(function() {
    'use strict';

    angular
        .module('mlcccApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

'use strict';

angular.module('mlcccApp')
    .service('UrlParams', function () {
        this.parseParam = function(params){
            var urlParamString = '';
            angular.forEach(params, function(paramInfo, urlParam){
                if(urlParamString == ''){
                    urlParamString = urlParamString+'?'+urlParam+'='+paramInfo;
                } else {
                    urlParamString = urlParamString+'&'+urlParam+'='+paramInfo;
                }
            });
            return urlParamString;
        };
    });

'use strict';

angular.module('mlcccApp')
    .service('Print', function () {
        this.print = function(title, content){
            var popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            popupWin.document.open();
            popupWin.document.write('<html> <head> <title>'+title+'</title> </head> <body onload="window.print();window.close()">'+content+'</body> </html>'
            );
            popupWin.document.close();
        };
    });

(function () {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('FileUpload', FileUpload);

    FileUpload.$inject = ['$resource'];

    function FileUpload ($resource, $window, $http) {
        var _params = {};
        var factory = {
            query: function () {
                return $resource('api/fileupload/', {}, {
                    query: {
                        method: 'GET',
                        isArray: true
                    }
                })
            },
            upload: function () {
                return $resource('api/fileupload', {}, {
                    'uploadFile': {
                        method: 'Post',
                        transformRequest: angular.identity,
                        params: _params,
                        headers: {'Content-type': undefined},
                        transformResponse: function (data) {
                            data = angular.fromJson(data);
                            return data;
                        }
                    }
                });
            },
            download: function () {
                return $resource('api/fileupload/:id', {}, {
                    'downloadFile': {
                        method: 'GET',
                        responseType: 'arraybuffer',
                        transformResponse: function (result) {
                            var file = new Blob([result], {type: 'application/pdf'});
                            var fileURL = window.URL.createObjectURL(file);
                            var fileObj = {file: fileURL};
                            return fileObj;
                        }
                    }
                });
            },

            setParameter: function (parameters) {
                _params = parameters;
            }
        };
        return {
            query: factory.query,
            upload: factory.upload,
            download: factory.download,
            setParameter: factory.setParameter
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('Email', Email);

    Email.$inject = ['$resource'];

    function Email ($resource) {
        var _params = {};
        var factory = {
            send: function () {
                return $resource('api/email', {}, {
                    'sendEmail': {
                        method: 'Post',
                        transformRequest: angular.identity,
                        params: _params,
                        headers: {'Content-type': undefined},
                        transformResponse: function (data) {
                            data = angular.fromJson(data);
                            return data;
                        }
                    }
                });
            },

            setParameter: function (parameters) {
                _params = parameters;
            }
        };
        return {
            send: factory.send,
            setParameter: factory.setParameter
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete': { method:'DELETE'},
            'search': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            hasNoAuthority: hasNoAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function hasNoAuthority (authority) {
            if (!_authenticated) {
                return $q.when(true);
            }

            return this.identity().then(function(_id) {
                return _id.authorities == undefined || _id.authorities.indexOf(authority) == -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('hasNoAuthority', hasNoAuthority);

    hasNoAuthority.$inject = ['Principal'];

    function hasNoAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasNoAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.showMyTeachers = true;

        Principal.hasAuthority('ROLE_ADMIN').then(function(response){
            if(response==true){
                vm.showMyTeachers=false;
            }
        });


        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'NewsLetter'];

    function HomeController ($scope, Principal, LoginService, $state, NewsLetter) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.newsletter_url = 'files/newsletter/newsletter.html';
        vm.changeNewsletter = changeNewsletter;
        vm.newsLetters = [];

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        getNewsletters();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
        function changeNewsletter(fileName){
            vm.newsletter_url = 'files/newsletter/'+fileName;
        }
        function getNewsletters(){
            NewsLetter.query(function(result) {
                vm.newsLetters = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserAgreementDialogController', UserAgreementDialogController);

    UserAgreementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'UserAgreement'];

    function UserAgreementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, UserAgreement) {
        var vm = this;

        vm.userAgreement = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.userAgreement.id !== null) {
                UserAgreement.update(vm.userAgreement, onSaveSuccess, onSaveError);
            } else {
                UserAgreement.save(vm.userAgreement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:userAgreementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserAgreementDetailController', UserAgreementDetailController);

    UserAgreementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'UserAgreement'];

    function UserAgreementDetailController($scope, $rootScope, $stateParams, previousState, entity, UserAgreement) {
        var vm = this;

        vm.userAgreement = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:userAgreementUpdate', function(event, result) {
            vm.userAgreement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserAgreementDeleteController',UserAgreementDeleteController);

    UserAgreementDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserAgreement'];

    function UserAgreementDeleteController($uibModalInstance, entity, UserAgreement) {
        var vm = this;

        vm.userAgreement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserAgreement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-agreement', {
            parent: 'entity',
            url: '/user-agreement',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'UserAgreements'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-agreement/user-agreements.html',
                    controller: 'UserAgreementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('user-agreement-detail', {
            parent: 'user-agreement',
            url: '/user-agreement/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'UserAgreement'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-agreement/user-agreement-detail.html',
                    controller: 'UserAgreementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'UserAgreement', function($stateParams, UserAgreement) {
                    return UserAgreement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'user-agreement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('user-agreement-detail.edit', {
            parent: 'user-agreement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-agreement/user-agreement-dialog.html',
                    controller: 'UserAgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserAgreement', function(UserAgreement) {
                            return UserAgreement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-agreement.new', {
            parent: 'user-agreement',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-agreement/user-agreement-dialog.html',
                    controller: 'UserAgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-agreement', null, { reload: 'user-agreement' });
                }, function() {
                    $state.go('user-agreement');
                });
            }]
        })
        .state('user-agreement.edit', {
            parent: 'user-agreement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-agreement/user-agreement-dialog.html',
                    controller: 'UserAgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserAgreement', function(UserAgreement) {
                            return UserAgreement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-agreement', null, { reload: 'user-agreement' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-agreement.delete', {
            parent: 'user-agreement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-agreement/user-agreement-delete-dialog.html',
                    controller: 'UserAgreementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserAgreement', function(UserAgreement) {
                            return UserAgreement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-agreement', null, { reload: 'user-agreement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('UserAgreement', UserAgreement);

    UserAgreement.$inject = ['$resource'];

    function UserAgreement ($resource) {
        var resourceUrl =  'api/user-agreements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserAgreementController', UserAgreementController);

    UserAgreementController.$inject = ['UserAgreement'];

    function UserAgreementController(UserAgreement) {

        var vm = this;

        vm.userAgreements = [];

        loadAll();

        function loadAll() {
            UserAgreement.query(function(result) {
                vm.userAgreements = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('TeacherDialogController', TeacherDialogController);

    TeacherDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Teacher', 'User'];

    function TeacherDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Teacher, User) {
        var vm = this;

        vm.searchUser = searchUser;
        vm.teacher = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.accounts = []
        vm.accounts.push(vm.teacher.account);

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.teacher.id !== null) {
                Teacher.update(vm.teacher, onSaveSuccess, onSaveError);
            } else {
                Teacher.save(vm.teacher, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:teacherUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.hireDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function searchUser(){
            User.search({search:vm.searchTerm}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.accounts = data;
                vm.teacher.account = data[0];
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('TeacherDetailController', TeacherDetailController);

    TeacherDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Teacher', 'MlcAccount'];

    function TeacherDetailController($scope, $rootScope, $stateParams, previousState, entity, Teacher, MlcAccount) {
        var vm = this;

        vm.teacher = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:teacherUpdate', function(event, result) {
            vm.teacher = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('TeacherDeleteController',TeacherDeleteController);

    TeacherDeleteController.$inject = ['$uibModalInstance', 'entity', 'Teacher'];

    function TeacherDeleteController($uibModalInstance, entity, Teacher) {
        var vm = this;

        vm.teacher = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Teacher.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('teacher', {
            parent: 'entity',
            url: '/teacher?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Teachers'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/teacher/teachers.html',
                    controller: 'TeacherController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                loginUser:['Principal', function(Principal){
                    return Principal.identity (false);
                }]
            }
        })
        .state('my-teacher', {
            parent: 'entity',
            url: '/my-teacher?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'My Teachers'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/teacher/my-teachers.html',
                    controller: 'MyTeacherController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                loginUser:['Principal', function(Principal){
                    return Principal.identity (false);
                }]
            }
        })
        .state('teacher-detail', {
            parent: 'teacher',
            url: '/teacher/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Teacher'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/teacher/teacher-detail.html',
                    controller: 'TeacherDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Teacher', function($stateParams, Teacher) {
                    return Teacher.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'teacher',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('teacher-detail.edit', {
            parent: 'teacher-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/teacher/teacher-dialog.html',
                    controller: 'TeacherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Teacher', function(Teacher) {
                            return Teacher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('teacher.new', {
            parent: 'teacher',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/teacher/teacher-dialog.html',
                    controller: 'TeacherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                hireDate: null,
                                payRate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('teacher', null, { reload: 'teacher' });
                }, function() {
                    $state.go('teacher');
                });
            }]
        })
        .state('teacher.edit', {
            parent: 'teacher',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/teacher/teacher-dialog.html',
                    controller: 'TeacherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Teacher', function(Teacher) {
                            return Teacher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('teacher', null, { reload: 'teacher' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('teacher.delete', {
            parent: 'teacher',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/teacher/teacher-delete-dialog.html',
                    controller: 'TeacherDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Teacher', function(Teacher) {
                            return Teacher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('teacher', null, { reload: 'teacher' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('teacher.email', {
            parent: 'teacher',
            url: '/{id}/email',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/email/email.html',
                    controller: 'EmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Teacher', function(Teacher) {
                            return Teacher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('teacher', null, { reload: 'teacher' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('teacher.allemail', {
            parent: 'teacher',
            url: '/email',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/email/email.html',
                    controller: 'EmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {to: 'All Teachers'}
                    }
                }).result.then(function() {
                    $state.go('teacher', null, { reload: 'teacher' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('Teacher', Teacher);

    Teacher.$inject = ['$resource', 'DateUtils'];

    function Teacher ($resource, DateUtils) {
        var resourceUrl =  'api/teachers/:id?searchTerm=:param';

        return $resource(resourceUrl, {param: '@param'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.hireDate = DateUtils.convertLocalDateFromServer(data.hireDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.hireDate = DateUtils.convertLocalDateToServer(copy.hireDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.hireDate = DateUtils.convertLocalDateToServer(copy.hireDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('TeacherController', TeacherController);

    TeacherController.$inject = ['$state', 'loginUser', 'Teacher', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TeacherController($state, loginUser, Teacher, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchTeacher = searchTeacher;

        loadAll();

        function loadAll () {
            Teacher.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.teachers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadAllWithoutPaging(){
            Teacher.query({
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function searchTeacher(){
            Teacher.query({param: vm.searchTerm}, {
                page: 0,
                size: vm.itemsPerPage,
                sort: 'firstName, asc'
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.teachers = data;
            vm.page = pagingParams.page;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MyTeacherController', MyTeacherController);

    MyTeacherController.$inject = ['$state', 'loginUser', 'Teacher', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MyTeacherController($state, loginUser, Teacher, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchTeacher = searchTeacher;

        loadAll();

        function loadAll () {
            Teacher.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.teachers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadAllWithoutPaging(){
            Teacher.query({
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function searchTeacher(){
            Teacher.query({param: vm.searchTerm}, {
                page: 0,
                size: vm.itemsPerPage,
                sort: 'firstName, asc'
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.teachers = data;
            vm.page = pagingParams.page;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('StudentInClassController', StudentInClassController);

    StudentInClassController.$inject = ['$state', 'loginUser', 'Student', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Registration', 'MlcClass', 'Print'];

    function StudentInClassController($state, loginUser, Student, ParseLinks, AlertService, paginationConstants, pagingParams, Registration, MlcClass, Print) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 30;
        vm.showRegistrations = true;
        vm.searchStudent = searchStudent;
        vm.account = loginUser;
        vm.mlcClasses = [];
        vm.print = print;
        vm.emailParents = email;
        loadAll();

        function loadAll () {
            Student.query( {
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                param: 'inClass'
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.students = data;
            vm.page = pagingParams.page;
            vm.students.forEach(function(student){
                student.registrations.forEach(function(registration){
                    if(registration.status == 'CONFIRMED' || registration.status == "PENDING" ){
                        var data = vm.mlcClasses.find( function( ele ) {
                            return ele.name === registration.mlcClassName;
                        } );
                        student.status = registration.status;
                        if(data == null){
                            var classItem = {
                                name: registration.mlcClassName,
                                students: []
                            }
                            classItem.students.push(student);
                            vm.mlcClasses.push(classItem);
                        } else {
                            data.students.push(student);
                        }
                    }
                });
            });
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
        function searchStudent(){
            Student.query({param: vm.searchTerm}, onSuccess, onError);
        }

        function print(className){
            var printContents = document.getElementById('print-section '+className).innerHTML;
            Print.print(className, printContents);
        }

        function email(className){
            var parents = []
            vm.mlcClasses.forEach(function(mlcClass) {
                if(mlcClass.name == className){
                    mlcClass.students.forEach(function(student){
                        student.associatedAccounts.forEach(function(account){
                            if(account.primaryContact && account.email){
                                parents.push(account.email);
                            }
                        });
                    });
                }
            })

            $state.params.to = 'principals@mlccc.org';
            $state.params.subject = className;
            $state.params.cc = vm.account.email;
            $state.params.bcc = parents;
            $state.go('student-in-class.email')
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('StudentDialogUserController', StudentDialogUserController);

    StudentDialogUserController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Student', 'User'];

    function StudentDialogUserController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Student, User) {
        var vm = this;

        vm.student = entity;
        vm.clear = clear;
        vm.save = save;
        vm.availableUsers = User.query();
        vm.deleteAssociatedAccount = deleteAssociatedAccount;
        vm.addAccountToStudent = addAccountToStudent;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.student.id !== null) {
                Student.update(vm.student, onSaveSuccess, onSaveError);
            } else {
                Student.save(vm.student, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:studentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function deleteAssociatedAccount (login){
            alert('delete association '+login);
        }

        function addAccountToStudent() {
            alert('addAccountToStudent ')
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('StudentDialogController', StudentDialogController);

    StudentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Student', 'User'];

    function StudentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Student, User) {
        var vm = this;

        vm.student = entity;
        vm.clear = clear;
        vm.save = save;
        vm.removeAssociatedAccount = removeAssociatedAccount;
        vm.showSearchField = showSearchField;
        vm.searchUser = searchUser;
        vm.addAccountToStudent = addAccountToStudent;
        vm.showSearch = false;
        vm.searchTerm = '';

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.student.id !== null) {
                Student.update(vm.student, onSaveSuccess, onSaveError);
            } else {
                Student.save(vm.student, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:studentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function showSearchField(id) {
            vm.showSearch = true;
        }

        function searchUser(){
            vm.availableUsers = User.search({search:vm.searchTerm});
        }

        function addAccountToStudent(user) {
            vm.student.associatedAccounts.push(angular.fromJson(angular.toJson(user)));
        }

        function removeAssociatedAccount (user){
            vm.student.associatedAccounts.splice(user);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('StudentDetailController', StudentDetailController);

    StudentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Student', 'MlcAccount'];

    function StudentDetailController($scope, $rootScope, $stateParams, previousState, entity, Student, MlcAccount) {
        var vm = this;

        vm.student = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:studentUpdate', function(event, result) {
            vm.student = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('StudentDeleteController',StudentDeleteController);

    StudentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Student'];

    function StudentDeleteController($uibModalInstance, entity, Student) {
        var vm = this;

        vm.student = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Student.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('student', {
            parent: 'entity',
            url: '/student?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Students'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/student/students.html',
                    controller: 'StudentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                loginUser:['Principal', function(Principal){
                    return Principal.identity (false);
                }]
            }
        })
        .state('student-in-class', {
            parent: 'entity',
            url: '/student-in-class?page&sort&search',
            data: {
                authorities: ['ROLE_TEACHER'],
                pageTitle: 'Students In My Class'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/student/students-in-class.html',
                    controller: 'StudentInClassController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                loginUser:['Principal', function(Principal){
                    return Principal.identity (false);
                }]
            }
        })
        .state('student-detail', {
            parent: 'student',
            url: '/student/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Student'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/student/student-detail.html',
                    controller: 'StudentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Student', function($stateParams, Student) {
                    return Student.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'student',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('student-detail.edit', {
            parent: 'student-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/student/student-dialog.html',
                    controller: 'StudentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Student', function(Student) {
                            return Student.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('student-detail.users', {
            parent: 'student-detail',
            url: '/detail/users',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/student/student-dialog-users.html',
                    controller: 'StudentDialogUserController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Student', function(Student) {
                            return Student.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('student.new', {
            parent: 'student',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/student/student-dialog.html',
                    controller: 'StudentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                gender: null,
                                birthMonth: null,
                                birthYear: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('student', null, { reload: 'student' });
                }, function() {
                    $state.go('student');
                });
            }]
        })
        .state('student.edit', {
            parent: 'student',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/student/student-dialog.html',
                    controller: 'StudentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Student', function(Student) {
                            return Student.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('student', null, { reload: 'student' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('student.delete', {
            parent: 'student',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/student/student-delete-dialog.html',
                    controller: 'StudentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Student', function(Student) {
                            return Student.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('student', null, { reload: 'student' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('student-in-class.email', {
            parent: 'student-in-class',
            url: '/email',
            data: {
                authorities: ['ROLE_TEACHER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/email/email.html',
                    controller: 'EmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {to: $state.params.to, subject: $state.params.subject, cc: $state.params.cc, bcc: $state.params.bcc}
                    }
                }).result.then(function() {
                    $state.go('student-in-class', null, { reload: 'student-in-class' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('Student', Student);

    Student.$inject = ['$resource'];

    function Student ($resource) {
        var resourceUrl =  'api/students/:id?searchTerm=:param';

        return $resource(resourceUrl, {param: '@param'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('StudentController', StudentController);

    StudentController.$inject = ['$state', 'loginUser', 'Student', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function StudentController($state, loginUser, Student, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.showRegistrations = true;
        vm.searchStudent = searchStudent;
        vm.searchTerm = pagingParams.search;

        if(loginUser.authorities && loginUser.authorities.indexOf('ROLE_ADMIN') !== -1){
            vm.showRegistrations = false;
        }

        loadAll();

        function loadAll () {
            Student.query( {
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                param: pagingParams.search
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.searchTerm
            });
        }
        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.students = data;
            vm.page = pagingParams.page;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
        function searchStudent(){
            Student.query({param: vm.searchTerm+'%'}, onSuccess, onError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SchoolTermDialogController', SchoolTermDialogController);

    SchoolTermDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SchoolTerm'];

    function SchoolTermDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SchoolTerm) {
        var vm = this;

        vm.schoolTerm = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.statusList = ["ACTIVE", "PENDING", "FINISHED"];
        vm.typeList = ["WEEKEND", "SUMMER CAMP"];

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.schoolTerm.id !== null) {
                SchoolTerm.update(vm.schoolTerm, onSaveSuccess, onSaveError);
            } else {
                SchoolTerm.save(vm.schoolTerm, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:schoolTermUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.promDate = false;
        vm.datePickerOpenStatus.earlyBirdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SchoolTermDetailController', SchoolTermDetailController);

    SchoolTermDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SchoolTerm'];

    function SchoolTermDetailController($scope, $rootScope, $stateParams, previousState, entity, SchoolTerm) {
        var vm = this;

        vm.schoolTerm = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:schoolTermUpdate', function(event, result) {
            vm.schoolTerm = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SchoolTermDeleteController',SchoolTermDeleteController);

    SchoolTermDeleteController.$inject = ['$uibModalInstance', 'entity', 'SchoolTerm'];

    function SchoolTermDeleteController($uibModalInstance, entity, SchoolTerm) {
        var vm = this;

        vm.schoolTerm = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SchoolTerm.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('school-term', {
            parent: 'entity',
            url: '/school-term',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SchoolTerms'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/school-term/school-terms.html',
                    controller: 'SchoolTermController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('school-term-detail', {
            parent: 'school-term',
            url: '/school-term/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SchoolTerm'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/school-term/school-term-detail.html',
                    controller: 'SchoolTermDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SchoolTerm', function($stateParams, SchoolTerm) {
                    return SchoolTerm.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'school-term',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('school-term-detail.edit', {
            parent: 'school-term-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/school-term/school-term-dialog.html',
                    controller: 'SchoolTermDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SchoolTerm', function(SchoolTerm) {
                            return SchoolTerm.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('school-term.new', {
            parent: 'school-term',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/school-term/school-term-dialog.html',
                    controller: 'SchoolTermDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                term: null,
                                status: null,
                                register: null,
                                promDate: null,
                                earlyBirdDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('school-term', null, { reload: 'school-term' });
                }, function() {
                    $state.go('school-term');
                });
            }]
        })
        .state('school-term.edit', {
            parent: 'school-term',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/school-term/school-term-dialog.html',
                    controller: 'SchoolTermDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SchoolTerm', function(SchoolTerm) {
                            return SchoolTerm.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('school-term', null, { reload: 'school-term' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('school-term.delete', {
            parent: 'school-term',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/school-term/school-term-delete-dialog.html',
                    controller: 'SchoolTermDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SchoolTerm', function(SchoolTerm) {
                            return SchoolTerm.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('school-term', null, { reload: 'school-term' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('SchoolTerm', SchoolTerm);

    SchoolTerm.$inject = ['$resource', 'DateUtils'];

    function SchoolTerm ($resource, DateUtils) {
        var resourceUrl =  'api/school-terms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.promDate = DateUtils.convertLocalDateFromServer(data.promDate);
                        data.earlyBirdDate = DateUtils.convertLocalDateFromServer(data.earlyBirdDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.promDate = DateUtils.convertLocalDateToServer(copy.promDate);
                    copy.earlyBirdDate = DateUtils.convertLocalDateToServer(copy.earlyBirdDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.promDate = DateUtils.convertLocalDateToServer(copy.promDate);
                    copy.earlyBirdDate = DateUtils.convertLocalDateToServer(copy.earlyBirdDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SchoolTermController', SchoolTermController);

    SchoolTermController.$inject = ['SchoolTerm'];

    function SchoolTermController(SchoolTerm) {

        var vm = this;
        vm.finish = finishSchoolTerm;
        vm.schoolTerms = [];
        vm.start = start;

        loadAll();

        function loadAll() {
            SchoolTerm.query(function(result) {
                vm.schoolTerms = result;
                vm.searchQuery = null;
            });
        }

        function finishSchoolTerm(data) {
            data.status = 'FINISHED';
            SchoolTerm.update(data, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:schooolTermUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function start(schoolTerm){
            schoolTerm.status = 'ACTIVE';
            SchoolTerm.update(schoolTerm, onSaveSuccess, onSaveError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SchoolDistrictDialogController', SchoolDistrictDialogController);

    SchoolDistrictDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SchoolDistrict'];

    function SchoolDistrictDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SchoolDistrict) {
        var vm = this;

        vm.schoolDistrict = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.schoolDistrict.id !== null) {
                SchoolDistrict.update(vm.schoolDistrict, onSaveSuccess, onSaveError);
            } else {
                SchoolDistrict.save(vm.schoolDistrict, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:schoolDistrictUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SchoolDistrictDetailController', SchoolDistrictDetailController);

    SchoolDistrictDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SchoolDistrict'];

    function SchoolDistrictDetailController($scope, $rootScope, $stateParams, previousState, entity, SchoolDistrict) {
        var vm = this;

        vm.schoolDistrict = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:schoolDistrictUpdate', function(event, result) {
            vm.schoolDistrict = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SchoolDistrictDeleteController',SchoolDistrictDeleteController);

    SchoolDistrictDeleteController.$inject = ['$uibModalInstance', 'entity', 'SchoolDistrict'];

    function SchoolDistrictDeleteController($uibModalInstance, entity, SchoolDistrict) {
        var vm = this;

        vm.schoolDistrict = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SchoolDistrict.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('school-district', {
            parent: 'entity',
            url: '/school-district',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SchoolDistricts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/school-district/school-districts.html',
                    controller: 'SchoolDistrictController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('school-district-detail', {
            parent: 'school-district',
            url: '/school-district/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SchoolDistrict'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/school-district/school-district-detail.html',
                    controller: 'SchoolDistrictDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SchoolDistrict', function($stateParams, SchoolDistrict) {
                    return SchoolDistrict.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'school-district',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('school-district-detail.edit', {
            parent: 'school-district-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/school-district/school-district-dialog.html',
                    controller: 'SchoolDistrictDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SchoolDistrict', function(SchoolDistrict) {
                            return SchoolDistrict.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('school-district.new', {
            parent: 'school-district',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/school-district/school-district-dialog.html',
                    controller: 'SchoolDistrictDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                county: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('school-district', null, { reload: 'school-district' });
                }, function() {
                    $state.go('school-district');
                });
            }]
        })
        .state('school-district.edit', {
            parent: 'school-district',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/school-district/school-district-dialog.html',
                    controller: 'SchoolDistrictDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SchoolDistrict', function(SchoolDistrict) {
                            return SchoolDistrict.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('school-district', null, { reload: 'school-district' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('school-district.delete', {
            parent: 'school-district',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/school-district/school-district-delete-dialog.html',
                    controller: 'SchoolDistrictDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SchoolDistrict', function(SchoolDistrict) {
                            return SchoolDistrict.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('school-district', null, { reload: 'school-district' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('SchoolDistrict', SchoolDistrict);

    SchoolDistrict.$inject = ['$resource'];

    function SchoolDistrict ($resource) {
        var resourceUrl =  'api/school-districts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SchoolDistrictController', SchoolDistrictController);

    SchoolDistrictController.$inject = ['SchoolDistrict'];

    function SchoolDistrictController(SchoolDistrict) {

        var vm = this;

        vm.schoolDistricts = [];

        loadAll();

        function loadAll() {
            SchoolDistrict.query(function(result) {
                vm.schoolDistricts = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegistrationStatusDialogController', RegistrationStatusDialogController);

    RegistrationStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RegistrationStatus'];

    function RegistrationStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RegistrationStatus) {
        var vm = this;

        vm.registrationStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.registrationStatus.id !== null) {
                RegistrationStatus.update(vm.registrationStatus, onSaveSuccess, onSaveError);
            } else {
                RegistrationStatus.save(vm.registrationStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:registrationStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegistrationStatusDetailController', RegistrationStatusDetailController);

    RegistrationStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RegistrationStatus'];

    function RegistrationStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, RegistrationStatus) {
        var vm = this;

        vm.registrationStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:registrationStatusUpdate', function(event, result) {
            vm.registrationStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegistrationStatusDeleteController',RegistrationStatusDeleteController);

    RegistrationStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'RegistrationStatus'];

    function RegistrationStatusDeleteController($uibModalInstance, entity, RegistrationStatus) {
        var vm = this;

        vm.registrationStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RegistrationStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('registration-status', {
            parent: 'entity',
            url: '/registration-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RegistrationStatuses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registration-status/registration-statuses.html',
                    controller: 'RegistrationStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('registration-status-detail', {
            parent: 'registration-status',
            url: '/registration-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RegistrationStatus'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registration-status/registration-status-detail.html',
                    controller: 'RegistrationStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RegistrationStatus', function($stateParams, RegistrationStatus) {
                    return RegistrationStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'registration-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('registration-status-detail.edit', {
            parent: 'registration-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration-status/registration-status-dialog.html',
                    controller: 'RegistrationStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RegistrationStatus', function(RegistrationStatus) {
                            return RegistrationStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('registration-status.new', {
            parent: 'registration-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration-status/registration-status-dialog.html',
                    controller: 'RegistrationStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registration-status', null, { reload: 'registration-status' });
                }, function() {
                    $state.go('registration-status');
                });
            }]
        })
        .state('registration-status.edit', {
            parent: 'registration-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration-status/registration-status-dialog.html',
                    controller: 'RegistrationStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RegistrationStatus', function(RegistrationStatus) {
                            return RegistrationStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registration-status', null, { reload: 'registration-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('registration-status.delete', {
            parent: 'registration-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration-status/registration-status-delete-dialog.html',
                    controller: 'RegistrationStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RegistrationStatus', function(RegistrationStatus) {
                            return RegistrationStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registration-status', null, { reload: 'registration-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('RegistrationStatus', RegistrationStatus);

    RegistrationStatus.$inject = ['$resource'];

    function RegistrationStatus ($resource) {
        var resourceUrl =  'api/registration-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegistrationStatusController', RegistrationStatusController);

    RegistrationStatusController.$inject = ['RegistrationStatus'];

    function RegistrationStatusController(RegistrationStatus) {

        var vm = this;

        vm.registrationStatuses = [];

        loadAll();

        function loadAll() {
            RegistrationStatus.query(function(result) {
                vm.registrationStatuses = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegistrationDialogController', RegistrationDialogController);

    RegistrationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Registration', 'Student', 'MlcClass', 'RegistrationStatus', 'MlcClassCategory', 'SchoolTerm'];

    function RegistrationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Registration, Student, MlcClass, RegistrationStatus, MlcClassCategory, SchoolTerm) {
        var vm = this;

        vm.registration = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.searchStudent = searchStudent;
        vm.searchClasses = searchClasses;
        vm.checked = false;
        vm.select = select;
        vm.schoolTerm;
        vm.mlcClassCategories=[];

        SchoolTerm.query({}, function(data){
            data.forEach(function(schoolTerm){
                if(schoolTerm.status != 'FINISHED') {
                    vm.schoolTerm = schoolTerm;
                }
            });
        })

        if($stateParams.studentId){
            vm.students = [Student.get({id : $stateParams.studentId})];
            vm.registration.student = vm.students[0];
        } else {
            vm.students = Student.query({}, function(data){
                vm.registration.student = data[0];
            });
        }
        if($stateParams.classId){
            MlcClass.get({id : $stateParams.classId}, onGetClass);
        } else {
            MlcClassCategory.query({}, onSuccess);
        }

        function onGetClass(data){
            vm.mlcclasses = [];
            vm.mlcClassCategories = [];
            vm.mlcclasses.push(data);
            vm.registration.mlcClass = vm.mlcclasses[0];
            vm.mlcClassCategories.push(vm.registration.mlcClass.mlcClassCategory);
            vm.mlcClassCategory = vm.mlcClassCategories[0];
        }

        function onSuccess(data) {
            if(vm.schoolTerm != null && vm.schoolTerm.type == 'SUMMER CAMP'){
                data.forEach(function(cat){
                    if(cat.type == 'SUMMER CAMP') {
                        vm.mlcClassCategories.push(cat);
                    }
                });
            } else {
                data.forEach(function(cat){
                    if(cat.type != 'SUMMER CAMP') {
                        vm.mlcClassCategories.push(cat);
                    }
                });
            }
            if(vm.mlcClassCategory == null){
                vm.mlcClassCategory = vm.mlcClassCategories[0];
            }
            vm.mlcclasses = MlcClass.query({category: vm.mlcClassCategory.id, newRegistration: true, size: 50, sort: 'className'}, function(data){
                vm.registration.mlcClass = data[0];
            });
        }

        vm.registrationstatuses = RegistrationStatus.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if(vm.registration.student == null){
                vm.registration.student = vm.students[0];
            }
            if (vm.registration.id !== null) {
                Registration.update(vm.registration, onSaveSuccess, onSaveError);
            } else {
                Registration.save(vm.registration, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:registrationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.modifyDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function searchClasses (){
            vm.mlcclasses = MlcClass.search({category: vm.mlcClassCategory.id, newRegistration: true, size:50, sort: 'className'}, function(data){
                vm.registration.mlcClass = data[0];
            });
        }

        function searchStudent (){
            vm.students = Student.query({param: vm.searchTerm,
                page: 0,
                size: 50,
                sort: 'firstName'
            }, function(data){
                vm.students = data;
                vm.registration.student = data[0];
            });
        }

        function select(){
            vm.checked = !vm.checked;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegistrationDetailController', RegistrationDetailController);

    RegistrationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Registration', 'Student', 'MlcClass', 'RegistrationStatus'];

    function RegistrationDetailController($scope, $rootScope, $stateParams, previousState, entity, Registration, Student, MlcClass, RegistrationStatus) {
        var vm = this;

        vm.registration = entity;
        vm.previousState = previousState.name;

        if (vm.registration.mlcClass.classRoom && vm.registration.mlcClass.classRoom.roomNumber < 100){  // online classes
            vm.registration.mlcClass.classRoom.roomNumber = vm.registration.mlcClass.classRoom.description;
        }

        var unsubscribe = $rootScope.$on('mlcccApp:registrationUpdate', function(event, result) {
            vm.registration = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegistrationDeleteController',RegistrationDeleteController);

    RegistrationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Registration'];

    function RegistrationDeleteController($uibModalInstance, entity, Registration) {
        var vm = this;

        vm.registration = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Registration.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('registration', {
            parent: 'entity',
            url: '/registration?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Registrations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registration/registrations.html',
                    controller: 'RegistrationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                schoolTerm: null,
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        schoolTerm: $stateParams.schoolTerm
                    };
                }],
                loginUser:['Principal', function(Principal){
                    return Principal.identity (false);
                }]
            }
        })
        .state('registration-detail', {
            parent: 'registration',
            url: '/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registration/registration-detail.html',
                    controller: 'RegistrationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Registration', function($stateParams, Registration) {
                    return Registration.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'registration',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('registration-detail.edit', {
            parent: 'registration-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('registration.new', {
            parent: 'registration',
            url: '/new/',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createDate: null,
                                modifyDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registration', null, { reload: 'registration' });
                }, function() {
                    $state.go('registration');
                });
            }]
        })
        .state('registration.new.student', {
            parent: 'registration',
            url: '/{studentId}/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createDate: null,
                                modifyDate: null,
                                id: null
                            };
                        },
                        studentId: function(){
                            return $stateParams.studentId;
                        }
                    }
                }).result.then(function() {
                    $state.go('student', null, { reload: 'student' });
                }, function() {
                    $state.go('student');
                });
            }]
        })
        .state('registration.new.class', {
            parent: 'registration',
            url: '/new/{classId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createDate: null,
                                modifyDate: null,
                                id: null
                            };
                        },
                        classId: function(){
                            return $stateParams.classId;
                        }
                    }
                }).result.then(function() {
                    $state.go('registration', null, { reload: 'registration' });
                }, function() {
                    $state.go('registration');
                });
            }]
        })
        .state('registration.edit', {
            parent: 'registration',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registration', null, { reload: 'registration' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('registration.delete', {
            parent: 'registration',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-delete-dialog.html',
                    controller: 'RegistrationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registration', null, { reload: 'registration' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
            /*
        .state('registration.withdraw', {
            parent: 'registration-detail',
            url: '/withdraw',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-withdraw-dialog.html',
                    controller: 'RegistrationWithdrawController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registration', null, { reload: 'registration' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/;
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('Registration', Registration);

    Registration.$inject = ['$resource', 'DateUtils'];

    function Registration ($resource, DateUtils) {
        var resourceUrl =  'api/:schoolTermId/registrations/:id?searchTerm=:param';

        return $resource(resourceUrl, {param: '@param'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertLocalDateFromServer(data.createDate);
                        data.modifyDate = DateUtils.convertLocalDateFromServer(data.modifyDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createDate = DateUtils.convertLocalDateToServer(copy.createDate);
                    copy.modifyDate = DateUtils.convertLocalDateToServer(copy.modifyDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createDate = DateUtils.convertLocalDateToServer(copy.createDate);
                    copy.modifyDate = DateUtils.convertLocalDateToServer(copy.modifyDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegistrationController', RegistrationController);

    RegistrationController.$inject = ['$state', 'loginUser', 'Registration', 'SchoolTerm','ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function RegistrationController($state, loginUser, Registration, SchoolTerm, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.confirm = confirm;
        vm.searchRegistration = searchRegistration;
        vm.schoolTerms = loadSchoolTerms;
        vm.loadAll = loadAll;
        vm.schoolTerm = pagingParams.schoolTerm;
        vm.showClassRoom = !loginUser.authorities.includes('ROLE_ADMIN');

        loadSchoolTerms();

        function loadAll (schoolTermId) {
            Registration.query({
                schoolTermId: schoolTermId,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.registrations = data;
            vm.page = pagingParams.page;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                schoolTerm: vm.schoolTerm,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });

        }

        function confirm(data){
            data.status = 'CONFIRMED';
            Registration.update(data, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:registrationUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function searchRegistration(searchTerm){
            if(vm.schoolTerm != null){
                Registration.query({
                    schoolTermId: vm.schoolTerm.id,
                    param: 'registrationsForStudent:' + vm.searchTerm
                }, onSuccess, onError);
            } else {
                Registration.query({
                    param: 'registrationsForStudent:' + vm.searchTerm
                }, onSuccess, onError);
            }
        }

        function loadSchoolTerms () {
            SchoolTerm.query(function(result) {
                vm.schoolTerms = result;
                vm.searchQuery = null;
                //vm.schoolTerm = vm.schoolTerms[0];
                if(vm.schoolTerm){
                    loadAll(vm.schoolTerm.id);
                } else {
                    loadAll();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PhoneTypeDialogController', PhoneTypeDialogController);

    PhoneTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneType'];

    function PhoneTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneType) {
        var vm = this;

        vm.phoneType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneType.id !== null) {
                PhoneType.update(vm.phoneType, onSaveSuccess, onSaveError);
            } else {
                PhoneType.save(vm.phoneType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:phoneTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PhoneTypeDetailController', PhoneTypeDetailController);

    PhoneTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneType'];

    function PhoneTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneType) {
        var vm = this;

        vm.phoneType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:phoneTypeUpdate', function(event, result) {
            vm.phoneType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PhoneTypeDeleteController',PhoneTypeDeleteController);

    PhoneTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneType'];

    function PhoneTypeDeleteController($uibModalInstance, entity, PhoneType) {
        var vm = this;

        vm.phoneType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-type', {
            parent: 'entity',
            url: '/phone-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PhoneTypes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-type/phone-types.html',
                    controller: 'PhoneTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('phone-type-detail', {
            parent: 'phone-type',
            url: '/phone-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PhoneType'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-type/phone-type-detail.html',
                    controller: 'PhoneTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PhoneType', function($stateParams, PhoneType) {
                    return PhoneType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-type-detail.edit', {
            parent: 'phone-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-dialog.html',
                    controller: 'PhoneTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneType', function(PhoneType) {
                            return PhoneType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-type.new', {
            parent: 'phone-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-dialog.html',
                    controller: 'PhoneTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                phoneType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-type', null, { reload: 'phone-type' });
                }, function() {
                    $state.go('phone-type');
                });
            }]
        })
        .state('phone-type.edit', {
            parent: 'phone-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-dialog.html',
                    controller: 'PhoneTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneType', function(PhoneType) {
                            return PhoneType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-type', null, { reload: 'phone-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-type.delete', {
            parent: 'phone-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-delete-dialog.html',
                    controller: 'PhoneTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneType', function(PhoneType) {
                            return PhoneType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-type', null, { reload: 'phone-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('PhoneType', PhoneType);

    PhoneType.$inject = ['$resource'];

    function PhoneType ($resource) {
        var resourceUrl =  'api/phone-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PhoneTypeController', PhoneTypeController);

    PhoneTypeController.$inject = ['PhoneType'];

    function PhoneTypeController(PhoneType) {

        var vm = this;

        vm.phoneTypes = [];

        loadAll();

        function loadAll() {
            PhoneType.query(function(result) {
                vm.phoneTypes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PaymentRefundController', PaymentRefundController);

    PaymentRefundController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Payment', 'MlcAccount', 'Invoice'];

    function PaymentRefundController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Payment, MlcAccount, Invoice) {
        var vm = this;
        vm.payment = { id: null, amount: null, type: null, status: null};
        vm.invoice = entity;
        vm.creditCardPayment = {
            paymentAmount : null,
            cardNumber : null,
            expirationDate: null,
            cardCode: null,
            email: null
        };
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.payment.invoiceDto = vm.invoice;
            vm.payment.account = vm.invoice.billToUser;
            vm.payment.status = 'REFUND';
            vm.payment.amount = 0-vm.invoice.refund;
            Payment.save(vm.payment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PaymentNewController', PaymentNewController);

    PaymentNewController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Payment', 'MlcAccount', 'Invoice'];

    function PaymentNewController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Payment, MlcAccount, Invoice) {
        var vm = this;
        vm.payment = { id: null, amount: null, type: null, status: null};
        vm.invoice = entity;
        vm.creditCardPayment = {
            paymentAmount : null,
            cardNumber : null,
            expirationDate: null,
            cardCode: null,
            email: null
        };
        vm.paidAmount = 0.00;
        vm.paymentAmount = 0.00;

        vm.getPaymentMethod = getPaymentMethod;
        vm.clear = clear;
        vm.save = save;

        Payment.query({invoiceId: vm.invoice.id}, function(data){
            data.forEach(function(payment){
                vm.paidAmount += payment.amount;
            })
            vm.paymentAmount = (vm.invoice.total - vm.paidAmount).toFixed(2);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.payment.invoiceDto = vm.invoice;
            vm.payment.account = vm.invoice.billToUser;
            vm.payment.status = 'PAID';
            vm.payment.amount = vm.paymentAmount;
            if(vm.payment.type == 'Credit Card'){
                vm.payment.creditCard = vm.creditCardPayment;
            }
            Payment.save(vm.payment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function  getPaymentMethod() {
            if (vm.payment.type == 'Credit Card'){
                vm.creditCardPayment.paymentAmount = vm.paymentAmount;
                vm.creditCardPayment.email = vm.invoice.billToUser.email;
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PaymentDialogController', PaymentDialogController);

    PaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Payment', 'MlcAccount', 'Invoice'];

    function PaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Payment, MlcAccount, Invoice) {
        var vm = this;

        vm.payment = entity;
        vm.clear = clear;
        vm.save = save;

        vm.invoice = Invoice.get({id : $stateParams.invoiceId}).$promise;
        vm.account

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.payment.id !== null) {
                Payment.update(vm.payment, onSaveSuccess, onSaveError);
            } else {
                Payment.save(vm.payment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PaymentDetailController', PaymentDetailController);

    PaymentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Payment', 'MlcAccount', 'Registration'];

    function PaymentDetailController($scope, $rootScope, $stateParams, previousState, entity, Payment, MlcAccount, Registration) {
        var vm = this;

        vm.payment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:paymentUpdate', function(event, result) {
            vm.payment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PaymentDeleteController',PaymentDeleteController);

    PaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Payment'];

    function PaymentDeleteController($uibModalInstance, entity, Payment) {
        var vm = this;

        vm.payment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Payment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('payment', {
            parent: 'entity',
            url: '/payment',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Payments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/payment/payments.html',
                    controller: 'PaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                schoolTerm: null,
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        schoolTerm: $stateParams.schoolTerm
                    };
                }]
            }
        })
        .state('payment-detail', {
            parent: 'payment',
            url: '/payment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Payment'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/payment/payment-detail.html',
                    controller: 'PaymentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Payment', function($stateParams, Payment) {
                    return Payment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('payment-detail.edit', {
            parent: 'payment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment/payment-dialog.html',
                    controller: 'PaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Payment', function(Payment) {
                            return Payment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('payment.new', {
            parent: 'payment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            params: {
                invoiceId: null
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment/payment-new.html',
                    controller: 'PaymentNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.invoiceId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment', null, { reload: 'payment' });
                }, function() {
                    $state.go('payment');
                });
            }]
        })
        .state('payment.edit', {
            parent: 'payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment/payment-dialog.html',
                    controller: 'PaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Payment', function(Payment) {
                            return Payment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment', null, { reload: 'payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('payment.delete', {
            parent: 'payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment/payment-delete-dialog.html',
                    controller: 'PaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Payment', function(Payment) {
                            return Payment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment', null, { reload: 'payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('payment.refund', {
            parent: 'payment',
            url: '/refund',
            data: {
                authorities: ['ROLE_USER']
            },
            params: {
                invoiceId: null
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment/payment-refund.html',
                    controller: 'PaymentRefundController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.invoiceId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment', null, { reload: 'payment' });
                }, function() {
                    $state.go('payment');
                });
            }]
        })
        .state('payment.invoice', {
            parent: 'entity',
            url: '/payment/invoice/{invoiceId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Payments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/payment/payments.html',
                    controller: 'PaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                }
            },
            invoiceId: 0,
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('Payment', Payment);

    Payment.$inject = ['$resource'];

    function Payment ($resource) {
        var resourceUrl =  'api/:schoolTermId/payments/:id?searchTerm=:param&invoiceId=:invoiceId';

        return $resource(resourceUrl, {param: '@param', invoiceId: '@invoiceId'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PaymentController', PaymentController);

    PaymentController.$inject = ['Payment', 'SchoolTerm', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function PaymentController(Payment, SchoolTerm, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {

        var vm = this;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.payments = [];
        vm.searchPayment = searchPayment;
        vm.schoolTerm = pagingParams.schoolTerm;

        vm.loadAll = loadAll;

        if($state.params.invoiceId){
            getPaymentsByInvoiceId($state.params.invoiceId);
        } else {
            loadSchoolTerms();
        }

        function loadAll(schoolTermId) {
            Payment.query({
                schoolTermId: schoolTermId,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: 'id,desc'
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.payments = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition() {
            $state.transitionTo($state.$current, {
                schoolTerm: vm.schoolTerm,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function searchPayment(searchTerm){
            Payment.query({param: vm.searchTerm}, onSuccess);
        }

        function getPaymentsByInvoiceId(invoiceId){
            Payment.query({invoiceId: invoiceId}, onSuccess);
        }

        function loadSchoolTerms () {
            SchoolTerm.query(function(result) {
                vm.schoolTerms = result;
                vm.searchQuery = null;
                if(vm.schoolTerm) {
                    loadAll(vm.schoolTerm.id);
                } else {
                    loadAll();
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('CCPayment', CCPayment);

    CCPayment.$inject = ['$http'];

    function CCPayment ($http) {
        return  {
            getToken: function() {
                return $http.get('api/payments/token');
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('NewsLetterDialogController', NewsLetterDialogController);

    NewsLetterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NewsLetter'];

    function NewsLetterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NewsLetter) {
        var vm = this;

        vm.newsLetter = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.newsLetter.id !== null) {
                NewsLetter.update(vm.newsLetter, onSaveSuccess, onSaveError);
            } else {
                NewsLetter.save(vm.newsLetter, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:newsLetterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.uploadDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('NewsLetterDetailController', NewsLetterDetailController);

    NewsLetterDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'NewsLetter'];

    function NewsLetterDetailController($scope, $rootScope, $stateParams, previousState, entity, NewsLetter) {
        var vm = this;

        vm.newsLetter = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:newsLetterUpdate', function(event, result) {
            vm.newsLetter = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('NewsLetterDeleteController',NewsLetterDeleteController);

    NewsLetterDeleteController.$inject = ['$uibModalInstance', 'entity', 'NewsLetter'];

    function NewsLetterDeleteController($uibModalInstance, entity, NewsLetter) {
        var vm = this;

        vm.newsLetter = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NewsLetter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('news-letter', {
            parent: 'entity',
            url: '/news-letter',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'NewsLetters'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/news-letter/news-letters.html',
                    controller: 'NewsLetterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('news-letter-detail', {
            parent: 'news-letter',
            url: '/news-letter/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'NewsLetter'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/news-letter/news-letter-detail.html',
                    controller: 'NewsLetterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'NewsLetter', function($stateParams, NewsLetter) {
                    return NewsLetter.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'news-letter',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('news-letter-detail.edit', {
            parent: 'news-letter-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news-letter/news-letter-dialog.html',
                    controller: 'NewsLetterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NewsLetter', function(NewsLetter) {
                            return NewsLetter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('news-letter.new', {
            parent: 'news-letter',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news-letter/news-letter-dialog.html',
                    controller: 'NewsLetterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                fileName: null,
                                uploadDate: null,
                                uploadedBy: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('news-letter', null, { reload: 'news-letter' });
                }, function() {
                    $state.go('news-letter');
                });
            }]
        })
        .state('news-letter.edit', {
            parent: 'news-letter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news-letter/news-letter-dialog.html',
                    controller: 'NewsLetterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NewsLetter', function(NewsLetter) {
                            return NewsLetter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('news-letter', null, { reload: 'news-letter' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('news-letter.delete', {
            parent: 'news-letter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news-letter/news-letter-delete-dialog.html',
                    controller: 'NewsLetterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NewsLetter', function(NewsLetter) {
                            return NewsLetter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('news-letter', null, { reload: 'news-letter' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('NewsLetter', NewsLetter);

    NewsLetter.$inject = ['$resource', 'DateUtils'];

    function NewsLetter ($resource, DateUtils) {
        var resourceUrl =  'api/news-letters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.uploadDate = DateUtils.convertLocalDateFromServer(data.uploadDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.uploadDate = DateUtils.convertLocalDateToServer(copy.uploadDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.uploadDate = DateUtils.convertLocalDateToServer(copy.uploadDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('NewsLetterController', NewsLetterController);

    NewsLetterController.$inject = ['$scope', '$rootScope', '$stateParams', 'FileUpload','NewsLetter'];

    function NewsLetterController($scope, $rootScope, $stateParams, FileUpload, NewsLetter) {

        var vm = this;

        vm.newsLetters = [];
        vm.uploadedFile = null;
        vm.fileSelected = false;
        vm.cancel = cancel;
        vm.selectFile = selectFile;
        vm.uploadFile = uploadFile;

        function isFileSelected() {
            if(vm.uploadedFile){
                return true;
            } else {
                return false;
            }
        };

        function selectFile() {
            vm.fileSelected = true;
            $scope.$apply();
        };

        loadAll();

        function loadAll() {
            NewsLetter.query(function(result) {
                vm.newsLetters = result;
                vm.searchQuery = null;
            });
        };

        function cancel() {
            vm.fileSelected = false;
            vm.uploadedFile = null;
        };

        function uploadFile() {
            var file = vm.uploadedFile;
            var fd = new FormData();
            fd.append('file', file);
            var params = {
                type: 'NewsLetter'
            };
            FileUpload.setParameter(params);
            FileUpload.upload().uploadFile(fd, onUploadFinished);
        };

        function onUploadFinished(){
            console.log("upload finished");
            vm.fileSelected = false;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassCategoryDialogController', MlcClassCategoryDialogController);

    MlcClassCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MlcClassCategory', 'MlcClass'];

    function MlcClassCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MlcClassCategory, MlcClass) {
        var vm = this;

        vm.mlcClassCategory = entity;
        vm.clear = clear;
        vm.save = save;
        vm.mlcclasses = MlcClass.query();
        vm.typeList = ["WEEKEND", "SUMMER CAMP"];

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.mlcClassCategory.id !== null) {
                MlcClassCategory.update(vm.mlcClassCategory, onSaveSuccess, onSaveError);
            } else {
                MlcClassCategory.save(vm.mlcClassCategory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:mlcClassCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassCategoryDetailController', MlcClassCategoryDetailController);

    MlcClassCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MlcClassCategory', 'MlcClass'];

    function MlcClassCategoryDetailController($scope, $rootScope, $stateParams, previousState, entity, MlcClassCategory, MlcClass) {
        var vm = this;

        vm.mlcClassCategory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:mlcClassCategoryUpdate', function(event, result) {
            vm.mlcClassCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassCategoryDeleteController',MlcClassCategoryDeleteController);

    MlcClassCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'MlcClassCategory'];

    function MlcClassCategoryDeleteController($uibModalInstance, entity, MlcClassCategory) {
        var vm = this;

        vm.mlcClassCategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MlcClassCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('mlc-class-category', {
            parent: 'entity',
            url: '/mlc-class-category',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mlcccApp.mlcClassCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mlc-class-category/mlc-class-categories.html',
                    controller: 'MlcClassCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('mlc-class-category-detail', {
            parent: 'mlc-class-category',
            url: '/mlc-class-category/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'MlcClassCategory'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mlc-class-category/mlc-class-category-detail.html',
                    controller: 'MlcClassCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MlcClassCategory', function($stateParams, MlcClassCategory) {
                    return MlcClassCategory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'mlc-class-category',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('mlc-class-category-detail.edit', {
            parent: 'mlc-class-category-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-class-category/mlc-class-category-dialog.html',
                    controller: 'MlcClassCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MlcClassCategory', function(MlcClassCategory) {
                            return MlcClassCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mlc-class-category.new', {
            parent: 'mlc-class-category',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-class-category/mlc-class-category-dialog.html',
                    controller: 'MlcClassCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('mlc-class-category', null, { reload: 'mlc-class-category' });
                }, function() {
                    $state.go('mlc-class-category');
                });
            }]
        })
        .state('mlc-class-category.edit', {
            parent: 'mlc-class-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-class-category/mlc-class-category-dialog.html',
                    controller: 'MlcClassCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MlcClassCategory', function(MlcClassCategory) {
                            return MlcClassCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mlc-class-category', null, { reload: 'mlc-class-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mlc-class-category.delete', {
            parent: 'mlc-class-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-class-category/mlc-class-category-delete-dialog.html',
                    controller: 'MlcClassCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MlcClassCategory', function(MlcClassCategory) {
                            return MlcClassCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mlc-class-category', null, { reload: 'mlc-class-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('MlcClassCategory', MlcClassCategory);

    MlcClassCategory.$inject = ['$resource'];

    function MlcClassCategory ($resource) {
        var resourceUrl =  'api/mlc-class-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassCategoryController', MlcClassCategoryController);

    MlcClassCategoryController.$inject = ['MlcClassCategory'];

    function MlcClassCategoryController(MlcClassCategory) {

        var vm = this;

        vm.mlcClassCategories = [];

        loadAll();

        function loadAll() {
            MlcClassCategory.query(function(result) {
                vm.mlcClassCategories = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MyMlcClassController', MyMlcClassController);

    MyMlcClassController.$inject = ['$state', 'loginUser', 'MlcClass', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MyMlcClassController($state, loginUser, MlcClass, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.account = loginUser;
        
        loadAll();

        function loadAll () {
            MlcClass.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                teacher: vm.account.id,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.mlcClasses = data;
            vm.page = pagingParams.page;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassRegistrationsController', MlcClassRegistrationsController);

    MlcClassRegistrationsController.$inject = ['$state','$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Registration', 'Print'];

    function MlcClassRegistrationsController ($state, $timeout, $scope, $stateParams, $uibModalInstance, entity, Registration, Print) {
        var vm = this;

        vm.registrations = entity;
        vm.clear = clear;
        vm.print = print;
        vm.emailParents = email;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function print(className){
            var printContents = document.getElementById('print-section '+className).innerHTML;
            Print.print(className, printContents);
        }

        function email(className){
            var parents = [];
            vm.registrations.forEach(function(registration){
                parents.push(registration.invoice.user.email);
            });

            /*
            vm.registrations.forEach(function(registration) {
                if(mlcClass.name == className){
                    mlcClass.students.forEach(function(student){
                        student.associatedAccounts.forEach(function(account){
                            if(account.primaryContact && account.email){
                                parents.push(account.email);
                            }
                        });
                    });
                }
            })
            */
            $state.params.to = 'principals@mlccc.org';
            $state.params.subject = "MLCCC Admin on behalf of " + className;
            //$state.params.cc = vm.account.email;
            $state.params.bcc = parents;
            $state.go('mlc-class.registrations.email')
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassDialogController', MlcClassDialogController);

    MlcClassDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MlcClass', 'ClassStatus', 'ClassTime', 'Teacher', 'ClassRoom', 'SchoolTerm', 'MlcClassCategory'];

    function MlcClassDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MlcClass, ClassStatus, ClassTime, Teacher, ClassRoom, SchoolTerm, MlcClassCategory) {
        var vm = this;

        vm.mlcClass = entity;
        vm.clear = clear;
        vm.save = save;
        vm.classstatuses = ClassStatus.query();
        vm.classtimes = ClassTime.query();
        vm.teachers = Teacher.query({
            page: 0,
            size: 1000,
            sort: 'lastName'
        });
        vm.classrooms = ClassRoom.query();
        vm.schoolterms = SchoolTerm.query();
        vm.categories = MlcClassCategory.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.mlcClass.id !== null) {
                MlcClass.update(vm.mlcClass, onSaveSuccess, onSaveError);
            } else {
                MlcClass.save(vm.mlcClass, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:mlcClassUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassDetailController', MlcClassDetailController);

    MlcClassDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'loginUser', 'MlcClass', 'ClassStatus', 'ClassTime', 'Teacher', 'ClassRoom', 'SchoolTerm'];

    function MlcClassDetailController($scope, $rootScope, $stateParams, previousState, entity, loginUser, MlcClass, ClassStatus, ClassTime, Teacher, ClassRoom, SchoolTerm) {
        var vm = this;

        vm.mlcClass = entity;
        vm.previousState = previousState.name;
        vm.isAdmin = loginUser.authorities.includes('ROLE_ADMIN');

        if (vm.mlcClass.classRoom && vm.mlcClass.classRoom.roomNumber < 100){  // online classes
            if(vm.isAdmin){
                vm.mlcClass.classRoom.roomNumber = vm.mlcClass.classRoom.description;
            } else {
                vm.mlcClass.classRoom.roomNumber = 'Online';
            }
        }

        var unsubscribe = $rootScope.$on('mlcccApp:mlcClassUpdate', function(event, result) {
            vm.mlcClass = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassDeleteController',MlcClassDeleteController);

    MlcClassDeleteController.$inject = ['$uibModalInstance', 'entity', 'MlcClass'];

    function MlcClassDeleteController($uibModalInstance, entity, MlcClass) {
        var vm = this;

        vm.mlcClass = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MlcClass.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('mlc-class', {
            parent: 'entity',
            url: '/mlc-class?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Classes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mlc-class/mlc-classes.html',
                    controller: 'MlcClassController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'className,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],

                loginUser:['Principal', function(Principal){
                    return Principal.identity (false);
                }]
            }
        })
        .state('my-mlc-class', {
            parent: 'entity',
            url: '/my-class?page&sort&search',
            data: {
                authorities: ['ROLE_TEACHER'],
                pageTitle: 'MyClasses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mlc-class/my-mlc-classes.html',
                    controller: 'MyMlcClassController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                loginUser:['Principal', function(Principal){
                    return Principal.identity (false);
                }]
            }
        })
        .state('mlc-class-detail', {
            parent: 'mlc-class',
            url: '/mlc-class/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Class'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mlc-class/mlc-class-detail.html',
                    controller: 'MlcClassDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MlcClass', function($stateParams, MlcClass) {
                    return MlcClass.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'mlc-class',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('mlc-class-detail.edit', {
            parent: 'mlc-class-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-class/mlc-class-dialog.html',
                    controller: 'MlcClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MlcClass', function(MlcClass) {
                            return MlcClass.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mlc-class.new', {
            parent: 'mlc-class',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-class/mlc-class-dialog.html',
                    controller: 'MlcClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                className: null,
                                textBook: null,
                                size: null,
                                minAge: null,
                                tuition: null,
                                registrationFee: null,
                                seqNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('mlc-class', null, { reload: 'mlc-class' });
                }, function() {
                    $state.go('mlc-class');
                });
            }]
        })
        .state('mlc-class.edit', {
            parent: 'mlc-class',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-class/mlc-class-dialog.html',
                    controller: 'MlcClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MlcClass', function(MlcClass) {
                            return MlcClass.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mlc-class', null, { reload: 'mlc-class' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mlc-class.registrations', {
            parent: 'mlc-class',
            url: '/{id}/registrations',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-class/mlc-class-registrations.html',
                    controller: 'MlcClassRegistrationsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.query({param : "registrationsForClass:"+$stateParams.id, size: 100}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mlc-class', null, { reload: 'mlc-class' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mlc-class.delete', {
            parent: 'mlc-class',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-class/mlc-class-delete-dialog.html',
                    controller: 'MlcClassDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MlcClass', function(MlcClass) {
                            return MlcClass.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mlc-class', null, { reload: 'mlc-class' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mlc-class.registrations.email', {
            parent: 'mlc-class.registrations',
            url: '/email',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/email/email.html',
                    controller: 'EmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {to: $state.params.to, subject: $state.params.subject, bcc: $state.params.bcc}
                    }
                }).result.then(function() {
                    $state.go('mlc-class.registrations', null, { reload: 'mlc-class.registrations' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('MlcClass', MlcClass);

    MlcClass.$inject = ['$resource'];

    function MlcClass ($resource) {
        var resourceUrl =  'api/mlc-classes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'search': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassController', MlcClassController);

    MlcClassController.$inject = ['$state', 'loginUser', 'MlcClass', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MlcClassCategory', 'SchoolTerm', 'Registration'];

    function MlcClassController($state, loginUser, MlcClass, ParseLinks, AlertService, paginationConstants, pagingParams, MlcClassCategory, SchoolTerm, Registration) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchClass = searchClass;
        vm.getCHLClasses = getCHLClasses;
        vm.getCSLClasses = getCSLClasses;
        vm.getNonLangClasses = getNonLangClasses;
        vm.getAllClasses = loadAll;
        vm.mlcClassCategories = [];
        vm.mlcWeekendClassCategories = [];
        vm.mlcSummerClassCategories = [];
        vm.CHLCategoryId;
        vm.CSLCategoryId;
        vm.NonLangCategoryId;
        vm.schoolTerms = loadSchoolTerms;
        vm.getClassesBySchoolTerm = getClassesBySchoolTerm;
        vm.filterClasses = filterClasses;
        vm.loadCategories = loadCategories;
        vm.mlcClassTimes=[];
        vm.schoolTerms=[];

        vm.isAdmin = loginUser.authorities.includes('ROLE_ADMIN');

        loadSchoolTerms();

        function loadCategories() {
            MlcClassCategory.query(null,function(data){
                vm.mlcClassCategories = data;
                vm.mlcClassCategories.forEach(function(cat){
                    if(cat.type == 'SUMMER CAMP'){
                        if(cat.description == null || !cat.description.startsWith('INACTIVE')) {
                            vm.mlcSummerClassCategories.push(cat);
                        }
                    } else {
                        vm.mlcWeekendClassCategories.push(cat);
                    }
                    if(cat.name == 'CSL Chinese'){
                        vm.CSLCategoryId = cat.id;
                    } else if(cat.name == 'CHL Chinese'){
                        vm.CHLCategoryId = cat.id;
                    } else if(cat.name == 'NonLanguage'){
                        vm.NonLangCategoryId = cat.id;
                    }
                });
                if(vm.schoolTerm.type == "SUMMER CAMP"){
                    vm.mlcClassCategories = vm.mlcSummerClassCategories;
                } else {
                    vm.mlcClassCategories = vm.mlcWeekendClassCategories;
                }
            });
        }

        function loadAll () {
            MlcClass.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'className') {
                    result.push('className');
                }
                return result;
            }
        }

        function checkClassTime(mlcClass){
            if(vm.classTime){
                return mlcClass.classTime.classTime === vm.classTime;
            } else {
                return true;
            }
        }
        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;

            vm.mlcClasses = data.filter(checkClassTime);
            vm.mlcClassTimes = [];

            vm.mlcClasses.forEach(function(mlcClass){
                mlcClass.confirmed = 0;
                mlcClass.pending = 0;

                if(vm.mlcClassTimes.indexOf(mlcClass.classTime.classTime) === -1){
                    vm.mlcClassTimes.push(mlcClass.classTime.classTime);
                }

                if (mlcClass.classRoom && mlcClass.classRoom.roomNumber < 100){  // online classes
                    if(vm.isAdmin){
                        mlcClass.classRoom.roomNumber = mlcClass.classRoom.description;
                    } else {
                        mlcClass.classRoom.roomNumber = 'Online';
                    }
                }
                if (mlcClass.classRoom && mlcClass.classRoom.roomNumber > 1000){  // classes not in class room
                        mlcClass.classRoom.roomNumber = mlcClass.classRoom.description;
                }

                Registration.query({param : "registrationsForClass:"+mlcClass.id, size: 100}, function (registrations){
                    registrations.forEach(function(reg){
                       if(reg.status == 'CONFIRMED'){
                           mlcClass.confirmed += 1;
                       } else if(reg.status == 'PENDING'){
                           mlcClass.pending +=1;
                       }
                    });
                });
            });
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function onSchoolTermLoadSuccess() {
            vm.schoolTerm = vm.schoolTerms[0];
            getClassesBySchoolTerm();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        /*function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                category: vm.category? vm.category.id : null,
                schoolTerm: vm.schoolTerm? vm.schoolTerm.id : null,
                search: vm.currentSearch
            });
        }*/
        function transition() {
            var categoryId  = vm.category? vm.category.id : null;
            var schoolTermId = vm.schoolTerm? vm.schoolTerm.id : null;
            MlcClass.query({schoolTerm: schoolTermId, category: categoryId,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            }, onSuccess, onError);
        }

        function searchClass(){
            vm.category = null;
            MlcClass.query({search: vm.searchTerm,
                schoolTerm: vm.schoolTerm.id,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function getCHLClasses(){
            MlcClass.query({category: vm.CHLCategoryId,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function getCSLClasses(){
            MlcClass.query({category: vm.CSLCategoryId,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function getNonLangClasses(){
            MlcClass.query({category: vm.NonLangCategoryId,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function loadSchoolTerms () {
            SchoolTerm.query(function(result) {
                if(vm.isAdmin) {
                    vm.schoolTerms = result;
                } else {
                    result.forEach(function(schoolTerm){
                        if(schoolTerm.status !== 'FINISHED'){
                            vm.schoolTerms.push(schoolTerm);
                        }
                    });
                }
                vm.searchQuery = null;
                vm.schoolTerm = vm.schoolTerms[0];
                vm.loadCategories();
                vm.getClassesBySchoolTerm();
            });
        }

        function getClassesBySchoolTerm() {
            MlcClass.query({schoolTerm: vm.schoolTerm.id,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function filterClasses () {
            vm.searchTerm = null;
            var categoryId  = vm.category? vm.category.id : null;
            var schoolTermId = vm.schoolTerm? vm.schoolTerm.id : null;
            var classTime = vm.classTime? vm.classTime : null;
            if(vm.schoolTerm.type == "SUMMER CAMP"){
                vm.mlcClassCategories = vm.mlcSummerClassCategories;
            } else {
                vm.mlcClassCategories = vm.mlcWeekendClassCategories;
            }
            MlcClass.query({schoolTerm: schoolTermId, category: categoryId,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcAccountDialogController', MlcAccountDialogController);

    MlcAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'MlcAccount', 'Contact'];

    function MlcAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, MlcAccount, Contact) {
        var vm = this;

        vm.mlcAccount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.contacts = Contact.query({filter: 'mlcaccount-is-null'});
        $q.all([vm.mlcAccount.$promise, vm.contacts.$promise]).then(function() {
            if (!vm.mlcAccount.contact || !vm.mlcAccount.contact.id) {
                return $q.reject();
            }
            return Contact.get({id : vm.mlcAccount.contact.id}).$promise;
        }).then(function(contact) {
            vm.contacts.push(contact);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.mlcAccount.id !== null) {
                MlcAccount.update(vm.mlcAccount, onSaveSuccess, onSaveError);
            } else {
                MlcAccount.save(vm.mlcAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:mlcAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcAccountDetailController', MlcAccountDetailController);

    MlcAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MlcAccount', 'Contact'];

    function MlcAccountDetailController($scope, $rootScope, $stateParams, previousState, entity, MlcAccount, Contact) {
        var vm = this;

        vm.mlcAccount = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:mlcAccountUpdate', function(event, result) {
            vm.mlcAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcAccountDeleteController',MlcAccountDeleteController);

    MlcAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'MlcAccount'];

    function MlcAccountDeleteController($uibModalInstance, entity, MlcAccount) {
        var vm = this;

        vm.mlcAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MlcAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('mlc-account', {
            parent: 'entity',
            url: '/mlc-account?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'MlcAccounts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mlc-account/mlc-accounts.html',
                    controller: 'MlcAccountController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('mlc-account-detail', {
            parent: 'mlc-account',
            url: '/mlc-account/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'MlcAccount'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mlc-account/mlc-account-detail.html',
                    controller: 'MlcAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MlcAccount', function($stateParams, MlcAccount) {
                    return MlcAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'mlc-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('mlc-account-detail.edit', {
            parent: 'mlc-account-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-account/mlc-account-dialog.html',
                    controller: 'MlcAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MlcAccount', function(MlcAccount) {
                            return MlcAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mlc-account.new', {
            parent: 'mlc-account',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-account/mlc-account-dialog.html',
                    controller: 'MlcAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                email: null,
                                password: null,
                                createDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('mlc-account', null, { reload: 'mlc-account' });
                }, function() {
                    $state.go('mlc-account');
                });
            }]
        })
        .state('mlc-account.edit', {
            parent: 'mlc-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-account/mlc-account-dialog.html',
                    controller: 'MlcAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MlcAccount', function(MlcAccount) {
                            return MlcAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mlc-account', null, { reload: 'mlc-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mlc-account.delete', {
            parent: 'mlc-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mlc-account/mlc-account-delete-dialog.html',
                    controller: 'MlcAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MlcAccount', function(MlcAccount) {
                            return MlcAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mlc-account', null, { reload: 'mlc-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('MlcAccount', MlcAccount);

    MlcAccount.$inject = ['$resource', 'DateUtils'];

    function MlcAccount ($resource, DateUtils) {
        var resourceUrl =  'api/mlc-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertLocalDateFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createDate = DateUtils.convertLocalDateToServer(copy.createDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createDate = DateUtils.convertLocalDateToServer(copy.createDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcAccountController', MlcAccountController);

    MlcAccountController.$inject = ['$state', 'MlcAccount', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MlcAccountController($state, MlcAccount, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            MlcAccount.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.mlcAccounts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SwitchClassController',SwitchClassController);

    SwitchClassController.$inject = ['$scope', '$state', 'previousState', '$uibModalInstance', 'entity', 'Registration', 'MlcClassCategory', 'MlcClass'];

    function SwitchClassController($scope, $state, previousState, $uibModalInstance, entity, Registration, MlcClassCategory, MlcClass) {
        var vm = this;

        vm.registration = entity;
        vm.switchClass = false;
        vm.saving = false;
        vm.checked = false;

        vm.searchClasses = searchClasses;
        vm.save = save;
        vm.clear = clear;
        vm.confirmSwitchClass = confirmSwitchClass;
        vm.checkDisclaimer = checkDisclaimer;

        vm.existingClass = vm.registration.mlcClass;
        vm.mlcClassCategories = [];
        vm.mlcClassCategory = null;
        vm.mlcClasses = [];
        vm.mlcClass = null;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmSwitchClass () {
            vm.mlcClassCategories = MlcClassCategory.query({}, onLoadCategoriesSuccess);
            vm.switchClass = true;
        }

        function onLoadCategoriesSuccess(){
            if(vm.mlcClassCategories){
                vm.mlcClassCategory = vm.mlcClassCategories[0];
                vm.mlcClasses = MlcClass.query({category: vm.mlcClassCategory.id, newRegistration: true, size: 50, sort: 'className'}, function(data){
                    vm.registration.mlcClass = data[0];
                });
            }
        }

        function searchClasses (){
            vm.mlcClasses = MlcClass.search({category: vm.mlcClassCategory.id, newRegistration: true, size:50, sort: 'className'}, function(data){
                vm.registration.mlcClass = data[0];
            });
        }

        function checkDisclaimer(){
            vm.checked = !vm.checked;
        }

        function save () {
            vm.isSaving = true;
            Registration.update(vm.registration, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:registrationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegistrationWithdrawController',RegistrationWithdrawController);

    RegistrationWithdrawController.$inject = ['$state', 'previousState', '$uibModalInstance', 'entity', 'Registration'];

    function RegistrationWithdrawController($state, previousState, $uibModalInstance, entity, Registration) {
        var vm = this;

        vm.registration = entity;
        vm.clear = clear;
        vm.confirmWithdraw = confirmWithdraw;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmWithdraw (registration) {
            registration.status = 'WITHDRAWN_NEED_REFUND';
            Registration.update(registration,function(){
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('InvoiceDialogController', InvoiceDialogController);

    InvoiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Invoice', 'User', 'Registration', 'Payment', 'AppliedDiscount'];

    function InvoiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Invoice, User, Registration, Payment, AppliedDiscount) {
        var vm = this;

        vm.invoice = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.registrations = Registration.query();
        vm.payments = Payment.query();
        vm.applieddiscounts = AppliedDiscount.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.invoice.id !== null) {
                Invoice.update(vm.invoice, onSaveSuccess, onSaveError);
            } else {
                Invoice.save(vm.invoice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:invoiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.invoiceDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('InvoiceDetailController', InvoiceDetailController);

    InvoiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Invoice', 'User', 'Registration', 'Payment', 'AppliedDiscount'];

    function InvoiceDetailController($scope, $rootScope, $stateParams, previousState, entity, Invoice, User, Registration, Payment, AppliedDiscount) {
        var vm = this;

        vm.invoice = entity;
        vm.previousState = previousState.name;
        vm.needRefund = false;
        vm.paymentNeeded = vm.invoice.status !== 'PAID' && vm.invoice.total > 0;
        vm.paymentMade = vm.invoice.status === 'PAID' || vm.invoice.status === 'PARTIALLY_PAID';

        vm.invoice.registrations.forEach(function(registration){
            if(registration.status == 'WITHDRAWN_NEED_REFUND'){
                vm.needRefund = true;
            }
        })

        var unsubscribe = $rootScope.$on('mlcccApp:invoiceUpdate', function(event, result) {
            vm.invoice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('InvoiceDeleteController',InvoiceDeleteController);

    InvoiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Invoice'];

    function InvoiceDeleteController($uibModalInstance, entity, Invoice) {
        var vm = this;

        vm.invoice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Invoice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice', {
            parent: 'entity',
            url: '/invoice',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Invoices'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoices.html',
                    controller: 'InvoiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                schoolTerm: null,
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        schoolTerm: $stateParams.schoolTerm
                    };
                }]
            }
        })
        .state('invoice-detail', {
            parent: 'invoice',
            url: '/invoice/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Invoice'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoice-detail.html',
                    controller: 'InvoiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Invoice', function($stateParams, Invoice) {
                    return Invoice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'invoice',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('invoice-detail.edit', {
            parent: 'invoice-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice.new', {
            parent: 'invoice',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                status: null,
                                invoiceDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: 'invoice' });
                }, function() {
                    $state.go('invoice');
                });
            }]
        })
        .state('invoice.edit', {
            parent: 'invoice',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: 'invoice' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice.delete', {
            parent: 'invoice',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-delete-dialog.html',
                    controller: 'InvoiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: 'invoice' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice.withdrawRegistration', {
            parent: 'invoice-detail',
            url: '/withdraw/{regId}',
            data: {
                authorities: ['ROLE_USER']
            },
            regId: 0,
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/registration-withdraw-dialog.html',
                    controller: 'RegistrationWithdrawController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.get({id : $stateParams.regId}).$promise;
                        }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'registration',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                            return currentStateData;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-detail', null, { reload: 'invoice-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice.switchClass', {
            parent: 'invoice-detail',
            url: '/switch/{regId}',
            data: {
                authorities: ['ROLE_USER']
            },
            regId: 0,
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/switch-class-dialog.html',
                    controller: 'SwitchClassController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.get({id : $stateParams.regId}).$promise;
                        }],
                        previousState: ["$state", function ($state) {
                            var currentStateData = {
                                name: $state.current.name || 'registration',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-detail', null, { reload: 'invoice-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'api/:schoolTermId/invoices/:id?searchTerm=:param';

        return $resource(resourceUrl, {param: '@param'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.invoiceDate = DateUtils.convertLocalDateFromServer(data.invoiceDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.invoiceDate = DateUtils.convertLocalDateToServer(copy.invoiceDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.invoiceDate = DateUtils.convertLocalDateToServer(copy.invoiceDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('InvoiceController', InvoiceController);

    InvoiceController.$inject = ['Invoice', 'SchoolTerm', 'Print', '$state', 'pagingParams', 'paginationConstants', 'ParseLinks'];

    function InvoiceController(Invoice, SchoolTerm, Print, $state, pagingParams, paginationConstants, ParseLinks) {

        var vm = this;
        vm.noRecord = false;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.invoices = [];
        vm.loadSchoolTerms = loadSchoolTerms()
        vm.print = print;
        vm.searchInvoice = searchInvoice;
        vm.loadAll = loadAll;
        vm.schoolTerm = pagingParams.schoolTerm;

        vm.summerCampInvoice = false;
        vm.weekendSchoolInvoice = !vm.summerCampInvoice;

        loadSchoolTerms();

        function loadAll(schoolTermId) {
            Invoice.query(
                {
                    schoolTermId: schoolTermId,
                    param: vm.searchTerm,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: 'id,desc'
                }, onSuccess);
        }

        function print(title){
            var printContents = document.getElementById('print-section').innerHTML;
            Print.print(title, printContents);
        }

        function searchInvoice(searchTerm){
            Invoice.query({param: vm.searchTerm}, onSuccess);
        }

        function transition() {
            $state.transitionTo($state.$current, {
                schoolTerm: vm.schoolTerm,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function onSuccess(result, headers){
                vm.invoices = result;
                if(vm.invoices.length == 0){
                    vm.noRecord = true;
                }
                vm.searchQuery = null;
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
        }

        function loadSchoolTerms () {
            SchoolTerm.query(function(result) {
                vm.schoolTerms = result;
                vm.searchQuery = null;
                if(vm.schoolTerm) {
                    loadAll(vm.schoolTerm.id);
                } else {
                    loadAll();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('DiscountCodeDialogController', DiscountCodeDialogController);

    DiscountCodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DiscountCode'];

    function DiscountCodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DiscountCode) {
        var vm = this;

        vm.discountCode = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.discountCode.id !== null) {
                DiscountCode.update(vm.discountCode, onSaveSuccess, onSaveError);
            } else {
                DiscountCode.save(vm.discountCode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:discountCodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('DiscountCodeDetailController', DiscountCodeDetailController);

    DiscountCodeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DiscountCode'];

    function DiscountCodeDetailController($scope, $rootScope, $stateParams, previousState, entity, DiscountCode) {
        var vm = this;

        vm.discountCode = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:discountCodeUpdate', function(event, result) {
            vm.discountCode = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('DiscountCodeDeleteController',DiscountCodeDeleteController);

    DiscountCodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'DiscountCode'];

    function DiscountCodeDeleteController($uibModalInstance, entity, DiscountCode) {
        var vm = this;

        vm.discountCode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DiscountCode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('discount-code', {
            parent: 'entity',
            url: '/discount-code',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DiscountCodes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-code/discount-codes.html',
                    controller: 'DiscountCodeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('discount-code-detail', {
            parent: 'discount-code',
            url: '/discount-code/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DiscountCode'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-code/discount-code-detail.html',
                    controller: 'DiscountCodeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'DiscountCode', function($stateParams, DiscountCode) {
                    return DiscountCode.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'discount-code',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('discount-code-detail.edit', {
            parent: 'discount-code-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-code/discount-code-dialog.html',
                    controller: 'DiscountCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DiscountCode', function(DiscountCode) {
                            return DiscountCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discount-code.new', {
            parent: 'discount-code',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-code/discount-code-dialog.html',
                    controller: 'DiscountCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('discount-code', null, { reload: 'discount-code' });
                }, function() {
                    $state.go('discount-code');
                });
            }]
        })
        .state('discount-code.edit', {
            parent: 'discount-code',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-code/discount-code-dialog.html',
                    controller: 'DiscountCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DiscountCode', function(DiscountCode) {
                            return DiscountCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-code', null, { reload: 'discount-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discount-code.delete', {
            parent: 'discount-code',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-code/discount-code-delete-dialog.html',
                    controller: 'DiscountCodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DiscountCode', function(DiscountCode) {
                            return DiscountCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-code', null, { reload: 'discount-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('DiscountCode', DiscountCode);

    DiscountCode.$inject = ['$resource'];

    function DiscountCode ($resource) {
        var resourceUrl =  'api/discount-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('DiscountCodeController', DiscountCodeController);

    DiscountCodeController.$inject = ['DiscountCode'];

    function DiscountCodeController(DiscountCode) {

        var vm = this;

        vm.discountCodes = [];

        loadAll();

        function loadAll() {
            DiscountCode.query(function(result) {
                vm.discountCodes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('DiscountDialogController', DiscountDialogController);

    DiscountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Discount', 'DiscountCode', 'SchoolTerm'];

    function DiscountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Discount, DiscountCode, SchoolTerm) {
        var vm = this;

        vm.discount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.discountcodes = DiscountCode.query();
        vm.schoolterms = SchoolTerm.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.discount.id !== null) {
                Discount.update(vm.discount, onSaveSuccess, onSaveError);
            } else {
                Discount.save(vm.discount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:discountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('DiscountDetailController', DiscountDetailController);

    DiscountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Discount', 'DiscountCode', 'SchoolTerm'];

    function DiscountDetailController($scope, $rootScope, $stateParams, previousState, entity, Discount, DiscountCode, SchoolTerm) {
        var vm = this;

        vm.discount = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:discountUpdate', function(event, result) {
            vm.discount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('DiscountDeleteController',DiscountDeleteController);

    DiscountDeleteController.$inject = ['$uibModalInstance', 'entity', 'Discount'];

    function DiscountDeleteController($uibModalInstance, entity, Discount) {
        var vm = this;

        vm.discount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Discount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('discount', {
            parent: 'entity',
            url: '/discount',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Discounts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount/discounts.html',
                    controller: 'DiscountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('discount-detail', {
            parent: 'discount',
            url: '/discount/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Discount'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount/discount-detail.html',
                    controller: 'DiscountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Discount', function($stateParams, Discount) {
                    return Discount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'discount',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('discount-detail.edit', {
            parent: 'discount-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount/discount-dialog.html',
                    controller: 'DiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Discount', function(Discount) {
                            return Discount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discount.new', {
            parent: 'discount',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount/discount-dialog.html',
                    controller: 'DiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                amount: null,
                                startDate: null,
                                endDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('discount', null, { reload: 'discount' });
                }, function() {
                    $state.go('discount');
                });
            }]
        })
        .state('discount.edit', {
            parent: 'discount',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount/discount-dialog.html',
                    controller: 'DiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Discount', function(Discount) {
                            return Discount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount', null, { reload: 'discount' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discount.delete', {
            parent: 'discount',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount/discount-delete-dialog.html',
                    controller: 'DiscountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Discount', function(Discount) {
                            return Discount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount', null, { reload: 'discount' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('Discount', Discount);

    Discount.$inject = ['$resource', 'DateUtils'];

    function Discount ($resource, DateUtils) {
        var resourceUrl =  'api/discounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('DiscountController', DiscountController);

    DiscountController.$inject = ['Discount'];

    function DiscountController(Discount) {

        var vm = this;

        vm.discounts = [];

        loadAll();

        function loadAll() {
            Discount.query(function(result) {
                vm.discounts = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ContactDialogController', ContactDialogController);

    ContactDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Contact', 'PhoneType', 'SchoolDistrict'];

    function ContactDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Contact, PhoneType, SchoolDistrict) {
        var vm = this;

        vm.contact = entity;
        vm.clear = clear;
        vm.save = save;
        vm.phonetypes = PhoneType.query();
        vm.schooldistricts = SchoolDistrict.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.contact.id !== null) {
                Contact.update(vm.contact, onSaveSuccess, onSaveError);
            } else {
                Contact.save(vm.contact, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:contactUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ContactDetailController', ContactDetailController);

    ContactDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Contact', 'PhoneType', 'SchoolDistrict'];

    function ContactDetailController($scope, $rootScope, $stateParams, previousState, entity, Contact, PhoneType, SchoolDistrict) {
        var vm = this;

        vm.contact = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:contactUpdate', function(event, result) {
            vm.contact = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ContactDeleteController',ContactDeleteController);

    ContactDeleteController.$inject = ['$uibModalInstance', 'entity', 'Contact'];

    function ContactDeleteController($uibModalInstance, entity, Contact) {
        var vm = this;

        vm.contact = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Contact.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('contact', {
            parent: 'entity',
            url: '/contact',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contact/contacts.html',
                    controller: 'ContactController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('contact-detail', {
            parent: 'contact',
            url: '/contact/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Contact'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contact/contact-detail.html',
                    controller: 'ContactDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Contact', function($stateParams, Contact) {
                    return Contact.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'contact',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('contact-detail.edit', {
            parent: 'contact-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact/contact-dialog.html',
                    controller: 'ContactDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contact', function(Contact) {
                            return Contact.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contact.new', {
            parent: 'contact',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact/contact-dialog.html',
                    controller: 'ContactDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                address: null,
                                city: null,
                                state: null,
                                zip: null,
                                phone: null,
                                fax: null,
                                p1FirstName: null,
                                p1LastName: null,
                                p2FirstName: null,
                                p2LastName: null,
                                p1Phone1: null,
                                p1Phone2: null,
                                p2Phone1: null,
                                p2Phone2: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('contact', null, { reload: 'contact' });
                }, function() {
                    $state.go('contact');
                });
            }]
        })
        .state('contact.edit', {
            parent: 'contact',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact/contact-dialog.html',
                    controller: 'ContactDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contact', function(Contact) {
                            return Contact.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contact', null, { reload: 'contact' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contact.delete', {
            parent: 'contact',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact/contact-delete-dialog.html',
                    controller: 'ContactDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Contact', function(Contact) {
                            return Contact.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contact', null, { reload: 'contact' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('Contact', Contact);

    Contact.$inject = ['$resource'];

    function Contact ($resource) {
        var resourceUrl =  'api/contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ContactController', ContactController);

    ContactController.$inject = ['Contact'];

    function ContactController(Contact) {

        var vm = this;

        vm.contacts = [];

        loadAll();

        function loadAll() {
            Contact.query(function(result) {
                vm.contacts = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassTimeDialogController', ClassTimeDialogController);

    ClassTimeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ClassTime'];

    function ClassTimeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ClassTime) {
        var vm = this;

        vm.classTime = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.classTime.id !== null) {
                ClassTime.update(vm.classTime, onSaveSuccess, onSaveError);
            } else {
                ClassTime.save(vm.classTime, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:classTimeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassTimeDetailController', ClassTimeDetailController);

    ClassTimeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ClassTime'];

    function ClassTimeDetailController($scope, $rootScope, $stateParams, previousState, entity, ClassTime) {
        var vm = this;

        vm.classTime = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:classTimeUpdate', function(event, result) {
            vm.classTime = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassTimeDeleteController',ClassTimeDeleteController);

    ClassTimeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ClassTime'];

    function ClassTimeDeleteController($uibModalInstance, entity, ClassTime) {
        var vm = this;

        vm.classTime = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ClassTime.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('class-time', {
            parent: 'entity',
            url: '/class-time',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ClassTimes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/class-time/class-times.html',
                    controller: 'ClassTimeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('class-time-detail', {
            parent: 'class-time',
            url: '/class-time/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ClassTime'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/class-time/class-time-detail.html',
                    controller: 'ClassTimeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ClassTime', function($stateParams, ClassTime) {
                    return ClassTime.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'class-time',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('class-time-detail.edit', {
            parent: 'class-time-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-time/class-time-dialog.html',
                    controller: 'ClassTimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClassTime', function(ClassTime) {
                            return ClassTime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('class-time.new', {
            parent: 'class-time',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-time/class-time-dialog.html',
                    controller: 'ClassTimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                classTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('class-time', null, { reload: 'class-time' });
                }, function() {
                    $state.go('class-time');
                });
            }]
        })
        .state('class-time.edit', {
            parent: 'class-time',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-time/class-time-dialog.html',
                    controller: 'ClassTimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClassTime', function(ClassTime) {
                            return ClassTime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('class-time', null, { reload: 'class-time' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('class-time.delete', {
            parent: 'class-time',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-time/class-time-delete-dialog.html',
                    controller: 'ClassTimeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ClassTime', function(ClassTime) {
                            return ClassTime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('class-time', null, { reload: 'class-time' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('ClassTime', ClassTime);

    ClassTime.$inject = ['$resource'];

    function ClassTime ($resource) {
        var resourceUrl =  'api/class-times/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassTimeController', ClassTimeController);

    ClassTimeController.$inject = ['ClassTime'];

    function ClassTimeController(ClassTime) {

        var vm = this;

        vm.classTimes = [];

        loadAll();

        function loadAll() {
            ClassTime.query(function(result) {
                vm.classTimes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassStatusDialogController', ClassStatusDialogController);

    ClassStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ClassStatus'];

    function ClassStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ClassStatus) {
        var vm = this;

        vm.classStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.classStatus.id !== null) {
                ClassStatus.update(vm.classStatus, onSaveSuccess, onSaveError);
            } else {
                ClassStatus.save(vm.classStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:classStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassStatusDetailController', ClassStatusDetailController);

    ClassStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ClassStatus'];

    function ClassStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, ClassStatus) {
        var vm = this;

        vm.classStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:classStatusUpdate', function(event, result) {
            vm.classStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassStatusDeleteController',ClassStatusDeleteController);

    ClassStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'ClassStatus'];

    function ClassStatusDeleteController($uibModalInstance, entity, ClassStatus) {
        var vm = this;

        vm.classStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ClassStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('class-status', {
            parent: 'entity',
            url: '/class-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ClassStatuses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/class-status/class-statuses.html',
                    controller: 'ClassStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('class-status-detail', {
            parent: 'class-status',
            url: '/class-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ClassStatus'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/class-status/class-status-detail.html',
                    controller: 'ClassStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ClassStatus', function($stateParams, ClassStatus) {
                    return ClassStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'class-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('class-status-detail.edit', {
            parent: 'class-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-status/class-status-dialog.html',
                    controller: 'ClassStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClassStatus', function(ClassStatus) {
                            return ClassStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('class-status.new', {
            parent: 'class-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-status/class-status-dialog.html',
                    controller: 'ClassStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                colorDisplayed: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('class-status', null, { reload: 'class-status' });
                }, function() {
                    $state.go('class-status');
                });
            }]
        })
        .state('class-status.edit', {
            parent: 'class-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-status/class-status-dialog.html',
                    controller: 'ClassStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClassStatus', function(ClassStatus) {
                            return ClassStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('class-status', null, { reload: 'class-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('class-status.delete', {
            parent: 'class-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-status/class-status-delete-dialog.html',
                    controller: 'ClassStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ClassStatus', function(ClassStatus) {
                            return ClassStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('class-status', null, { reload: 'class-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('ClassStatus', ClassStatus);

    ClassStatus.$inject = ['$resource'];

    function ClassStatus ($resource) {
        var resourceUrl =  'api/class-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassStatusController', ClassStatusController);

    ClassStatusController.$inject = ['ClassStatus'];

    function ClassStatusController(ClassStatus) {

        var vm = this;

        vm.classStatuses = [];

        loadAll();

        function loadAll() {
            ClassStatus.query(function(result) {
                vm.classStatuses = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassRoomDialogController', ClassRoomDialogController);

    ClassRoomDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ClassRoom'];

    function ClassRoomDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ClassRoom) {
        var vm = this;

        vm.classRoom = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.classRoom.id !== null) {
                ClassRoom.update(vm.classRoom, onSaveSuccess, onSaveError);
            } else {
                ClassRoom.save(vm.classRoom, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:classRoomUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassRoomDetailController', ClassRoomDetailController);

    ClassRoomDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ClassRoom'];

    function ClassRoomDetailController($scope, $rootScope, $stateParams, previousState, entity, ClassRoom) {
        var vm = this;

        vm.classRoom = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:classRoomUpdate', function(event, result) {
            vm.classRoom = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassRoomDeleteController',ClassRoomDeleteController);

    ClassRoomDeleteController.$inject = ['$uibModalInstance', 'entity', 'ClassRoom'];

    function ClassRoomDeleteController($uibModalInstance, entity, ClassRoom) {
        var vm = this;

        vm.classRoom = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ClassRoom.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('class-room', {
            parent: 'entity',
            url: '/class-room',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ClassRooms'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/class-room/class-rooms.html',
                    controller: 'ClassRoomController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('class-room-detail', {
            parent: 'class-room',
            url: '/class-room/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ClassRoom'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/class-room/class-room-detail.html',
                    controller: 'ClassRoomDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ClassRoom', function($stateParams, ClassRoom) {
                    return ClassRoom.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'class-room',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('class-room-detail.edit', {
            parent: 'class-room-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-room/class-room-dialog.html',
                    controller: 'ClassRoomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClassRoom', function(ClassRoom) {
                            return ClassRoom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('class-room.new', {
            parent: 'class-room',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-room/class-room-dialog.html',
                    controller: 'ClassRoomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                roomNumber: null,
                                description: null,
                                projectAvailable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('class-room', null, { reload: 'class-room' });
                }, function() {
                    $state.go('class-room');
                });
            }]
        })
        .state('class-room.edit', {
            parent: 'class-room',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-room/class-room-dialog.html',
                    controller: 'ClassRoomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClassRoom', function(ClassRoom) {
                            return ClassRoom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('class-room', null, { reload: 'class-room' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('class-room.delete', {
            parent: 'class-room',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/class-room/class-room-delete-dialog.html',
                    controller: 'ClassRoomDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ClassRoom', function(ClassRoom) {
                            return ClassRoom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('class-room', null, { reload: 'class-room' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('ClassRoom', ClassRoom);

    ClassRoom.$inject = ['$resource'];

    function ClassRoom ($resource) {
        var resourceUrl =  'api/class-rooms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ClassRoomController', ClassRoomController);

    ClassRoomController.$inject = ['ClassRoom'];

    function ClassRoomController(ClassRoom) {

        var vm = this;

        vm.classRooms = [];

        loadAll();

        function loadAll() {
            ClassRoom.query(function(result) {
                vm.classRooms = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AppliedDiscountDialogController', AppliedDiscountDialogController);

    AppliedDiscountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AppliedDiscount', 'Discount', 'Registration', 'Invoice'];

    function AppliedDiscountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AppliedDiscount, Discount, Registration, Invoice) {
        var vm = this;

        vm.appliedDiscount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.discounts = Discount.query();
        vm.registrations = Registration.query();
        vm.invoices = Invoice.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appliedDiscount.id !== null) {
                AppliedDiscount.update(vm.appliedDiscount, onSaveSuccess, onSaveError);
            } else {
                AppliedDiscount.save(vm.appliedDiscount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:appliedDiscountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AppliedDiscountDetailController', AppliedDiscountDetailController);

    AppliedDiscountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AppliedDiscount', 'Discount', 'Registration', 'Invoice'];

    function AppliedDiscountDetailController($scope, $rootScope, $stateParams, previousState, entity, AppliedDiscount, Discount, Registration, Invoice) {
        var vm = this;

        vm.appliedDiscount = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:appliedDiscountUpdate', function(event, result) {
            vm.appliedDiscount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AppliedDiscountDeleteController',AppliedDiscountDeleteController);

    AppliedDiscountDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppliedDiscount'];

    function AppliedDiscountDeleteController($uibModalInstance, entity, AppliedDiscount) {
        var vm = this;

        vm.appliedDiscount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppliedDiscount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('applied-discount', {
            parent: 'entity',
            url: '/applied-discount',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AppliedDiscounts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/applied-discount/applied-discounts.html',
                    controller: 'AppliedDiscountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('applied-discount-detail', {
            parent: 'applied-discount',
            url: '/applied-discount/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AppliedDiscount'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/applied-discount/applied-discount-detail.html',
                    controller: 'AppliedDiscountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'AppliedDiscount', function($stateParams, AppliedDiscount) {
                    return AppliedDiscount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'applied-discount',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('applied-discount-detail.edit', {
            parent: 'applied-discount-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applied-discount/applied-discount-dialog.html',
                    controller: 'AppliedDiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppliedDiscount', function(AppliedDiscount) {
                            return AppliedDiscount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('applied-discount.new', {
            parent: 'applied-discount',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applied-discount/applied-discount-dialog.html',
                    controller: 'AppliedDiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdDate: null,
                                modifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('applied-discount', null, { reload: 'applied-discount' });
                }, function() {
                    $state.go('applied-discount');
                });
            }]
        })
        .state('applied-discount.edit', {
            parent: 'applied-discount',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applied-discount/applied-discount-dialog.html',
                    controller: 'AppliedDiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppliedDiscount', function(AppliedDiscount) {
                            return AppliedDiscount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('applied-discount', null, { reload: 'applied-discount' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('applied-discount.delete', {
            parent: 'applied-discount',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applied-discount/applied-discount-delete-dialog.html',
                    controller: 'AppliedDiscountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppliedDiscount', function(AppliedDiscount) {
                            return AppliedDiscount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('applied-discount', null, { reload: 'applied-discount' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('AppliedDiscount', AppliedDiscount);

    AppliedDiscount.$inject = ['$resource', 'DateUtils'];

    function AppliedDiscount ($resource, DateUtils) {
        var resourceUrl =  'api/applied-discounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                        data.modifiedDate = DateUtils.convertLocalDateFromServer(data.modifiedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    copy.modifiedDate = DateUtils.convertLocalDateToServer(copy.modifiedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    copy.modifiedDate = DateUtils.convertLocalDateToServer(copy.modifiedDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AppliedDiscountController', AppliedDiscountController);

    AppliedDiscountController.$inject = ['AppliedDiscount'];

    function AppliedDiscountController(AppliedDiscount) {

        var vm = this;

        vm.appliedDiscounts = [];

        loadAll();

        function loadAll() {
            AppliedDiscount.query(function(result) {
                vm.appliedDiscounts = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountFlagStatusDialogController', AccountFlagStatusDialogController);

    AccountFlagStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AccountFlagStatus'];

    function AccountFlagStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AccountFlagStatus) {
        var vm = this;

        vm.accountFlagStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.accountFlagStatus.id !== null) {
                AccountFlagStatus.update(vm.accountFlagStatus, onSaveSuccess, onSaveError);
            } else {
                AccountFlagStatus.save(vm.accountFlagStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:accountFlagStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountFlagStatusDetailController', AccountFlagStatusDetailController);

    AccountFlagStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AccountFlagStatus'];

    function AccountFlagStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, AccountFlagStatus) {
        var vm = this;

        vm.accountFlagStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:accountFlagStatusUpdate', function(event, result) {
            vm.accountFlagStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountFlagStatusDeleteController',AccountFlagStatusDeleteController);

    AccountFlagStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'AccountFlagStatus'];

    function AccountFlagStatusDeleteController($uibModalInstance, entity, AccountFlagStatus) {
        var vm = this;

        vm.accountFlagStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AccountFlagStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('account-flag-status', {
            parent: 'entity',
            url: '/account-flag-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AccountFlagStatuses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/account-flag-status/account-flag-statuses.html',
                    controller: 'AccountFlagStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('account-flag-status-detail', {
            parent: 'account-flag-status',
            url: '/account-flag-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AccountFlagStatus'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/account-flag-status/account-flag-status-detail.html',
                    controller: 'AccountFlagStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'AccountFlagStatus', function($stateParams, AccountFlagStatus) {
                    return AccountFlagStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'account-flag-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('account-flag-status-detail.edit', {
            parent: 'account-flag-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-flag-status/account-flag-status-dialog.html',
                    controller: 'AccountFlagStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccountFlagStatus', function(AccountFlagStatus) {
                            return AccountFlagStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('account-flag-status.new', {
            parent: 'account-flag-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-flag-status/account-flag-status-dialog.html',
                    controller: 'AccountFlagStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('account-flag-status', null, { reload: 'account-flag-status' });
                }, function() {
                    $state.go('account-flag-status');
                });
            }]
        })
        .state('account-flag-status.edit', {
            parent: 'account-flag-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-flag-status/account-flag-status-dialog.html',
                    controller: 'AccountFlagStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccountFlagStatus', function(AccountFlagStatus) {
                            return AccountFlagStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('account-flag-status', null, { reload: 'account-flag-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('account-flag-status.delete', {
            parent: 'account-flag-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-flag-status/account-flag-status-delete-dialog.html',
                    controller: 'AccountFlagStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AccountFlagStatus', function(AccountFlagStatus) {
                            return AccountFlagStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('account-flag-status', null, { reload: 'account-flag-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('AccountFlagStatus', AccountFlagStatus);

    AccountFlagStatus.$inject = ['$resource'];

    function AccountFlagStatus ($resource) {
        var resourceUrl =  'api/account-flag-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountFlagStatusController', AccountFlagStatusController);

    AccountFlagStatusController.$inject = ['AccountFlagStatus'];

    function AccountFlagStatusController(AccountFlagStatus) {

        var vm = this;

        vm.accountFlagStatuses = [];

        loadAll();

        function loadAll() {
            AccountFlagStatus.query(function(result) {
                vm.accountFlagStatuses = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountFlagDialogController', AccountFlagDialogController);

    AccountFlagDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AccountFlag', 'MlcAccount', 'AccountFlagStatus'];

    function AccountFlagDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AccountFlag, MlcAccount, AccountFlagStatus) {
        var vm = this;

        vm.accountFlag = entity;
        vm.clear = clear;
        vm.save = save;
        vm.mlcaccounts = MlcAccount.query();
        vm.accountflagstatuses = AccountFlagStatus.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.accountFlag.id !== null) {
                AccountFlag.update(vm.accountFlag, onSaveSuccess, onSaveError);
            } else {
                AccountFlag.save(vm.accountFlag, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:accountFlagUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountFlagDetailController', AccountFlagDetailController);

    AccountFlagDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AccountFlag', 'MlcAccount', 'AccountFlagStatus'];

    function AccountFlagDetailController($scope, $rootScope, $stateParams, previousState, entity, AccountFlag, MlcAccount, AccountFlagStatus) {
        var vm = this;

        vm.accountFlag = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:accountFlagUpdate', function(event, result) {
            vm.accountFlag = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountFlagDeleteController',AccountFlagDeleteController);

    AccountFlagDeleteController.$inject = ['$uibModalInstance', 'entity', 'AccountFlag'];

    function AccountFlagDeleteController($uibModalInstance, entity, AccountFlag) {
        var vm = this;

        vm.accountFlag = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AccountFlag.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('account-flag', {
            parent: 'entity',
            url: '/account-flag',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AccountFlags'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/account-flag/account-flags.html',
                    controller: 'AccountFlagController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('account-flag-detail', {
            parent: 'account-flag',
            url: '/account-flag/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AccountFlag'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/account-flag/account-flag-detail.html',
                    controller: 'AccountFlagDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'AccountFlag', function($stateParams, AccountFlag) {
                    return AccountFlag.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'account-flag',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('account-flag-detail.edit', {
            parent: 'account-flag-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-flag/account-flag-dialog.html',
                    controller: 'AccountFlagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccountFlag', function(AccountFlag) {
                            return AccountFlag.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('account-flag.new', {
            parent: 'account-flag',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-flag/account-flag-dialog.html',
                    controller: 'AccountFlagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                flagType: null,
                                relatedKey: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('account-flag', null, { reload: 'account-flag' });
                }, function() {
                    $state.go('account-flag');
                });
            }]
        })
        .state('account-flag.edit', {
            parent: 'account-flag',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-flag/account-flag-dialog.html',
                    controller: 'AccountFlagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccountFlag', function(AccountFlag) {
                            return AccountFlag.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('account-flag', null, { reload: 'account-flag' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('account-flag.delete', {
            parent: 'account-flag',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-flag/account-flag-delete-dialog.html',
                    controller: 'AccountFlagDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AccountFlag', function(AccountFlag) {
                            return AccountFlag.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('account-flag', null, { reload: 'account-flag' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('AccountFlag', AccountFlag);

    AccountFlag.$inject = ['$resource'];

    function AccountFlag ($resource) {
        var resourceUrl =  'api/account-flags/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountFlagController', AccountFlagController);

    AccountFlagController.$inject = ['AccountFlag'];

    function AccountFlagController(AccountFlag) {

        var vm = this;

        vm.accountFlags = [];

        loadAll();

        function loadAll() {
            AccountFlag.query(function(result) {
                vm.accountFlags = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountAgreementDialogController', AccountAgreementDialogController);

    AccountAgreementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'AccountAgreement', 'MlcAccount', 'UserAgreement'];

    function AccountAgreementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, AccountAgreement, MlcAccount, UserAgreement) {
        var vm = this;

        vm.accountAgreement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.accounts = MlcAccount.query({filter: 'accountagreement-is-null'});
        $q.all([vm.accountAgreement.$promise, vm.accounts.$promise]).then(function() {
            if (!vm.accountAgreement.account || !vm.accountAgreement.account.id) {
                return $q.reject();
            }
            return MlcAccount.get({id : vm.accountAgreement.account.id}).$promise;
        }).then(function(account) {
            vm.accounts.push(account);
        });
        vm.agreements = UserAgreement.query({filter: 'accountagreement-is-null'});
        $q.all([vm.accountAgreement.$promise, vm.agreements.$promise]).then(function() {
            if (!vm.accountAgreement.agreement || !vm.accountAgreement.agreement.id) {
                return $q.reject();
            }
            return UserAgreement.get({id : vm.accountAgreement.agreement.id}).$promise;
        }).then(function(agreement) {
            vm.agreements.push(agreement);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.accountAgreement.id !== null) {
                AccountAgreement.update(vm.accountAgreement, onSaveSuccess, onSaveError);
            } else {
                AccountAgreement.save(vm.accountAgreement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mlcccApp:accountAgreementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountAgreementDetailController', AccountAgreementDetailController);

    AccountAgreementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AccountAgreement', 'MlcAccount', 'UserAgreement'];

    function AccountAgreementDetailController($scope, $rootScope, $stateParams, previousState, entity, AccountAgreement, MlcAccount, UserAgreement) {
        var vm = this;

        vm.accountAgreement = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mlcccApp:accountAgreementUpdate', function(event, result) {
            vm.accountAgreement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountAgreementDeleteController',AccountAgreementDeleteController);

    AccountAgreementDeleteController.$inject = ['$uibModalInstance', 'entity', 'AccountAgreement'];

    function AccountAgreementDeleteController($uibModalInstance, entity, AccountAgreement) {
        var vm = this;

        vm.accountAgreement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AccountAgreement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('account-agreement', {
            parent: 'entity',
            url: '/account-agreement',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AccountAgreements'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/account-agreement/account-agreements.html',
                    controller: 'AccountAgreementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('account-agreement-detail', {
            parent: 'account-agreement',
            url: '/account-agreement/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AccountAgreement'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/account-agreement/account-agreement-detail.html',
                    controller: 'AccountAgreementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'AccountAgreement', function($stateParams, AccountAgreement) {
                    return AccountAgreement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'account-agreement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('account-agreement-detail.edit', {
            parent: 'account-agreement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-agreement/account-agreement-dialog.html',
                    controller: 'AccountAgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccountAgreement', function(AccountAgreement) {
                            return AccountAgreement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('account-agreement.new', {
            parent: 'account-agreement',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-agreement/account-agreement-dialog.html',
                    controller: 'AccountAgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('account-agreement', null, { reload: 'account-agreement' });
                }, function() {
                    $state.go('account-agreement');
                });
            }]
        })
        .state('account-agreement.edit', {
            parent: 'account-agreement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-agreement/account-agreement-dialog.html',
                    controller: 'AccountAgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccountAgreement', function(AccountAgreement) {
                            return AccountAgreement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('account-agreement', null, { reload: 'account-agreement' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('account-agreement.delete', {
            parent: 'account-agreement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/account-agreement/account-agreement-delete-dialog.html',
                    controller: 'AccountAgreementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AccountAgreement', function(AccountAgreement) {
                            return AccountAgreement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('account-agreement', null, { reload: 'account-agreement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('AccountAgreement', AccountAgreement);

    AccountAgreement.$inject = ['$resource', 'DateUtils'];

    function AccountAgreement ($resource, DateUtils) {
        var resourceUrl =  'api/account-agreements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertLocalDateFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createDate = DateUtils.convertLocalDateToServer(copy.createDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createDate = DateUtils.convertLocalDateToServer(copy.createDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AccountAgreementController', AccountAgreementController);

    AccountAgreementController.$inject = ['AccountAgreement'];

    function AccountAgreementController(AccountAgreement) {

        var vm = this;

        vm.accountAgreements = [];

        loadAll();

        function loadAll() {
            AccountAgreement.query(function(result) {
                vm.accountAgreements = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('mlcccApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('mlcccApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('mlcccApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('EmailController',EmailController);

    EmailController.$inject = ['$uibModalInstance', 'Email','$stateParams', 'entity'];

    function EmailController($uibModalInstance, Email, $stateParams, entity) {
        var vm = this;
        vm.clear = clear;
        vm.send = send;
        vm.email = {'recipients':'', 'subject':'', 'content':''}
        if(entity){
            if(entity.to){
                if(entity.to === 'All Parents'){
                    vm.email.recipients = 'All Parents';
                } else {
                    vm.email.recipients = entity.to;
                }
            } else if (entity.account) {
                vm.email.recipients = entity.account.email;
            }
            vm.email.cc = entity.cc;
            vm.email.bcc = entity.bcc;
            vm.email.subject = entity.subject;
        }
        vm.onSuccess = onSuccess;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function send(){
            Email.setParameter(
                {
                    'recipients':vm.email.recipients,
                    'cc':vm.email.cc,
                    'bcc':vm.email.bcc,
                    'subject':vm.email.subject,
                    'content':vm.email.content
                });
            Email.send().sendEmail(null, onSuccess, onError);
        }

        function onSuccess(result){
            $uibModalInstance.close(true);
        }

        function onError(data){
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('mlcccApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('mlcccApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('mlcccApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('mlcccApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'mlccc' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('mlcccApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('mlcccApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1792953211244)
;
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserManagementResetController', UserManagementResetController);

    UserManagementResetController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementResetController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.clear = clear;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.user = entity;

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                vm.user.password = vm.password;
                User.update(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'SchoolDistrict'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, SchoolDistrict) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_TEACHER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.schoolDistricts = [];

        loadSchoolDistricts();

        function loadSchoolDistricts() {
            SchoolDistrict.query(function(result) {
                vm.schoolDistricts = result;
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                    };
                }]
            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'mlccc'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.reset-password', {
            url: '/{login}/reset',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-reset.html',
                    controller: 'UserManagementResetController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.email', {
            parent: 'user-management',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/email/email.html',
                    controller: 'EmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {to: 'All Users'}
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: 'user-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.emailUser', {
            parent: 'user-management',
            url: '{email}/email',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/email/email.html',
                    controller: 'EmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {to: $stateParams.email}
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: 'user-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER','ROLE_TEACHER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.searchUser = searchUser;
        vm.searchTerm = pagingParams.search;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search: pagingParams.search
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.searchTerm
            });
        }

        function searchUser(){
            User.search({search:vm.searchTerm+'%'}, onSuccess, onError);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('mlcccApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'SchoolDistrict'];

    function SettingsController (Principal, Auth, SchoolDistrict) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.schoolDistricts = [];

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                address: account.address,
                city: account.city,
                state: account.state,
                zip: account.zip,
                phone: account.phone,
                schoolDistrict: account.schoolDistrict
            };
        };
        //load all school districts
        loadSchoolDistricts();

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }

        function loadSchoolDistricts() {
            SchoolDistrict.query(function(result) {
                vm.schoolDistricts = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService', 'SchoolDistrict'];

    function RegisterController ($timeout, Auth, LoginService, SchoolDistrict) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        vm.schoolDistricts = [];

        loadSchoolDistricts();

        function loadSchoolDistricts() {
            SchoolDistrict.query(function(result) {
                vm.schoolDistricts = result;
            });
        }

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('mlcccApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-2"></div><div class="col-md-8"><h1 style="color:#ff0000">Welcome To MLCCC !</h1><img src="content/images/home-bg.png" width="723px"><br><br><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true">You are logged in as user "{{vm.account.login}}".</div><div class="alert alert-warning" ng-switch-when="false">You can <a class="alert-link" href="" ng-click="vm.login()"><b style="color: brown;font-size: medium">sign in</b></a> here.</div><div class="alert alert-warning" ng-switch-when="false">You don\'t have an account yet? <a class="alert-link" ui-sref="register" style="color: brown;font-size: medium">Register a new account</a></div></div><!--\n            <div id="paypal-button"></div>\n            <script>\n                paypal.Button.render({\n                    env: \'sandbox\',\n                    client: {\n                        sandbox: \'demo_sandbox_client_id\'\n                    },\n                    payment: function (data, actions) {\n                        return actions.payment.create({\n                            transactions: [{\n                                amount: {\n                                    total: \'0.01\',\n                                    currency: \'USD\'\n                                }\n                            }]\n                        });\n                    },\n                    onAuthorize: function (data, actions) {\n                        return actions.payment.execute()\n                            .then(function () {\n                                window.alert(\'Thank you for your purchase!\');\n                            });\n                    }\n                }, \'#paypal-button\');\n            </script> --></div><div class="col-md-2"></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Registration</h1><div class="alert alert-success" ng-show="vm.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="Your username" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@a-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="login">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your First Name" ng-model="vm.registerAccount.firstName" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z]*$/" required><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.firstName.$error.pattern">Your first name can only contain letters.</p></div></div><div class="form-group"><label class="control-label" for="login">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your Last Name" ng-model="vm.registerAccount.lastName" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z]*$/" required><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.lastName.$error.pattern">Your last name can only contain letters.</p></div></div><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label">Phone</label><input type="number" class="form-control" name="phone" placeholder="Your phone (numbers only)" ng-model="vm.registerAccount.phone" required ng-maxlength="10" ng-minlength="10"><div ng-show="form.phone.$dirty && form.phone.$invalid"><p class="help-block" ng-show="form.phone.$error.required">Your phone is required.</p><p class="help-block" ng-show="form.phone.$error.maxlength">Your phone cannot be longer than 10 characters.</p><p class="help-block" ng-show="form.phone.$error.minlength">Your phone cannot be shorter than 10 characters.</p><p class="help-block" ng-show="form.phone.$error.number">Phone field should be number only.</p></div></div><div class="form-group"><label class="control-label">Select a school district</label><select class="form-control" id="field_school_district" name="schoolDistrict" ng-model="vm.registerAccount.schoolDistrict" ng-options="schoolDistrict as schoolDistrict.name for schoolDistrict in vm.schoolDistricts track by schoolDistrict.id" required><option value=""></option></select></div><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button></form><p></p></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div><label class="control-label" for="address">Street Address</label><input type="text" class="form-control" id="address" name="address" placeholder="Street Address" ng-model="vm.settingsAccount.address" ng-minlength="5" ng-maxlength="500" maxlength="500"><label class="control-label" for="city">City</label><input type="text" class="form-control" id="city" name="city" placeholder="City" ng-model="vm.settingsAccount.city" ng-minlength="5" ng-maxlength="500" maxlength="500"><label class="control-label" for="state">State</label><input type="text" class="form-control" id="state" name="state" placeholder="State" ng-model="vm.settingsAccount.state" ng-minlength="2" ng-maxlength="500" maxlength="500"><label class="control-label" for="zip">Zip</label><input type="text" class="form-control" id="zip" name="zip" placeholder="Zip" ng-model="vm.settingsAccount.zip" ng-minlength="5" ng-maxlength="500" maxlength="500"><label class="control-label" for="phone">Phone</label><input type="phone" class="form-control" id="phone" name="phone" placeholder="phone" ng-model="vm.settingsAccount.phone" ng-minlength="10" ng-maxlength="10" maxlength="10"><label class="control-label" for="schoolDistrict">School District</label><select class="form-control" id="field_schoolDistrict" name="schoolDistrict" ng-model="vm.settingsAccount.schoolDistrict" ng-options="schoolDistrict as schoolDistrict.name for schoolDistrict in vm.schoolDistricts track by schoolDistrict.id"><option value="">Select School District</option></select></div><p></p><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button> <button class="btn btn-primary" ui-sref="student.new"><span class="glyphicon glyphicon-flash"></span> <span>Add a student</span></button></form></div></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length === 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length === 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3>Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Cache name</th><th class="text-right">Cache Hits</th><th class="text-right">Cache Misses</th><th class="text-right">Cache Gets</th><th class="text-right">Cache Puts</th><th class="text-right">Cache Removals</th><th class="text-right">Cache Evictions</th><th class="text-right">Cache Hit %</th><th class="text-right">Cache Miss %</th><th class="text-right">Average get time (\xB5s)</th><th class="text-right">Average put time (\xB5s)</th><th class="text-right">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> [<b>{{vm.user.login}}</b>]</h2><hr><div class="container"><div class="left-half dl-horizontal jh-entity-details"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated">Activated</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></div><div class="right-half dl-horizontal jh-entity-details"><dt><span>Address</span></dt><dd>{{vm.user.address}}</dd><dt><span>City</span></dt><dd>{{vm.user.city}}</dd><dt><span>State</span></dt><dd>{{vm.user.state}}</dd><dt><span>Zip</span></dt><dd>{{vm.user.zip}}</dd><dt><span>Phone</span></dt><dd>{{vm.user.phone}}</dd><dt><span>School District</span></dt><dd>{{vm.user.schoolDistrict.name}}</dd><dt><span>Credit</span></dt><dd>{{vm.user.credit | currency:"$"}}</dd></div></div><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your email is invalid.</p></div></div><div class="form-group"><label class="control-label">Phone</label><input type="text" class="form-control" name="phone" placeholder="numbers only" ng-model="vm.user.phone" required ng-maxlength="10" ng-minlength="10" ng-pattern="/^[0-9]{1,10}$/"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.phone.$error.maxlength">This field cannot be longer than 10 characters.</p><p class="help-block" ng-show="editForm.phone.$error.minlength">This field cannot be shorter than 10 characters.</p><p class="help-block" ng-show="editForm.phone.$error.pattern">Phone field should be number only.</p></div></div><div class="form-group"><label class="control-label">Select a school district</label><select class="form-control" id="field_school_district" name="schoolDistrict" ng-model="vm.user.schoolDistrict" ng-options="schoolDistrict as schoolDistrict.name for schoolDistrict in vm.schoolDistricts track by schoolDistrict.id"><option value=""></option></select></div><div class="form-group"><label class="control-label">Credit</label><input type="number" min="0" class="form-control" name="credit" id="credit" ng-model="vm.user.credit"><div ng-show="editForm.credit.$invalid"><p class="help-block" ng-show="editForm.credit.$error.number">This field should be a number.</p></div></div><div class="form-group"><label for="activated"><input type="checkbox" id="primaryContact" name="primaryContact" ng-model="vm.user.primaryContact"> <span>Is Primary Contact</span></label></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-reset.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.user.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="editForm" role="form" novalidate ng-submit="changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-click="vm.changePassword()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form></div></div></div>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-6"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div><div class="col-md-4"><form name="searchForm" role="form" novalidate ng-submit="vm.searchUser()"><div class="form-group has-feedback"><input type="search" class="form-control" placeholder="Search User by Name" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"> <i class="glyphicon glyphicon-search form-control-feedback"></i></div></form></div><div class="col-sm-2" has-authority="ROLE_ADMIN"><button class="btn btn-primary" ui-sref="user-management.email"><span class="glyphicon glyphicon-envelope"></span> <span>Send Email</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--<th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span>Profiles</span></th><th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastLoginDate"><span>Last Login Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><!--<td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td>--><td><a ui-sref="user-management-detail({login:user.login})">{{user.login}}</a></td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login">Activated</button></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastLoginDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn btn-primary" ui-sref="user-management.emailUser({email: user.email})"><span class="glyphicon glyphicon-envelope"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.reset-password({login:user.login})" class="btn btn-primary btn-sm"><span class="hidden-xs hidden-sm"></span> <span>Reset Password</span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/email/email.html','<form name="editForm" role="form" novalidate ng-submit="vm.send()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTeacherLabel">Send Email</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="recipients">To</label><input type="text" class="form-control" id="recipients" name="recipients" ng-model="vm.email.recipients"></div><div class="form-group"><label for="cc">CC</label><input type="text" class="form-control" id="cc" name="cc" ng-model="vm.email.cc"></div><div class="form-group"><label for="bcc">BCC</label><input type="text" class="form-control" id="bcc" name="bcc" ng-model="vm.email.bcc"></div><div class="form-group"><label for="subject">Subject</label><input type="text" class="form-control" id="subject" name="subject" ng-model="vm.email.subject"></div><div class="form-group"><label class="control-label" for="field_content">Content</label><textarea rows="10" class="form-control" name="content" id="field_content" ng-model="vm.email.content"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-envelope"></span>&nbsp;<span>Send</span></button></div></form>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username">Username</label><input type="text" class="form-control" id="username" placeholder="Your username" ng-model="vm.username"></div><div class="form-group"><label for="password">Password</label><input type="password" class="form-control" id="password" placeholder="Your password" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()">Did you forget your password?</a></div><div class="alert alert-warning">You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/entities/account-agreement/account-agreement-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.accountAgreement.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Account Agreement?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/account-agreement/account-agreement-detail.html','<div><h2><span>Account Agreement</span> {{vm.accountAgreement.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Create Date</span></dt><dd><span>{{vm.accountAgreement.createDate | date:\'mediumDate\'}}</span></dd><dt><span>Account</span></dt><dd><a ui-sref="mlc-account-detail({id:vm.accountAgreement.account.id})">{{vm.accountAgreement.account.id}}</a></dd><dt><span>Agreement</span></dt><dd><a ui-sref="user-agreement-detail({id:vm.accountAgreement.agreement.id})">{{vm.accountAgreement.agreement.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="account-agreement-detail.edit({id:vm.accountAgreement.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/account-agreement/account-agreement-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAccountAgreementLabel">Create or edit a Account Agreement</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.accountAgreement.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.accountAgreement.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_createDate">Create Date</label><div class="input-group"><input id="field_createDate" type="text" class="form-control" name="createDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.accountAgreement.createDate" is-open="vm.datePickerOpenStatus.createDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_account">Account</label><select class="form-control" id="field_account" name="account" ng-model="vm.accountAgreement.account" ng-options="mlcAccount as mlcAccount.id for mlcAccount in vm.accounts | orderBy:\'id\' track by mlcAccount.id"><option value=""></option></select></div><div class="form-group"><label for="field_agreement">Agreement</label><select class="form-control" id="field_agreement" name="agreement" ng-model="vm.accountAgreement.agreement" ng-options="userAgreement as userAgreement.id for userAgreement in vm.agreements | orderBy:\'id\' track by userAgreement.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/account-agreement/account-agreements.html','<div><h2>Account Agreements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="account-agreement.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Account Agreement</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Create Date</span></th><th><span>Account</span></th><th><span>Agreement</span></th><th></th></tr></thead><tbody><tr ng-repeat="accountAgreement in vm.accountAgreements track by accountAgreement.id"><td><a ui-sref="account-agreement-detail({id:accountAgreement.id})">{{accountAgreement.id}}</a></td><td>{{accountAgreement.createDate | date:\'mediumDate\'}}</td><td><a ui-sref="mlc-account-detail({id:accountAgreement.account.id})">{{accountAgreement.account.id}}</a></td><td><a ui-sref="user-agreement-detail({id:accountAgreement.agreement.id})">{{accountAgreement.agreement.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="account-agreement-detail({id:accountAgreement.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="account-agreement.edit({id:accountAgreement.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="account-agreement.delete({id:accountAgreement.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/account-flag/account-flag-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.accountFlag.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Account Flag?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/account-flag/account-flag-detail.html','<div><h2><span>Account Flag</span> {{vm.accountFlag.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Flag Type</span></dt><dd><span>{{vm.accountFlag.flagType}}</span></dd><dt><span>Related Key</span></dt><dd><span>{{vm.accountFlag.relatedKey}}</span></dd><dt><span>Account</span></dt><dd><a ui-sref="mlc-account-detail({id:vm.accountFlag.account.id})">{{vm.accountFlag.account.id}}</a></dd><dt><span>Flag Status</span></dt><dd><a ui-sref="account-flag-status-detail({id:vm.accountFlag.flagStatus.id})">{{vm.accountFlag.flagStatus.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="account-flag-detail.edit({id:vm.accountFlag.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/account-flag/account-flag-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAccountFlagLabel">Create or edit a Account Flag</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.accountFlag.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.accountFlag.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_flagType">Flag Type</label><input type="text" class="form-control" name="flagType" id="field_flagType" ng-model="vm.accountFlag.flagType"></div><div class="form-group"><label class="control-label" for="field_relatedKey">Related Key</label><input type="number" class="form-control" name="relatedKey" id="field_relatedKey" ng-model="vm.accountFlag.relatedKey"></div><div class="form-group"><label for="field_account">Account</label><select class="form-control" id="field_account" name="account" ng-model="vm.accountFlag.account" ng-options="mlcAccount as mlcAccount.id for mlcAccount in vm.mlcaccounts track by mlcAccount.id"><option value=""></option></select></div><div class="form-group"><label for="field_flagStatus">Flag Status</label><select class="form-control" id="field_flagStatus" name="flagStatus" ng-model="vm.accountFlag.flagStatus" ng-options="accountFlagStatus as accountFlagStatus.id for accountFlagStatus in vm.accountflagstatuses track by accountFlagStatus.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/account-flag/account-flags.html','<div><h2>Account Flags</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="account-flag.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Account Flag</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Flag Type</span></th><th><span>Related Key</span></th><th><span>Account</span></th><th><span>Flag Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="accountFlag in vm.accountFlags track by accountFlag.id"><td><a ui-sref="account-flag-detail({id:accountFlag.id})">{{accountFlag.id}}</a></td><td>{{accountFlag.flagType}}</td><td>{{accountFlag.relatedKey}}</td><td><a ui-sref="mlc-account-detail({id:accountFlag.account.id})">{{accountFlag.account.id}}</a></td><td><a ui-sref="account-flag-status-detail({id:accountFlag.flagStatus.id})">{{accountFlag.flagStatus.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="account-flag-detail({id:accountFlag.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="account-flag.edit({id:accountFlag.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="account-flag.delete({id:accountFlag.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/account-flag-status/account-flag-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.accountFlagStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Account Flag Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/account-flag-status/account-flag-status-detail.html','<div><h2><span>Account Flag Status</span> {{vm.accountFlagStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Description</span></dt><dd><span>{{vm.accountFlagStatus.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="account-flag-status-detail.edit({id:vm.accountFlagStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/account-flag-status/account-flag-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAccountFlagStatusLabel">Create or edit a Account Flag Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.accountFlagStatus.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.accountFlagStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.accountFlagStatus.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/account-flag-status/account-flag-statuses.html','<div><h2>Account Flag Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="account-flag-status.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Account Flag Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Description</span></th><th></th></tr></thead><tbody><tr ng-repeat="accountFlagStatus in vm.accountFlagStatuses track by accountFlagStatus.id"><td><a ui-sref="account-flag-status-detail({id:accountFlagStatus.id})">{{accountFlagStatus.id}}</a></td><td>{{accountFlagStatus.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="account-flag-status-detail({id:accountFlagStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="account-flag-status.edit({id:accountFlagStatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="account-flag-status.delete({id:accountFlagStatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/applied-discount/applied-discount-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.appliedDiscount.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Applied Discount?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/applied-discount/applied-discount-detail.html','<div><h2><span>Applied Discount</span> {{vm.appliedDiscount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Created Date</span></dt><dd><span>{{vm.appliedDiscount.createdDate | date:\'mediumDate\'}}</span></dd><dt><span>Modified Date</span></dt><dd><span>{{vm.appliedDiscount.modifiedDate | date:\'mediumDate\'}}</span></dd><dt><span>Discount</span></dt><dd><a ui-sref="discount-detail({id:vm.appliedDiscount.discount.id})">{{vm.appliedDiscount.discount.id}}</a></dd><dt><span>Registration</span></dt><dd><a ui-sref="registration-detail({id:vm.appliedDiscount.registration.id})">{{vm.appliedDiscount.registration.id}}</a></dd><dt><span>Invoice</span></dt><dd><a ui-sref="invoice-detail({id:vm.appliedDiscount.invoice.id})">{{vm.appliedDiscount.invoice.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="applied-discount-detail.edit({id:vm.appliedDiscount.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/applied-discount/applied-discount-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAppliedDiscountLabel">Create or edit a Applied Discount</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.appliedDiscount.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.appliedDiscount.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.appliedDiscount.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_modifiedDate">Modified Date</label><div class="input-group"><input id="field_modifiedDate" type="text" class="form-control" name="modifiedDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.appliedDiscount.modifiedDate" is-open="vm.datePickerOpenStatus.modifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'modifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_discount">Discount</label><select class="form-control" id="field_discount" name="discount" ng-model="vm.appliedDiscount.discount" ng-options="discount as discount.id for discount in vm.discounts track by discount.id"><option value=""></option></select></div><div class="form-group"><label for="field_registration">Registration</label><select class="form-control" id="field_registration" name="registration" ng-model="vm.appliedDiscount.registration" ng-options="registration as registration.id for registration in vm.registrations track by registration.id"><option value=""></option></select></div><div class="form-group"><label for="field_invoice">Invoice</label><select class="form-control" id="field_invoice" name="invoice" ng-model="vm.appliedDiscount.invoice" ng-options="invoice as invoice.id for invoice in vm.invoices track by invoice.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/applied-discount/applied-discounts.html','<div><h2>Applied Discounts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="applied-discount.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Applied Discount</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Created Date</span></th><th><span>Modified Date</span></th><th><span>Discount</span></th><th><span>Registration</span></th><th><span>Invoice</span></th><th></th></tr></thead><tbody><tr ng-repeat="appliedDiscount in vm.appliedDiscounts track by appliedDiscount.id"><td><a ui-sref="applied-discount-detail({id:appliedDiscount.id})">{{appliedDiscount.id}}</a></td><td>{{appliedDiscount.createdDate | date:\'mediumDate\'}}</td><td>{{appliedDiscount.modifiedDate | date:\'mediumDate\'}}</td><td><a ui-sref="discount-detail({id:appliedDiscount.discount.id})">{{appliedDiscount.discount.id}}</a></td><td><a ui-sref="registration-detail({id:appliedDiscount.registration.id})">{{appliedDiscount.registration.id}}</a></td><td><a ui-sref="invoice-detail({id:appliedDiscount.invoice.id})">{{appliedDiscount.invoice.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="applied-discount-detail({id:appliedDiscount.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="applied-discount.edit({id:appliedDiscount.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="applied-discount.delete({id:appliedDiscount.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/class-room/class-room-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.classRoom.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Class Room?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/class-room/class-room-detail.html','<div><h2><span>Class Room</span> {{vm.classRoom.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Room Number</span></dt><dd><span>{{vm.classRoom.roomNumber}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.classRoom.description}}</span></dd><dt><span>Project Available</span></dt><dd><span>{{vm.classRoom.projectAvailable}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="class-room-detail.edit({id:vm.classRoom.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/class-room/class-room-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myClassRoomLabel">Create or edit a Class Room</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.classRoom.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.classRoom.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_roomNumber">Room Number</label><input type="number" class="form-control" name="roomNumber" id="field_roomNumber" ng-model="vm.classRoom.roomNumber"></div><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.classRoom.description"></div><div class="form-group"><label class="control-label" for="field_projectAvailable">Project Available</label><input type="checkbox" name="projectAvailable" id="field_projectAvailable" ng-model="vm.classRoom.projectAvailable"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/class-room/class-rooms.html','<div><h2>Class Rooms</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="class-room.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Class Room</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Room Number</span></th><th><span>Description</span></th><th><span>Project Available</span></th><th></th></tr></thead><tbody><tr ng-repeat="classRoom in vm.classRooms track by classRoom.id"><td><a ui-sref="class-room-detail({id:classRoom.id})">{{classRoom.id}}</a></td><td>{{classRoom.roomNumber}}</td><td>{{classRoom.description}}</td><td>{{classRoom.projectAvailable}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="class-room-detail({id:classRoom.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="class-room.edit({id:classRoom.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="class-room.delete({id:classRoom.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/class-status/class-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.classStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Class Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/class-status/class-status-detail.html','<div><h2><span>Class Status</span> {{vm.classStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Status</span></dt><dd><span>{{vm.classStatus.status}}</span></dd><dt><span>Color Displayed</span></dt><dd><span>{{vm.classStatus.colorDisplayed}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="class-status-detail.edit({id:vm.classStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/class-status/class-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myClassStatusLabel">Create or edit a Class Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.classStatus.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.classStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.classStatus.status"></div><div class="form-group"><label class="control-label" for="field_colorDisplayed">Color Displayed</label><input type="text" class="form-control" name="colorDisplayed" id="field_colorDisplayed" ng-model="vm.classStatus.colorDisplayed"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/class-status/class-statuses.html','<div><h2>Class Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="class-status.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Class Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Status</span></th><th><span>Color Displayed</span></th><th></th></tr></thead><tbody><tr ng-repeat="classStatus in vm.classStatuses track by classStatus.id"><td><a ui-sref="class-status-detail({id:classStatus.id})">{{classStatus.id}}</a></td><td>{{classStatus.status}}</td><td>{{classStatus.colorDisplayed}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="class-status-detail({id:classStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="class-status.edit({id:classStatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="class-status.delete({id:classStatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/class-time/class-time-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.classTime.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Class Time?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/class-time/class-time-detail.html','<div><h2><span>Class Time</span> {{vm.classTime.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Class Time</span></dt><dd><span>{{vm.classTime.classTime}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="class-time-detail.edit({id:vm.classTime.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/class-time/class-time-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myClassTimeLabel">Create or edit a Class Time</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.classTime.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.classTime.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_classTime">Class Time</label><input type="text" class="form-control" name="classTime" id="field_classTime" ng-model="vm.classTime.classTime"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/class-time/class-times.html','<div><h2>Class Times</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="class-time.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Class Time</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Class Time</span></th><th></th></tr></thead><tbody><tr ng-repeat="classTime in vm.classTimes track by classTime.id"><td><a ui-sref="class-time-detail({id:classTime.id})">{{classTime.id}}</a></td><td>{{classTime.classTime}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="class-time-detail({id:classTime.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="class-time.edit({id:classTime.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="class-time.delete({id:classTime.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/contact/contact-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.contact.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Contact?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/contact/contact-detail.html','<div><h2><span>Contact</span> {{vm.contact.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Address</span></dt><dd><span>{{vm.contact.address}}</span></dd><dt><span>City</span></dt><dd><span>{{vm.contact.city}}</span></dd><dt><span>State</span></dt><dd><span>{{vm.contact.state}}</span></dd><dt><span>Zip</span></dt><dd><span>{{vm.contact.zip}}</span></dd><dt><span>Phone</span></dt><dd><span>{{vm.contact.phone}}</span></dd><dt><span>Fax</span></dt><dd><span>{{vm.contact.fax}}</span></dd><dt><span>School District</span></dt><dd><a ui-sref="school-district-detail({id:vm.contact.schoolDistrict.id})">{{vm.contact.schoolDistrict.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="contact-detail.edit({id:vm.contact.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/contact/contact-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myContactLabel">Create or edit a Contact</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.contact.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.contact.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.contact.address"></div><div class="form-group"><label class="control-label" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.contact.city"></div><div class="form-group"><label class="control-label" for="field_state">State</label><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.contact.state"></div><div class="form-group"><label class="control-label" for="field_zip">Zip</label><input type="text" class="form-control" name="zip" id="field_zip" ng-model="vm.contact.zip"></div><div class="form-group"><label class="control-label" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.contact.phone"></div><div class="form-group"><label class="control-label" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.contact.fax"></div><div class="form-group"><label for="field_schoolDistrict">School District</label><select class="form-control" id="field_schoolDistrict" name="schoolDistrict" ng-model="vm.contact.schoolDistrict" ng-options="schoolDistrict as schoolDistrict.id for schoolDistrict in vm.schooldistricts track by schoolDistrict.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/contact/contacts.html','<div><h2>Contacts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="contact.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Contact</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Address</span></th><th><span>City</span></th><th><span>State</span></th><th><span>Zip</span></th><th><span>Phone</span></th><th><span>Fax</span></th><th><span>School District</span></th><th></th></tr></thead><tbody><tr ng-repeat="contact in vm.contacts track by contact.id"><td><a ui-sref="contact-detail({id:contact.id})">{{contact.id}}</a></td><td>{{contact.address}}</td><td>{{contact.city}}</td><td>{{contact.state}}</td><td>{{contact.zip}}</td><td>{{contact.phone}}</td><td>{{contact.fax}}</td><td><a ui-sref="school-district-detail({id:contact.schoolDistrict.id})">{{contact.schoolDistrict.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="contact-detail({id:contact.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="contact.edit({id:contact.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="contact.delete({id:contact.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/discount/discount-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.discount.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Discount?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/discount/discount-detail.html','<div><h2><span>Discount</span> {{vm.discount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Amount</span></dt><dd><span>{{vm.discount.amount | currency:"$"}}</span></dd><dt><span>Percentage</span></dt><dd><span>{{vm.discount.percentage}}</span></dd><dt><span>Start Date</span></dt><dd><span>{{vm.discount.startDate | date:\'mediumDate\'}}</span></dd><dt><span>End Date</span></dt><dd><span>{{vm.discount.endDate | date:\'mediumDate\'}}</span></dd><dt><span>Discount Code</span></dt><dd><a ui-sref="discount-code-detail({id:vm.discount.discountCode.id})">{{vm.discount.discountCode.code}}</a></dd><dt><span>School Term</span></dt><dd><a ui-sref="school-term-detail({id:vm.discount.schoolTerm.id})">{{vm.discount.schoolTerm.term}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="discount-detail.edit({id:vm.discount.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/discount/discount-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDiscountLabel">Create or edit a Discount</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.discount.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.discount.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_amount">Amount</label><input type="number" min="0.00" class="form-control" name="amount" id="field_amount" ng-model="vm.discount.amount"><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_percentage">Percentage</label><input type="number" min="0.00" class="form-control" name="percentage" id="field_percentage" ng-model="vm.discount.percentage"><div ng-show="editForm.percentage.$invalid"><p class="help-block" ng-show="editForm.percentage.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.discount.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.discount.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_discountCode">Discount Code</label><select class="form-control" id="field_discountCode" name="discountCode" ng-model="vm.discount.discountCode" ng-options="discountCode as discountCode.code for discountCode in vm.discountcodes track by discountCode.id"><option value=""></option></select></div><div class="form-group"><label for="field_schoolTerm">School Term</label><select class="form-control" id="field_schoolTerm" name="schoolTerm" ng-model="vm.discount.schoolTerm" ng-options="schoolTerm as schoolTerm.term for schoolTerm in vm.schoolterms track by schoolTerm.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/discount/discounts.html','<div><h2>Discounts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="discount.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Discount</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Amount</span></th><th><span>Percentage</span></th><th><span>Start Date</span></th><th><span>End Date</span></th><th><span>Discount Code</span></th><th><span>School Term</span></th><th></th></tr></thead><tbody><tr ng-repeat="discount in vm.discounts track by discount.id"><td><a ui-sref="discount-detail({id:discount.id})">{{discount.id}}</a></td><td><span ng-switch="{{discount.amount}} != null"><span ng-switch-when="true">{{discount.amount | currency:"$"}}</span></span></td><td><span ng-switch="{{discount.percentage}} != null"><span ng-switch-when="true">{{discount.percentage}}%</span></span></td><td>{{discount.startDate | date:\'mediumDate\'}}</td><td>{{discount.endDate | date:\'mediumDate\'}}</td><td><a ui-sref="discount-code-detail({id:discount.discountCode.id})">{{discount.discountCode.code}}</a></td><td><a ui-sref="school-term-detail({id:discount.schoolTerm.id})">{{discount.schoolTerm.term}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="discount.edit({id:discount.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="discount.delete({id:discount.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/discount-code/discount-code-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.discountCode.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Discount Code?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/discount-code/discount-code-detail.html','<div><h2><span>Discount Code</span> {{vm.discountCode.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Code</span></dt><dd><span>{{vm.discountCode.code}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.discountCode.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="discount-code-detail.edit({id:vm.discountCode.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/discount-code/discount-code-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDiscountCodeLabel">Create or edit a Discount Code</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.discountCode.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.discountCode.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.discountCode.code" required><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.discountCode.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/discount-code/discount-codes.html','<div><h2>Discount Codes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="discount-code.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Discount Code</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Code</span></th><th><span>Description</span></th><th></th></tr></thead><tbody><tr ng-repeat="discountCode in vm.discountCodes track by discountCode.id"><td><a ui-sref="discount-code-detail({id:discountCode.id})">{{discountCode.id}}</a></td><td>{{discountCode.code}}</td><td>{{discountCode.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="discount-code-detail({id:discountCode.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="discount-code.edit({id:discountCode.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="discount-code.delete({id:discountCode.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/mlc-account/mlc-account-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.mlcAccount.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Mlc Account?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/mlc-account/mlc-account-detail.html','<div><h2><span>Mlc Account</span> {{vm.mlcAccount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Email</span></dt><dd><span>{{vm.mlcAccount.email}}</span></dd><dt><span>Password</span></dt><dd><span>{{vm.mlcAccount.password}}</span></dd><dt><span>Create Date</span></dt><dd><span>{{vm.mlcAccount.createDate | date:\'mediumDate\'}}</span></dd><dt><span>Contact</span></dt><dd><a ui-sref="contact-detail({id:vm.mlcAccount.contact.id})">{{vm.mlcAccount.contact.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="mlc-account-detail.edit({id:vm.mlcAccount.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/mlc-account/mlc-account-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMlcAccountLabel">Create or edit a Mlc Account</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.mlcAccount.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.mlcAccount.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.mlcAccount.email"></div><div class="form-group"><label class="control-label" for="field_password">Password</label><input type="text" class="form-control" name="password" id="field_password" ng-model="vm.mlcAccount.password"></div><div class="form-group"><label class="control-label" for="field_createDate">Create Date</label><div class="input-group"><input id="field_createDate" type="text" class="form-control" name="createDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.mlcAccount.createDate" is-open="vm.datePickerOpenStatus.createDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_contact">Contact</label><select class="form-control" id="field_contact" name="contact" ng-model="vm.mlcAccount.contact" ng-options="contact as contact.id for contact in vm.contacts | orderBy:\'id\' track by contact.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/mlc-account/mlc-accounts.html','<div><h2>Mlc Accounts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="mlc-account.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Mlc Account</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="password"><span>Password</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createDate"><span>Create Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contact.id"><span>Contact</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="mlcAccount in vm.mlcAccounts track by mlcAccount.id"><td><a ui-sref="mlc-account-detail({id:mlcAccount.id})">{{mlcAccount.id}}</a></td><td>{{mlcAccount.email}}</td><td>{{mlcAccount.password}}</td><td>{{mlcAccount.createDate | date:\'mediumDate\'}}</td><td><a ui-sref="contact-detail({id:mlcAccount.contact.id})">{{mlcAccount.contact.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="mlc-account-detail({id:mlcAccount.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="mlc-account.edit({id:mlcAccount.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="mlc-account.delete({id:mlcAccount.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/invoice/invoice-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.invoice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Invoice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/invoice/invoice-detail.html','<div><h2><span>Invoice</span> {{vm.invoice.id}}</h2><div><div ng-if="vm.paymentNeeded"><button type="button" ui-sref="payment.new({invoiceId:vm.invoice.id})" class="btn btn-primary" ng-if="vm.paymentNeeded"><span class="glyphicon glyphicon-usd"></span> <span class="hidden-sm-down">Pay</span></button></div><div class="row"><div class="col-sm-10"><button class="btn btn-primary" ui-sref="payment.refund({invoiceId:vm.invoice.id})" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-usd"></span> <span class="hidden-sm-down">Refund</span></button></div><div class="col-sm-2"><button type="button" ui-sref="payment.invoice({invoiceId:vm.invoice.id})" class="btn btn-info" ng-if="vm.paymentMade"><span class="glyphicon glyphicon-usd"></span> <span class="hidden-sm-down">Payments</span></button></div></div></div><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Description</span></dt><dd><span>{{vm.invoice.description}}</span></dd><dt><span>Amount Due:</span><span style="color: red"> {{vm.invoice.total | currency:"$"}}</span></dt><dd><table class="jh-table table table-striped"><thead><th><span>Registration Fee</span></th><th ng-if="vm.invoice.summerCamp"><span>Multi Session Discount</span></th><th ng-if="vm.invoice.summerCamp"><span>Weekend School Student Discount</span></th><th ng-if="!vm.invoice.summerCamp"><span>Multi Class Discount</span></th><th ng-if="!vm.invoice.summerCamp"><span>Benefits</span></th><th><span>Credit</span></th><th><span>Admin Adjustment</span></th></thead><tbody><tr><td><span class="glyphicon glyphicon-plus"></span>{{vm.invoice.registrationFee | currency:"$"}}</td><td ng-if="vm.invoice.summerCamp"><span class="glyphicon glyphicon-minus"></span>{{vm.invoice.multiSessionDiscount | currency:"$"}}</td><td ng-if="vm.invoice.summerCamp"><span class="glyphicon glyphicon-minus"></span>{{vm.invoice.weekendSchoolStudentDiscount | currency:"$"}}</td><td ng-if="!vm.invoice.summerCamp"><span class="glyphicon glyphicon-minus"></span>{{vm.invoice.multiClassDiscount | currency:"$"}}</td><td ng-if="!vm.invoice.summerCamp"><span class="glyphicon glyphicon-minus"></span>{{vm.invoice.benefits | currency:"$"}}</td><td><span class="glyphicon glyphicon-minus"></span>{{vm.invoice.credit | currency:"$"}}</td><td><span class="glyphicon glyphicon-minus"></span>{{vm.invoice.adjustment | currency:"$"}}</td></tr></tbody></table><span></span></dd><dt><span>Status</span></dt><dd><span>{{vm.invoice.status}}</span></dd><dt><span>Comments</span></dt><dd><span>{{vm.invoice.comments}}</span></dd><dt><span>Invoice Date</span></dt><dd><span>{{vm.invoice.invoiceDate | date:\'mediumDate\'}}</span></dd><dt><span>Updated Date</span></dt><dd><span>{{vm.invoice.modifyDate | date:\'mediumDate\'}}</span></dd><dt has-authority="ROLE_ADMIN"><span>User</span></dt><dd has-authority="ROLE_ADMIN"><a ui-sref="user-management-detail({login:vm.invoice.billToUser.login})">{{vm.invoice.billToUser.login}}</a></dd><dt><span>Registration</span></dt><dd><div ng-switch="vm.invoice.registrations.length > 0"><div ng-switch-when="true"><table class="jh-table table table-striped"><tbody><tr ng-repeat="registration in vm.invoice.registrations track by registration.id"><td>{{registration.studentName}}</td><td>{{registration.mlcClassName}}</td><td>{{registration.mlcClassCategory}}</td><td>{{registration.classTime}}</td><td><span ng-class="{\'color-red\': registration.status === \'WITHDRAWN_NEED_REFUND\' || registration.status === \'WITHDRAWN_REFUNDED\',\n                                        \'color-green\': registration.status === \'CONFIRMED\',\'color-orange\': registration.status === \'PENDING\'}">{{registration.status}}</span></td><td>Tuition: {{registration.tuition | currency:"$"}}</td><td><div ng-switch="registration.status" has-authority="ROLE_ADMIN"><span ng-switch-when="CONFIRMED"><button class="btn btn-danger btn-sm" ui-sref="invoice.withdrawRegistration({id: vm.invoice.id, regId:registration.id})"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down">Withdraw</span></button></span></div></td><td><div ng-switch="registration.status" has-authority="ROLE_ADMIN"><span ng-switch-when="CONFIRMED"><button class="btn btn-warning btn-sm" ui-sref="invoice.switchClass({id: vm.invoice.id, regId:registration.id})"><span class="glyphicon glyphicon-adjust"></span> <span class="hidden-sm-down">Switch Class</span></button></span></div></td></tr></tbody></table></div></div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button><!--\n    <button type="button" ui-sref="invoice-detail.edit({id:vm.invoice.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-sm-down"> Edit</span>\n    </button>\n--><!--\n    <div id="paypal-button"></div>\n    <script>\n        paypal.Button.render({\n            env: \'sandbox\',\n            client: {\n                sandbox: \'demo_sandbox_client_id\'\n            },\n            payment: function (data, actions) {\n                return actions.payment.create({\n                    transactions: [{\n                        amount: {\n                            total: \'0.01\',\n                            currency: \'USD\'\n                        }\n                    }]\n                });\n            },\n            onAuthorize: function (data, actions) {\n                return actions.payment.execute()\n                        .then(function () {\n                            window.alert(\'Thank you for your purchase!\');\n                        });\n            }\n        }, \'#paypal-button\');\n    </script>--></div>');
$templateCache.put('app/entities/invoice/invoice-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInvoiceLabel">Create or edit a Invoice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.invoice.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.invoice.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.invoice.description"></div><div class="form-group"><label class="control-label" for="field_adjustment">Admin Adjustment</label><input type="number" min="0.00" class="form-control" name="adjustment" id="field_adjustment" ng-model="vm.invoice.adjustment"></div><div class="form-group"><label class="control-label" for="field_comments">Admin Comments</label><textarea placeholder="Administrator: put your comments about the adjustment for this invoice." class="form-control" name="comments" id="field_comments" ng-model="vm.invoice.comments"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/invoice/invoices.html','<div><h2>Invoices</h2><jhi-alert></jhi-alert><div class="container-fluid" has-authority="ROLE_ADMIN"><div class="row"><div class="col-xs-4 no-padding-left"><form name="searchForm" role="form" novalidate ng-submit="vm.searchInvoice()"><div class="form-group has-feedback"><input type="search" class="form-control" placeholder="Search Invoice by Student Name" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"> <i class="glyphicon glyphicon-search form-control-feedback"></i></div></form></div><div class="col-sm-8"><button type="submit" ng-click="vm.print(\'Unpaid Invoices\')" class="btn btn-primary btn-sm" style="margin-left: 640px"><span class="glyphicon glyphicon-print"></span> <span class="hidden-sm-down">Print</span></button></div></div><div class="row"><div class="col-xs-2 no-padding-left" has-authority="ROLE_ADMIN"><!--<label for="field_status">School Term</label>--><select class="form-control" id="field_school_term" name="school_term" ng-model="vm.schoolTerm" ng-options="schoolTerm as schoolTerm.term for schoolTerm in vm.schoolTerms track by schoolTerm.id" ng-change="vm.loadAll(vm.schoolTerm.id)"><option value="">Select School Term</option></select></div></div></div><br><div ng-if="vm.noRecord"><h3>You have no unpaid invoices.</h3></div><div id="print-section"><div ng-repeat="invoice in vm.invoices track by invoice.id"><div><table class="jh-table table table-striped"><thead><th has-authority="ROLE_ADMIN"><span>Bill to User</span></th><th><span>Status</span></th><th><span>Invoice Date</span></th><th><span>Registration Fee</span></th><th ng-if="!invoice.summerCamp"><span>Multi Class Discount</span></th><th ng-if="invoice.summerCamp"><span>Multi Session Discount</span></th><th ng-if="!invoice.summerCamp"><span>Benefit</span></th><th ng-if="invoice.summerCamp"><span>Weekend School Student Discount</span></th><th><span>Credit</span></th><th><span>Adjustment</span></th><th><span>Total</span></th><th></th></thead><tbody><tr><td has-authority="ROLE_ADMIN"><a ui-sref="user-management-detail({login:invoice.billToUser.login})">{{invoice.billToUser.firstName}} {{invoice.billToUser.lastName}}</a></td><td>{{invoice.status}}</td><td>{{invoice.invoiceDate | date:\'mediumDate\'}}</td><td>{{invoice.registrationFee | currency:"$"}}</td><td ng-if="!invoice.summerCamp">{{invoice.multiClassDiscount | currency:"$"}}</td><td ng-if="invoice.summerCamp">{{invoice.multiSessionDiscount | currency:"$"}}</td><td ng-if="!invoice.summerCamp">{{invoice.benefits | currency:"$"}}</td><td ng-if="invoice.summerCamp">{{invoice.weekendSchoolStudentDiscount | currency:"$"}}</td><td>{{invoice.credit | currency:"$"}}</td><td>{{invoice.adjustment | currency:"$"}}</td><td style="color:green">{{invoice.total | currency:"$"}}</td><td has-authority="ROLE_ADMIN"><button type="button" ui-sref="invoice.edit({id:invoice.id})" class="btn btn-primary btn-sm"><span class="glyphicon"></span> <span class="hidden-sm-down">Edit</span></button></td><td><button type="button" ui-sref="payment.new({invoiceId:invoice.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-usd"></span> <span class="hidden-sm-down">Pay</span></button></td></tr></tbody></table><div ng-switch="invoice.registrations.length > 0"><div ng-switch-when="true"><table class="jh-table table table-striped"><tbody><tr ng-repeat="registration in invoice.registrations track by registration.id"><td>{{registration.studentName}}</td><td>Class: {{registration.mlcClassName}}</td><td>Time: {{registration.classTime}}</td><td>Status: {{registration.status}}</td><td>Tuition: {{registration.tuition | currency:"$"}}</td></tr></tbody></table></div></div></div></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/invoice/registration-withdraw-dialog.html','<form name="deleteForm" ng-submit="vm.confirmWithdraw(vm.registration)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm withdraw operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to withdraw {{vm.registration.student.firstName}} {{vm.registration.student.lastName}} from {{vm.registration.mlcClass.className}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Withdraw</span></button></div></form>');
$templateCache.put('app/entities/invoice/switch-class-dialog.html','<form name="deleteForm" ng-submit="vm.confirmSwitchClass(vm.registration)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm switch class operation</h4></div><div class="modal-body" ng-if="!vm.switchClass"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to switch {{vm.registration.student.firstName}} {{vm.registration.student.lastName}} from {{vm.registration.mlcClass.className}}?</p></div><div class="modal-footer" ng-if="!vm.switchClass"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-primary"><span class="glyphicon"></span>&nbsp;<span>Confirm</span></button></div></form><div ng-if="vm.switchClass"><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-body"><div class="form-group"><label for="field_mlcClassCategory">Select a Class Category</label><select class="form-control" id="field_mlcClassCategory" name="mlcClassCategory" ng-model="vm.mlcClassCategory" ng-options="mlcClassCategory as mlcClassCategory.name for mlcClassCategory in vm.mlcClassCategories track by mlcClassCategory.id" ng-change="vm.searchClasses()" required><option value=""></option></select></div><div class="form-group"><label for="field_mlcClass">Select a Class</label><select class="form-control" id="field_mlcClass" name="mlcClass" ng-model="vm.registration.mlcClass" ng-options="mlcClass as mlcClass.className for mlcClass in vm.mlcClasses track by mlcClass.id" required><option value=""></option></select></div><div><label for="disclaimer"><div><h4><strong>Main Line Chinese Culture Center Weekend School Disclaimer and Liability Waiver</strong></h4><h6>Your agreement to participate in an MLCCC Weekend School\u2019s online class means that you fully agree to the following:</h6><h5><strong>Article I: General Release</strong></h5><h6>My child is voluntarily participating in MLCCC online and offline learning activities. I hereby waive and discharge MLCCC, its officers, teachers, volunteers, and staff from all liability as a result of my child\u2019s participation in MLCCC activities at any events hosted by or incidental to MLCCC, whether caused by negligence or otherwise, whether resulting in any physical or mental injury, illness or economic loss.</h6><h5><strong>Article II: Image/Name Usage Release</strong></h5><h6>I hereby grant MLCCC the right to use my child\u2019s name and image for promotional, press, or public relations purposes in print and/or in electronic media.<br><br>MLCCC does not use or disclose sensitive personal information, such as race, religion, or political affiliations, without your explicit consent.</h6><h5><strong>Article III: Students/Parent Online Conducts</strong></h5><h6>All students must use a photo and a complete name to identify yourself (student/parent) in the classroom or will be denied entry. Please update your ZOOM application often (check for update once a week is recommended for maximum security).<br><br>MLCCC teacher has no obligation to monitor students while off camera, it is parent\u2019s responsibility to keep their child(ren) safe while away from teacher\u2019s camera views. Make sure your children are in a quiet place during class time, and especially for young children, a place is preferred where parents can monitor the session. Students will not post messages or upload files to defame, abuse, harass, threaten, bully or otherwise violate the legal rights (such as rights of privacy and publicity) of others.<br><br>Students will not publish, post, upload, distribute or disseminate any inappropriate, profane, defamatory, infringing, obscene, indecent or unlawful topics or photos or messages on the shared screen/chat box during class time. The teacher reserves the right to remove a student from the classroom if s/he is disruptive to the learning environment or violate the above rules of conducts after proper discipline warnings.<br><br>Friendly reminder that everything within the camera field area will be visible to the teacher and all the other students in the class. All classes will be live & interactive all the time. Can turn the camera toward the wall to help maintain your privacy. I understand and agree that in the event any dispute arises between me either personally or on behalf of my child and MLCCC or other personnel, that dispute will be decided according to the laws of the state of Pennsylvania.</h6><h5><strong>Article IV: COPPA Compliance - ONLINE TECHNOLOGY CONSENT FORM</strong></h5><h6>For MLCCC to continue to provide your student with the most effective tools to enhance their learning, school Admin and teachers may use educational web-based services and applications. Many of the Terms of Service and/or Privacy Policies of these applications state that, due to Federal Law, any users under the age of 13 must obtain parental permission to use their sites and often require an email address or other personal identifiers information.<br><br>Our recently embarked web-based learning is operated not by MLCCC, but by third parties, ZOOM (\u660E\u6717\u4E2D\u6587\u5B66\u6821ZOOM\u7F51\u8BFE). In addition to Google Apps for Education (GAFE), some of the applications used are Web-based Mandarin learning, YouTube, Google Search Engine, etc.<br><br>For our students to use these programs and services, certain personally identifying information, generally the student\u2019s name and/or registered IDs must be provided to the web site operator, in this case, Admin and teachers and ZOOM. Under federal law entitled the Children\u2019s Online Privacy Protection Act (COPPA), these websites and MLCCC must provide parental notification and obtain parental consent before collecting personal information (photo/audio/video recordings) from children under the age of 13. For more information on COPPA, please visit https://www.ftc.gov/tips-advice/ The law permits schools like MLCCC to consent to the collection (photo/audio/video recording) of personal information on behalf of all of its students, thereby eliminating the need for individual parental consent given directly to the web site operator (ZOOM).<br><br>This form, when completed below, and on file with MLCCC, will constitute consent for our school to provide personal identifying information for your child consisting of first name, last name, and email address and username (where applicable).<br><br>List of Web-Based Resources or websites most commonly used by the MLCCC teachers and students: www.zoom.com, www.google.com, www.youtube.com, www.edulines.com, or other third parties online where teachers deem proper for online learning reference.<br><br>If you do not want your student to participate in these programs (primarily ZOOM online learning or \u660E\u6717\u4E2D\u6587\u5B66\u6821\u7F51\u8BFE), select OPT-OUT at the end of the registration, otherwise, you will be properly deemed to be opted-in for this disclaimer. Thank you.</h6></div><input type="checkbox" id="disclaimer" name="disclaimer" ng-model="checked" ng-click="vm.checkDisclaimer()"> <span>I accept</span></label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.checked" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form></div>');
$templateCache.put('app/entities/mlc-class/mlc-class-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.mlcClass.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Mlc Class?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/mlc-class/mlc-class-detail.html','<div><h2><span>Class</span> {{vm.mlcClass.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt style="width: 250px; margin-right: 20px"><span>Class Name</span></dt><dd><span>{{vm.mlcClass.className}}</span></dd><dt style="width: 250px; margin-right: 20px"><span>Text Book and Class Description</span></dt><dd><span>{{vm.mlcClass.textBook}}</span></dd><dt style="width: 250px; margin-right: 20px"><span>Size</span></dt><dd><span>{{vm.mlcClass.size}}</span></dd><dt style="width: 250px; margin-right: 20px"><span>Min Age</span></dt><dd><span>{{vm.mlcClass.minAge}}</span></dd><dt style="width: 250px; margin-right: 20px"><span>Tuition</span></dt><dd><span>{{vm.mlcClass.tuition}}</span></dd><!--<dt><span>Seq Number</span></dt>\n        <dd>\n            <span>{{vm.mlcClass.seqNumber}}</span>\n        </dd>--><dt style="width: 250px; margin-right: 20px"><span>Status</span></dt><dd>{{vm.mlcClass.status.status}}</dd><dt style="width: 250px; margin-right: 20px"><span>Class Time</span></dt><dd>{{vm.mlcClass.classTime.classTime}}</dd><dt style="width: 250px; margin-right: 20px"><span>Teacher</span></dt><dd><a ui-sref="teacher-detail({id:vm.mlcClass.teacher.id})">{{vm.mlcClass.teacher.firstName}} {{vm.mlcClass.teacher.lastName}}</a></dd><dt style="width: 250px; margin-right: 20px"><span>Category</span></dt><dd>{{vm.mlcClass.mlcClassCategory.name}}</dd><dt style="width: 250px; margin-right: 20px"><span>Class Room</span></dt><dd>{{vm.mlcClass.classRoom.roomNumber}}</dd><dt style="width: 250px; margin-right: 20px"><span>School Term</span></dt><dd>{{vm.mlcClass.schoolTerm.term}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="submit" ui-sref="registration.new.class({classId:vm.mlcClass.id})" class="btn btn-primary" ng-if="vm.mlcClass.status.status !== \'CLOSED\' && vm.mlcClass.status.status !== \'FULL\'"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Register</span></button> <button type="button" ui-sref="mlc-class-detail.edit({id:vm.mlcClass.id})" class="btn btn-primary" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/mlc-class/mlc-class-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMlcClassLabel">Create or edit a Class</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.mlcClass.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.mlcClass.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_className">Class Name</label><input type="text" class="form-control" name="className" id="field_className" ng-model="vm.mlcClass.className"></div><div class="form-group"><label class="control-label" for="field_textBook">Text Book</label><input type="text" class="form-control" name="textBook" id="field_textBook" ng-model="vm.mlcClass.textBook"></div><div class="form-group"><label class="control-label" for="field_size">Size</label><input type="number" class="form-control" name="size" id="field_size" ng-model="vm.mlcClass.size"></div><div class="form-group"><label class="control-label" for="field_minAge">Min Age</label><input type="number" class="form-control" name="minAge" id="field_minAge" ng-model="vm.mlcClass.minAge"></div><div class="form-group"><label class="control-label" for="field_tuition">Tuition</label><input type="number" class="form-control" name="tuition" id="field_tuition" ng-model="vm.mlcClass.tuition"></div><div class="form-group"><label class="control-label" for="field_seqNumber">Seq Number</label><input type="number" class="form-control" name="seqNumber" id="field_seqNumber" ng-model="vm.mlcClass.seqNumber"></div><div class="form-group"><label for="field_status">Status</label><select class="form-control" id="field_status" name="status" ng-model="vm.mlcClass.status" ng-options="classStatus as classStatus.status for classStatus in vm.classstatuses track by classStatus.id"><option value=""></option></select></div><div class="form-group"><label for="field_classTime">Class Time</label><select class="form-control" id="field_classTime" name="classTime" ng-model="vm.mlcClass.classTime" ng-options="classTime as classTime.classTime for classTime in vm.classtimes track by classTime.id"><option value=""></option></select></div><div class="form-group"><label for="field_teacher">Teacher</label><select class="form-control" id="field_teacher" name="teacher" ng-model="vm.mlcClass.teacher" ng-options="teacher as teacher.lastName+\',\'+teacher.firstName for teacher in vm.teachers track by teacher.id"><option value=""></option></select></div><div class="form-group"><label for="field_classCategory">Category</label><select class="form-control" id="field_classCategory" name="category" ng-model="vm.mlcClass.mlcClassCategory" ng-options="category as category.name for category in vm.categories track by category.id"><option value=""></option></select></div><div class="form-group"><label for="field_classRoom">Class Room</label><select class="form-control" id="field_classRoom" name="classRoom" ng-model="vm.mlcClass.classRoom" ng-options="classRoom as classRoom.roomNumber for classRoom in vm.classrooms track by classRoom.id"><option value=""></option></select></div><div class="form-group"><label for="field_classRoom_desc">Class Room Description</label><input type="text" class="form-control" name="classRoomDesc" id="field_classRoom_desc" ng-model="vm.mlcClass.classRoom.description" readonly="readonly"></div><div class="form-group"><label for="field_schoolTerm">School Term</label><select class="form-control" id="field_schoolTerm" name="schoolTerm" ng-model="vm.mlcClass.schoolTerm" ng-options="schoolTerm as schoolTerm.term for schoolTerm in vm.schoolterms track by schoolTerm.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/mlc-class/mlc-class-registrations.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMlcClassLabel">Registrations</h4><br><div class="row"><div class="col-sm-9"><label>{{vm.registrations[0].mlcClass.className}}</label></div><div class="col-sm-1" ng-if="vm.registrations.length > 0"><button type="submit" ng-click="vm.print(vm.registrations[0].mlcClass.className)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-print"></span> <span class="hidden-sm-down">Print</span></button></div><div has-authority="ROLE_ADMIN" class="col-sm-1" ng-if="vm.registrations.length > 0"><button type="submit" ng-click="vm.emailParents(vm.registrations[0].mlcClass.className)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-sm-down">Email</span></button></div></div></div><div class="modal-body"><div ng-if="vm.registrations.length == 0"><label>No registrations yet.</label></div><div id="print-section {{vm.registrations[0].mlcClass.className}}" ng-if="vm.registrations.length > 0"><table class="jh-table table table-striped" style="margin-bottom: 5px"><tbody><tr ng-repeat="registration in vm.registrations track by registration.id"><td><a ui-sref="registration-detail({id:registration.id})">{{registration.id}}</a></td><td>{{registration.student.firstName}} {{registration.student.lastName}}</td><td><span ng-class="{\'color-red\': registration.status === \'Error\', \'color-green\':\n                            registration.status === \'CONFIRMED\', \'color-orange\': registration.status === \'PENDING\'}">{{registration.status}}</span></td><td>{{registration.invoice.user.email}}</td><td>{{registration.student.birthYear}}/{{registration.student.birthMonth}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div></div>');
$templateCache.put('app/entities/mlc-class/mlc-classes.html','<div><h2>Classes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-6 no-padding-left" has-authority="ROLE_ADMIN"><button class="btn btn-primary" ui-sref="mlc-class.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Class</span></button></div><div class="col-xs-6 no-padding-left"><form name="searchForm" role="form" novalidate ng-submit="vm.searchClass()"><div class="form-group has-feedback"><input type="search" class="form-control" placeholder="Search Class by Name" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"> <i class="glyphicon glyphicon-search form-control-feedback"></i></div></form></div></div><div class="row"><div class="col-xs-3 no-padding-left"><!--<label for="field_status">School Term</label>--><select class="form-control" id="field_school_term" name="school_term" ng-model="vm.schoolTerm" ng-options="schoolTerm as schoolTerm.term for schoolTerm in vm.schoolTerms track by schoolTerm.id" ng-change="vm.filterClasses()"><option value="">Select School Term</option></select></div><div class="col-xs-3"><!--<label for="field_status">Class Category</label>--><select class="form-control" id="field_category" name="category" ng-model="vm.category" ng-options="category as category.name for category in vm.mlcClassCategories track by category.id" ng-change="vm.filterClasses()"><option value="">Select Category</option></select></div><div class="col-xs-3"><!--<label for="field_status">Class Category</label>--><select class="form-control" id="field_classTime" name="classTime" ng-model="vm.classTime" ng-options="classTime for classTime in vm.mlcClassTimes" ng-change="vm.filterClasses()"><option value="">Select Class Time</option></select></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Class Name</span></th><th><span>Category</span></th><th><span>Min Age</span></th><th><span>Status</span></th><th><span>Class Time</span></th><th><span>Teacher</span></th><th><span>Class Room</span></th><th><span>Tuition</span></th><th has-authority="ROLE_ADMIN"><span>Registrations</span></th><th></th></tr></thead><tbody><tr ng-repeat="mlcClass in vm.mlcClasses track by mlcClass.id"><td><a ui-sref="mlc-class-detail({id:mlcClass.id})">{{mlcClass.className}}</a></td><td>{{mlcClass.mlcClassCategory.name}}</td><td>{{mlcClass.minAge}}</td><td style="color:{{mlcClass.status.colorDisplayed}}">{{mlcClass.status.status}}</td><td>{{mlcClass.classTime.classTime}}</td><td><a ui-sref="teacher-detail({id:mlcClass.teacher.id})">{{mlcClass.teacher.firstName}} {{mlcClass.teacher.lastName}}</a></td><td>{{mlcClass.classRoom.roomNumber}}</td><td>{{mlcClass.tuition | currency:"$"}}</td><td has-authority="ROLE_ADMIN" class="text-center"><span class="color-green">{{mlcClass.confirmed}}</span> : <span class="color-orange">{{mlcClass.pending}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="mlc-class.registrations({id:mlcClass.id})" class="btn btn-primary btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-list-alt"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="mlc-class.edit({id:mlcClass.id})" class="btn btn-primary btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="mlc-class.delete({id:mlcClass.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><!--<jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>--><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/mlc-class/my-mlc-classes.html','<div><h2>My Classes</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="className"><span>Class Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mlcClassCategory"><span>Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="minAge"><span>Min Age</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status.id"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="classTime.id"><span>Class Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="classRoom.id"><span>Class Room</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="mlcClass in vm.mlcClasses track by mlcClass.id"><td><a ui-sref="mlc-class-detail({id:mlcClass.id})">{{mlcClass.className}}</a></td><td>{{mlcClass.mlcClassCategory.name}}</td><td>{{mlcClass.minAge}}</td><td ng-class="{\'color-red\': mlcClass.status.status == \'CLOSED\'}">{{mlcClass.status.status}}</td><td>{{mlcClass.classTime.classTime}}</td><td>{{mlcClass.classRoom.roomNumber}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/mlc-class-category/mlc-class-categories.html','<div><h2 data-translate="mlcccApp.mlcClassCategory.home.title">Class Categories</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="mlc-class-category.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mlcccApp.mlcClassCategory.home.createLabel">Create new Class Category</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="mlcccApp.mlcClassCategory.name">Name</span></th><th><span data-translate="mlcccApp.mlcClassCategory.type">Type</span></th><th><span data-translate="mlcccApp.mlcClassCategory.description">Description</span></th><th></th></tr></thead><tbody><tr ng-repeat="mlcClassCategory in vm.mlcClassCategories track by mlcClassCategory.id"><td><a ui-sref="mlc-class-category-detail({id:mlcClassCategory.id})">{{mlcClassCategory.id}}</a></td><td>{{mlcClassCategory.name}}</td><td>{{mlcClassCategory.type}}</td><td>{{mlcClassCategory.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="mlc-class-category-detail({id:mlcClassCategory.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="mlc-class-category.edit({id:mlcClassCategory.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="mlc-class-category.delete({id:mlcClassCategory.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/mlc-class-category/mlc-class-category-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.mlcClassCategory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mlcccApp.mlcClassCategory.delete.question" translate-values="{id: \'{{vm.mlcClassCategory.id}}\'}">Are you sure you want to delete this Class Category?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/mlc-class-category/mlc-class-category-detail.html','<div><h2><span data-translate="mlcccApp.mlcClassCategory.detail.title">Class Category</span> {{vm.mlcClassCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mlcccApp.mlcClassCategory.name">Name</span></dt><dd><span>{{vm.mlcClassCategory.name}}</span></dd><dt><span data-translate="mlcccApp.mlcClassCategory.type">Type</span></dt><dd><span>{{vm.mlcClassCategory.type}}</span></dd><dt><span data-translate="mlcccApp.mlcClassCategory.description">Description</span></dt><dd><span>{{vm.mlcClassCategory.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="mlc-class-category-detail.edit({id:vm.mlcClassCategory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/mlc-class-category/mlc-class-category-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMlcClassCategoryLabel" data-translate="mlcccApp.mlcClassCategory.home.createOrEditLabel">Create or edit a Class Category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.mlcClassCategory.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.mlcClassCategory.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mlcccApp.mlcClassCategory.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.mlcClassCategory.name"></div><div class="form-group"><label class="control-label" data-translate="mlcccApp.mlcClassCategory.type" for="field_type">Type</label><select class="form-control" id="field_type" name="type" ng-model="vm.mlcClassCategory.type" ng-options="type for type in vm.typeList"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="mlcccApp.mlcClassCategory.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.mlcClassCategory.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/news-letter/news-letter-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.newsLetter.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this News Letter?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/news-letter/news-letter-detail.html','<div><h2><span>News Letter</span> {{vm.newsLetter.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.newsLetter.name}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.newsLetter.description}}</span></dd><dt><span>File Name</span></dt><dd><span>{{vm.newsLetter.fileName}}</span></dd><dt><span>Upload Date</span></dt><dd><span>{{vm.newsLetter.uploadDate | date:\'mediumDate\'}}</span></dd><dt><span>Uploaded By</span></dt><dd><span>{{vm.newsLetter.uploadedBy}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="news-letter-detail.edit({id:vm.newsLetter.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/news-letter/news-letter-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNewsLetterLabel">Create or edit a News Letter</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.newsLetter.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.newsLetter.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.newsLetter.name"></div><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.newsLetter.description"></div><div class="form-group"><label class="control-label" for="field_fileName">File Name</label><input type="text" class="form-control" name="fileName" id="field_fileName" ng-model="vm.newsLetter.fileName"></div><div class="form-group"><label class="control-label" for="field_uploadDate">Upload Date</label><div class="input-group"><input id="field_uploadDate" type="text" class="form-control" name="uploadDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.newsLetter.uploadDate" is-open="vm.datePickerOpenStatus.uploadDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'uploadDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_uploadedBy">Uploaded By</label><input type="number" class="form-control" name="uploadedBy" id="field_uploadedBy" ng-model="vm.newsLetter.uploadedBy"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/news-letter/news-letters.html','<div><h2>News Letters</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--\n                <button class="btn btn-primary" ui-sref="news-letter.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Upload News Letter\n                    </span>\n                </button>--><div ng-switch="vm.fileSelected"><span ng-switch-when="false">Select file to upload news letter <span class="btn btn-info" ng-class="{disabled: disabled}"><input type="file" name="file" ng-model="vm.uploadedFile" ngf-select="vm.selectFile()"></span></span><div><span ng-switch-when="true" class="file-selected">{{ vm.uploadedFile.name }}</span></div><span ng-switch-when="true" class="btn btn-primary" ng-click="vm.uploadFile()">Upload</span> <span ng-switch-when="true" class="btn btn-warning" ng-click="vm.cancel()">Cancel</span></div></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Name</span></th><th><span>Description</span></th><th><span>File Name</span></th><th><span>Upload Date</span></th><th><span>Uploaded By</span></th><th></th></tr></thead><tbody><tr ng-repeat="newsLetter in vm.newsLetters track by newsLetter.id"><td><a ui-sref="news-letter-detail({id:newsLetter.id})">{{newsLetter.id}}</a></td><td>{{newsLetter.name}}</td><td>{{newsLetter.description}}</td><td>{{newsLetter.fileName}}</td><td>{{newsLetter.uploadDate | date:\'mediumDate\'}}</td><td>{{newsLetter.uploadedBy}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="news-letter-detail({id:newsLetter.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="news-letter.edit({id:newsLetter.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="news-letter.delete({id:newsLetter.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/payment/payment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.payment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Payment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/payment/payment-detail.html','<div><h2><span>Payment</span> {{vm.payment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Amount</span></dt><dd><span>{{vm.payment.amount | currency:"$"}}</span></dd><dt><span>Status</span></dt><dd><span>{{vm.payment.status}}</span></dd><dt><span>Type</span></dt><dd><span>{{vm.payment.type}}</span></dd><dt><span>Reference Id</span></dt><dd><span>{{vm.payment.referenceId}}</span></dd><dt><span>Date Paid</span></dt><dd><span>{{vm.payment.createDate | date:\'mediumDate\'}}</span></dd><dt has-authority="ROLE_ADMIN"><span>Account</span></dt><dd has-authority="ROLE_ADMIN"><a ui-sref="user-management-detail({login:vm.payment.account.login})">{{vm.payment.account.login}}</a></dd><dt><span>Invoice</span></dt><dd><a ui-sref="invoice-detail({id:vm.payment.invoice.id})">{{vm.payment.invoice.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button has-authority="ROLE_ADMIN" type="button" ui-sref="payment-detail.edit({id:vm.payment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/payment/payment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaymentLabel">Edit a Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.payment.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.payment.id" readonly="readonly"></div><div class="form-group"><label for="field_account">Account</label><input class="form-control" id="field_account" name="account" ng-model="vm.payment.account.firstName" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_type">Type</label><select type="text" class="form-control" name="type" id="field_type" ng-model="vm.payment.type"><option value="Credit Card">Credit Card</option><option value="Cash">Cash</option><option value="Check">Check</option><option value="Paypal">PayPal</option><option value="Venmo">Venmo</option><option value="Zelle">Zelle</option><!-- <option value="Paypal">Paypal</option>\n                --></select></div><div class="form-group"><label class="control-label" for="field_amount">Amount</label><input type="number" min="vm.payment.invoice.total" max="vm.payment.invoice.total" class="form-control" name="amount" id="field_amount" ng-model="vm.payment.amount" readonly="readonly"></div><div class="form-group"><label class="control-reference_id" for="field_reference_id">Reference Id</label><input type="text" class="form-control" name="reference_id" id="field_reference_id" ng-model="vm.payment.referenceId" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.payment.status" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/payment/payment-new.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaymentLabel">Create a Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.payment.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.payment.id" readonly="readonly"></div><div class="form-group"><label for="field_account">Account</label><lable>{{vm.invoice.billToUser.firstName}} {{vm.invoice.billToUser.lastName}}</lable></div><div class="form-group"><label for="field_invoiced_amount">Invoiced Amount:</label><label class="control-label" for="invoiced_amount">{{vm.invoice.total | currency:"$"}}</label></div><div class="form-group" ng-if="vm.paidAmount > 0"><label for="field_paid_amount">Paid Amount:</label><label class="control-label" for="paid_amount">{{vm.paidAmount | currency:"$"}}</label></div><div class="form-group"><label for="field_payment_amount">Total Payment:</label><label class="control-label" for="payment_amount">{{vm.paymentAmount | currency:"$"}}</label></div><div class="form-group"><label class="control-label" for="field_type">Payment Type</label><select type="text" class="form-control" name="type" id="field_type" ng-model="vm.payment.type" ng-change="vm.getPaymentMethod()" required><option value="">Select Payment Type</option><option value="Credit Card">Credit Card (Visa Only)</option><option value="Cash" has-authority="ROLE_ADMIN">Cash</option><option value="Check" has-authority="ROLE_ADMIN">Check</option><option value="Check" has-authority="ROLE_ADMIN">PayPal</option><option value="Check" has-authority="ROLE_ADMIN">Venmo</option><option value="Check" has-authority="ROLE_ADMIN">Zelle</option></select></div><div class="form-group"><label class="control-label" for="field_reference_id">Type in your comments</label><input type="text" class="form-control" name="reference_ID" id="field_reference_id" ng-model="vm.payment.referenceId"></div><!--\n        <div class="form-group">\n            <label class="control-label" for="field_amount">Amount</label>\n            <div>\n                <label class="control-label" for="field_amount">Input amount must match invoiced amount</label>\n            </div>\n            <input type="number" value="{{vm.invoice.total}}" class="form-control" name="amount" id="field_amount"\n                    ng-model="vm.payment.amount" readonly/>\n        </div>\n        --><div ng-switch="vm.payment.type"><div ng-switch-when="Credit Card"><div id="dropin-container"><div class="row"><div class="col-sm-6"><div class="form-group"><label>We only accept Visa card.</label><label>If your credit card is declined due to bad credit history, credit card processing company will charge you a service fee.</label></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><svg id="icon-visa" viewBox="0 0 40 24" width="40" height="24"><title>Visa</title><path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: #FFF"></path><path d="M0 22.033C0 23.12.892 24 1.992 24h36.016c1.1 0 1.992-.88 1.992-1.967V20.08H0v1.953z" style="fill: #F8B600"></path><path d="M0 3.92h40V1.967C40 .88 39.108 0 38.008 0H1.992C.892 0 0 .88 0 1.967V3.92zM19.596 7.885l-2.11 9.478H14.93l2.11-9.478h2.554zm10.743 6.12l1.343-3.56.773 3.56H30.34zm2.85 3.358h2.36l-2.063-9.478H31.31c-.492 0-.905.274-1.088.695l-3.832 8.783h2.682l.532-1.415h3.276l.31 1.415zm-6.667-3.094c.01-2.502-3.6-2.64-3.577-3.76.008-.338.345-.7 1.083-.793.365-.045 1.373-.08 2.517.425l.448-2.01c-.615-.214-1.405-.42-2.39-.42-2.523 0-4.3 1.288-4.313 3.133-.016 1.364 1.268 2.125 2.234 2.58.996.464 1.33.762 1.325 1.177-.006.636-.793.918-1.526.928-1.285.02-2.03-.333-2.623-.6l-.462 2.08c.598.262 1.7.49 2.84.502 2.682 0 4.437-1.273 4.445-3.243zM15.948 7.884l-4.138 9.478h-2.7L7.076 9.8c-.123-.466-.23-.637-.606-.834-.615-.32-1.63-.62-2.52-.806l.06-.275h4.345c.554 0 1.052.354 1.178.966l1.076 5.486 2.655-6.45h2.683z" style="fill: #1A1F71"></path></svg><label class="control-label" for="field_cardNumber">Card Number</label><input type="text" class="form-control" name="cardNumber" id="field_cardNumber" ng-model="vm.creditCardPayment.cardNumber" placeholder="\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022" required ng-minlength="16" ng-maxlength="19" ng-pattern="/^[0-9]+$/"><div ng-show="editForm.cardNumber.$invalid"><p class="help-block" ng-show="editForm.cardNumber.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.cardNumber.$error.minlength">This field must be at least 16 digits.</p><p class="help-block" ng-show="editForm.cardNumber.$error.maxlength">This field cannot be longer than 19 digits.</p><p class="help-block" ng-show="editForm.cardNumber.$error.pattern">Card number must be numbers.</p></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label class="control-label" for="field_cardHolderName">Card Holder Name</label><input type="text" class="form-control" name="cardHolderName" id="field_cardHolderName" ng-model="vm.creditCardPayment.cardHardHolderName"></div></div></div><div class="row"><div class="col-sm-3"><div class="form-group"><label class="control-label" for="field_cardCode">Security Code</label><input type="text" class="form-control" name="cardCode" id="field_cardCode" ng-model="vm.creditCardPayment.cardCode" placeholder="\u2022\u2022\u2022" ng-pattern="/^[0-9]+$/" ng-minlength="3" ng-maxlength="3" required><div ng-show="editForm.cardCode.$invalid"><p class="help-block" ng-show="editForm.cardCode.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.cardCode.$error.minlength">This field must be 3 digits.</p><p class="help-block" ng-show="editForm.cardCode.$error.maxlength">This field must be 3 digits.</p><p class="help-block" ng-show="editForm.cardCode.$error.pattern">Security code must be numbers.</p></div></div></div><div class="col-sm-3"><div class="form-group"><label class="control-label" for="field_expirationDate">Expiration Date (MM/YYYY)</label><input type="text" class="form-control" name="expirationDate" id="field_expirationDate" ng-model="vm.creditCardPayment.expirationDate" placeholder="MM/YYYY" required><div ng-show="editForm.expirationDate.$invalid"><p class="help-block" ng-show="editForm.expirationDate.$error.required">This field is required.</p></div></div></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button id="submit-button" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Submit</span></button></div></form>');
$templateCache.put('app/entities/payment/payment-refund.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaymentLabel">Create a Refund</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.payment.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.payment.id" readonly="readonly"></div><div class="form-group"><label for="field_account">Account</label><lable>{{vm.invoice.billToUser.firstName}} {{vm.invoice.billToUser.lastName}}</lable></div><div class="form-group"><label for="field_invoiced_amount">Calculated Refund Amount</label><label class="control-label" for="invoiced_amount">{{vm.invoice.refund | currency:"$"}}</label></div><div class="form-group"><label class="control-label" for="field_description">Actual Refund Amount</label><input type="text" class="form-control" name="refund amount" id="field_description" ng-model="vm.invoice.refund"></div><div class="form-group"><label class="control-label" for="field_type">Refund Type</label><select type="text" class="form-control" name="type" id="field_type" ng-model="vm.payment.type" ng-change="vm.getPaymentMethod()" required><option value="">Select Refund Type</option><option value="Credit Card">Refund Credit Card</option><option value="Cash" has-authority="ROLE_ADMIN">Refund Cash</option><option value="Check" has-authority="ROLE_ADMIN">Refund Check</option><option value="Credit" has-authority="ROLE_ADMIN">Refund Credit</option><option value="Paypal" has-authority="ROLE_ADMIN">Refund PayPal</option><option value="Venmo" has-authority="ROLE_ADMIN">Refund Venmo</option><option value="Zelle" has-authority="ROLE_ADMIN">Refund Zelle</option></select></div><div class="form-group"><label class="control-label" for="field_reference_id">Comments</label><input type="text" class="form-control" name="reference_ID" id="field_reference_id" placeholder="Type in refund check number, credit card transaction id or any comments." ng-model="vm.payment.referenceId" required></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button id="submit-button" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Submit</span></button></div></form>');
$templateCache.put('app/entities/payment/payments.html','<div><h2>Payments</h2><jhi-alert></jhi-alert><div class="container-fluid" has-authority="ROLE_ADMIN"><div class="row"><div class="col-xs-4 no-padding-left"><form name="searchForm" role="form" novalidate ng-submit="vm.searchPayment()"><div class="form-group has-feedback"><input type="search" class="form-control" placeholder="Search Payment by User Name" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"> <i class="glyphicon glyphicon-search form-control-feedback"></i></div></form></div></div><div class="row"><div class="col-xs-2 no-padding-left" has-authority="ROLE_ADMIN"><!--<label for="field_status">School Term</label>--><select class="form-control" id="field_school_term" name="school_term" ng-model="vm.schoolTerm" ng-options="schoolTerm as schoolTerm.term for schoolTerm in vm.schoolTerms track by schoolTerm.id" ng-change="vm.loadAll(vm.schoolTerm.id)"><option value="">Select School Term</option></select></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Amount</span></th><th><span>Status</span></th><th><span>Type</span></th><th><span>Date Paid</span></th><th has-authority="ROLE_ADMIN"><span>User Account</span></th><th><span>Invoice</span></th><th></th></tr></thead><tbody><tr ng-repeat="payment in vm.payments track by payment.id"><td><a ui-sref="payment-detail({id:payment.id})">{{payment.id}}</a></td><td>{{payment.amount | currency:"$"}}</td><td ng-class="{\'color-red\': payment.status === \'REFUND\',\'color-green\': payment.status === \'PAID\'}">{{payment.status}}</td><td>{{payment.type}}</td><td>{{payment.createDate | date:\'mediumDate\'}}</td><td has-authority="ROLE_ADMIN"><a ui-sref="user-management-detail({login:payment.account.login})">{{payment.account.firstName}} {{payment.account.lastName}}</a></td><td><a ui-sref="invoice-detail({id:payment.invoice.id})">{{payment.invoice.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="payment-detail({id:payment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="payment.edit({id:payment.id})" class="btn btn-primary btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="payment.delete({id:payment.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/phone-type/phone-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.phoneType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Phone Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/phone-type/phone-type-detail.html','<div><h2><span>Phone Type</span> {{vm.phoneType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Phone Type</span></dt><dd><span>{{vm.phoneType.phoneType}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="phone-type-detail.edit({id:vm.phoneType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/phone-type/phone-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhoneTypeLabel">Create or edit a Phone Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.phoneType.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.phoneType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_phoneType">Phone Type</label><input type="text" class="form-control" name="phoneType" id="field_phoneType" ng-model="vm.phoneType.phoneType"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/phone-type/phone-types.html','<div><h2>Phone Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="phone-type.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Phone Type</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Phone Type</span></th><th></th></tr></thead><tbody><tr ng-repeat="phoneType in vm.phoneTypes track by phoneType.id"><td><a ui-sref="phone-type-detail({id:phoneType.id})">{{phoneType.id}}</a></td><td>{{phoneType.phoneType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="phone-type-detail({id:phoneType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="phone-type.edit({id:phoneType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="phone-type.delete({id:phoneType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/registration/registration-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.registration.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this {{vm.registration.student.firstName}} {{vm.registration.student.lastName}} Registration?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/registration/registration-detail.html','<div><h2><span>Registration</span> {{vm.registration.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Student</span></dt><dd><a ui-sref="student-detail({id:vm.registration.student.id})">{{vm.registration.student.firstName+\' \'+vm.registration.student.lastName}}</a></dd><dt><span>Class</span></dt><dd><a ui-sref="mlc-class-detail({id:vm.registration.mlcClass.id})">{{vm.registration.mlcClass.className}}</a></dd><dt><spn>Class Room</spn></dt><dd>{{vm.registration.mlcClass.classRoom.roomNumber}}</dd><dt><span>Status</span></dt><dd><span ng-class="{\'color-red\': vm.registration.status === \'WITHDRAWN\',\n            \'color-green\': vm.registration.status === \'CONFIRMED\',\n            \'color-orange\': vm.registration.status === \'PENDING\'}">{{vm.registration.status}}</span></dd><dt><span>Create Date</span></dt><dd><span>{{vm.registration.createDate | date:\'mediumDate\'}}</span></dd><dt><span>Modify Date</span></dt><dd><span>{{vm.registration.modifyDate | date:\'mediumDate\'}}</span></dd></dl><button type="button" ui-sref="student-detail({id:vm.registration.student.id})" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="registration-detail.edit({id:vm.registration.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/registration/registration-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRegistrationLabel">Create or edit a Registration</h4></div><div class="modal-body" has-authority="ROLE_ADMIN" style="padding-bottom: 1px; padding-top: 15px"><form name="searchForm" role="form" novalidate ng-submit="vm.searchStudent()" has-authority="ROLE_ADMIN"><div class="form-group has-feedback"><input type="search" class="form-control" placeholder="Search Student by Name" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"> <i class="glyphicon glyphicon-search form-control-feedback"></i></div></form></div><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.registration.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.registration.id" readonly="readonly"></div><div class="form-group"><label for="field_student">Select a Student</label><select class="form-control" id="field_student" name="student" ng-model="vm.registration.student" ng-options="student as student.firstName+\' \'+student.lastName for student in vm.students track by student.id" required><option value=""></option></select></div><div class="form-group"><label for="field_mlcClassCategory">Select a Class Category</label><select class="form-control" id="field_mlcClassCategory" name="mlcClassCategory" ng-model="vm.mlcClassCategory" ng-options="mlcClassCategory as mlcClassCategory.name for mlcClassCategory in vm.mlcClassCategories track by mlcClassCategory.id" ng-change="vm.searchClasses()" required><option value=""></option></select></div><div class="form-group"><label for="field_mlcClass">Select a Class</label><select class="form-control" id="field_mlcClass" name="mlcClass" ng-model="vm.registration.mlcClass" ng-options="mlcClass as mlcClass.className for mlcClass in vm.mlcclasses track by mlcClass.id" required><option value=""></option></select></div><div><label for="disclaimer"><div><h4><strong>MAIN LINE CHINESE CULTURE CENTER, INC. (MLCCC)<br>RELEASE OF LIABILITY, WAIVER &amp; ASSUMPTION OF RISK</strong></h4><h6>(Weekend School, Summer Camp, After School &amp; All Programs)</h6><h6>In consideration for my child being permitted to participate in programs offered by Main Line Chinese Culture Center, Inc. (\u201CMLCCC\u201D), including but not limited to Weekend School, Summer Camps, After School Programs, sports programs (including badminton, basketball, dance, fencing, fitness, martial arts, pickle ball, soccer, table tennis, tennis, yoga, and other athletic activities), academic programs, cooking programs, enrichment programs, outdoor activities, facility use, travel incidental thereto, and online learning activities (collectively, the \u201CPrograms\u201D), I agree as follows:</h6><h5><strong>1. Assumption of Risk</strong></h5><h6>I acknowledge that participation in the Programs involves inherent and significant risks, including but not limited to:<ul><li>Bodily injury, permanent disability, paralysis, illness, allergic reactions, burns, cuts, contact injuries, property damage, and death</li><li>Risks associated with athletic activities, physical exertion, outdoor conditions, uneven or slippery surfaces, insects, weather exposure, food preparation, and equipment use</li><li>Exposure to communicable diseases (including but not limited to colds, influenza, COVID-19, Lyme disease, and other infectious diseases)</li></ul>I knowingly and voluntarily assume all risks, both known and unknown, even if arising from the ordinary negligence of MLCCC, Great Valley School District (GVSD), United Church of Christ at Valley Forge (UCCVF), or their respective directors, officers, employees, volunteers, instructors, coaches, agents, or facility providers (\u201CReleasees\u201D), to the fullest extent permitted under Pennsylvania law.<br><br>I agree to comply with all health, safety, and behavioral policies in effect at the time of participation.</h6><h5><strong>2. Release and Waiver of Liability</strong></h5><h6>To the fullest extent permitted under Pennsylvania law, I release, waive, discharge, and covenant not to sue the Releasees from any and all claims, demands, causes of action, damages, losses, liabilities, costs, or expenses (including attorney\u2019s fees) arising out of or related to my child\u2019s participation in the Programs, including claims based on ordinary negligence.</h6><h5><strong>3. Medical Authorization</strong></h5><h6>I authorize MLCCC to provide reasonable first aid and to obtain emergency medical treatment for my child if deemed necessary. I understand that MLCCC, GVSD, UCCVF, and other Releasees do not provide medical insurance coverage and I accept full financial responsibility for any medical expenses incurred.</h6><h5><strong>4. Indemnification</strong></h5><h6>I agree to indemnify, defend, and hold harmless the Releasees from any and all claims, damages, or expenses (including attorney\u2019s fees) arising out of or related to my child\u2019s participation in the Programs.</h6><h5><strong>5. Conduct, Enrollment &amp; Property Responsibility</strong></h5><h6>MLCCC reserves the right to dismiss any participant for unsafe, inappropriate, disruptive, or non-compliant behavior without refund.<br><br>MLCCC further reserves the right, in its sole discretion, to decline enrollment or refuse participation to any student at any time when it determines such action is in the best interest of the student, other participants, staff, or the organization.<br><br>I agree to be financially responsible for any property damage caused by my child.</h6><h5><strong>6. Media Release</strong></h5><h6>I grant permission for MLCCC to photograph, record, or film my child during participation and to use such media for lawful educational, promotional, or organizational purposes without compensation.</h6><h5><strong>7. Online Learning &amp; COPPA Consent</strong></h5><h6>MLCCC may utilize third-party educational platforms and services (including but not limited to Zoom, Google services, YouTube, and other educational websites). I understand that personal information (such as name, email address, username, and audio/video recordings) may be used for educational purposes.<br><br>In compliance with the Children\u2019s Online Privacy Protection Act (COPPA), I consent to MLCCC\u2019s authorization of the collection and use of my child\u2019s information for educational purposes through such platforms.</h6><h5><strong>8. Governing Law and Venue</strong></h5><h6>This Agreement shall be governed by and construed in accordance with the laws of the Commonwealth of Pennsylvania.<br><br>Any legal action arising out of or related to this Agreement or my child\u2019s participation in the Programs shall be brought exclusively in a court of competent jurisdiction located within the Commonwealth of Pennsylvania, and I consent to such jurisdiction and venue.</h6><h5><strong>9. Severability</strong></h5><h6>If any provision of this Agreement is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.</h6><h5><strong>10. Acknowledgment of Binding Agreement</strong></h5><h6><input type="checkbox" id="disclaimer" name="disclaimer" ng-model="checked" ng-click="vm.select()"> By checking this box, I certify that I am the parent or legal guardian of the participant, and that I have carefully read this Agreement, understand that it is a legally binding release of liability under Pennsylvania law, and will abide by it voluntarily and without inducement.</h6></div></label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.checked" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form></div>');
$templateCache.put('app/entities/registration/registrations.html','<div><h2>Registrations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><!--\n            <div class="col-xs-8 no-padding-left">\n                <button class="btn btn-primary" ui-sref="registration.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Register New Class\n                    </span>\n                </button>\n            </div>--><div class="col-sm-4"><form name="searchForm" role="form" novalidate ng-submit="vm.searchRegistration()" has-authority="ROLE_ADMIN"><div class="form-group mx-sm-3 has-feedback"><input type="search" class="form-control" placeholder="Search Registration by Student Name" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"> <i class="glyphicon glyphicon-search form-control-feedback"></i></div></form></div></div><div class="row" has-authority="ROLE_ADMIN"><div class="col-xs-2 no-padding-left"><!--<label for="field_status">School Term</label>--><select class="form-control" id="field_school_term" name="school_term" ng-model="vm.schoolTerm" ng-options="schoolTerm as schoolTerm.term for schoolTerm in vm.schoolTerms track by schoolTerm.id" ng-change="vm.loadAll(vm.schoolTerm.id)"><option value="">Select School Term</option></select></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="student.id"><span>Student</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mlcClass.id"><span>Class</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-if="vm.showClassRoom"><span>Class Room</span></th><th><span>Category</span></th><th><span>Time</span></th><th><span>Teacher</span></th><th><span>Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="registration in vm.registrations track by registration.id"><td><a ui-sref="student-detail({id:registration.student.id})">{{registration.student.firstName+\' \'+registration.student.lastName}}</a></td><td><a ui-sref="mlc-class-detail({id:registration.mlcClass.id})">{{registration.mlcClass.className}}</a></td><td ng-if="vm.showClassRoom">{{registration.mlcClass.classRoom.roomNumber}} {{registration.mlcClass.classRoom.description}}</td><td>{{registration.mlcClass.mlcClassCategory.name}}</td><td>{{registration.mlcClass.classTime.classTime}}</td><td><a ui-sref="teacher-detail({id:registration.mlcClass.teacher.id})">{{registration.mlcClass.teacher.firstName}} {{registration.mlcClass.teacher.lastName}}</a></td><td><span ng-class="{\'color-red\': registration.status === \'WITHDRAWN_NEED_REFUND\' || registration.status === \'WITHDRAWN_REFUNDED\',\n                            \'color-green\': registration.status === \'CONFIRMED\',\n                            \'color-orange\': registration.status === \'PENDING\'}">{{registration.status}}</span></td><td><span ng-switch="registration.status"><span ng-switch-when="PENDING"><button type="submit" ui-sref="registration.delete({id:registration.id})" class="btn btn-danger btn-sm" title="Cancel registration"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></span></span></td><td><button class="btn btn-info btn-sm" ui-sref="invoice-detail({id:registration.invoice.id})" title="See invoice"><span class="glyphicon glyphicon-usd"></span> <span></span></button></td><td><span ng-switch="registration.status" has-authority="ROLE_ADMIN"><span ng-switch-when="PENDING"><form name="confirmForm" role="form" novalidate ng-submit="vm.confirm(registration)"><button class="btn btn-primary btn-sm" title="Confirm registration"><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down"></span></button></form></span></span></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/registration-status/registration-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.registrationStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Registration Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/registration-status/registration-status-detail.html','<div><h2><span>Registration Status</span> {{vm.registrationStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Status</span></dt><dd><span>{{vm.registrationStatus.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="registration-status-detail.edit({id:vm.registrationStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/registration-status/registration-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRegistrationStatusLabel">Create or edit a Registration Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.registrationStatus.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.registrationStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.registrationStatus.status"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/registration-status/registration-statuses.html','<div><h2>Registration Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="registration-status.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Registration Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="registrationStatus in vm.registrationStatuses track by registrationStatus.id"><td><a ui-sref="registration-status-detail({id:registrationStatus.id})">{{registrationStatus.id}}</a></td><td>{{registrationStatus.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="registration-status-detail({id:registrationStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="registration-status.edit({id:registrationStatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="registration-status.delete({id:registrationStatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/school-district/school-district-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.schoolDistrict.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this School District?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/school-district/school-district-detail.html','<div><h2><span>School District</span> {{vm.schoolDistrict.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.schoolDistrict.name}}</span></dd><dt><span>County</span></dt><dd><span>{{vm.schoolDistrict.county}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="school-district-detail.edit({id:vm.schoolDistrict.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/school-district/school-district-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySchoolDistrictLabel">Create or edit a School District</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.schoolDistrict.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.schoolDistrict.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.schoolDistrict.name"></div><div class="form-group"><label class="control-label" for="field_county">County</label><input type="text" class="form-control" name="county" id="field_county" ng-model="vm.schoolDistrict.county"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/school-district/school-districts.html','<div><h2>School Districts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="school-district.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new School District</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Name</span></th><th><span>County</span></th><th></th></tr></thead><tbody><tr ng-repeat="schoolDistrict in vm.schoolDistricts track by schoolDistrict.id"><td><a ui-sref="school-district-detail({id:schoolDistrict.id})">{{schoolDistrict.id}}</a></td><td>{{schoolDistrict.name}}</td><td>{{schoolDistrict.county}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="school-district-detail({id:schoolDistrict.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="school-district.edit({id:schoolDistrict.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="school-district.delete({id:schoolDistrict.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/school-term/school-term-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.schoolTerm.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this School Term?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/school-term/school-term-detail.html','<div><h2><span>School Term</span> {{vm.schoolTerm.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Term</span></dt><dd><span>{{vm.schoolTerm.term}}</span></dd><dt><span>Status</span></dt><dd><span>{{vm.schoolTerm.status}}</span></dd><dt><span>Type</span></dt><dd><span>{{vm.schoolTerm.type}}</span></dd><dt><span>Register</span></dt><dd><span>{{vm.schoolTerm.register}}</span></dd><dt><span>Registration Fee</span></dt><dd><span>{{vm.schoolTerm.registrationFee | currency:"$"}}</span></dd><dt><span>Prom Date</span></dt><dd><span>{{vm.schoolTerm.promDate | date:\'mediumDate\'}}</span></dd><dt><span>Early Bird Date</span></dt><dd><span>{{vm.schoolTerm.earlyBirdDate | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="school-term-detail.edit({id:vm.schoolTerm.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/school-term/school-term-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySchoolTermLabel">Create or edit a School Term</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.schoolTerm.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.schoolTerm.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_term">Term</label><input type="text" class="form-control" name="term" id="field_term" ng-model="vm.schoolTerm.term"></div><div class="form-group"><label class="control-label" for="field_status">Status</label><select class="form-control" id="field_status" name="status" ng-model="vm.schoolTerm.status" ng-options="status for status in vm.statusList"><option value=""></option></select></div><div class="form-group"><label class="control-label" for="field_status">Type</label><select class="form-control" id="field_type" name="type" ng-model="vm.schoolTerm.type" ng-options="type for type in vm.typeList"><option value=""></option></select></div><div class="form-group"><label class="control-label" for="field_registration_fee">Registration Fee</label><input type="number" class="form-control" name="registration_fee" id="field_registration_fee" min="0.00" ng-model="vm.schoolTerm.registrationFee"><div ng-show="editForm.registration_fee.$invalid"><p class="help-block" ng-show="editForm.registration_fee.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_register">Register</label><input type="checkbox" name="register" id="field_register" ng-model="vm.schoolTerm.register"></div><div class="form-group"><label class="control-label" for="field_promDate">Prom Date</label><div class="input-group"><input id="field_promDate" type="text" class="form-control" name="promDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.schoolTerm.promDate" is-open="vm.datePickerOpenStatus.promDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'promDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_earlyBirdDate">Early Bird Date</label><div class="input-group"><input id="field_earlyBirdDate" type="text" class="form-control" name="earlyBirdDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.schoolTerm.earlyBirdDate" is-open="vm.datePickerOpenStatus.earlyBirdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'earlyBirdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/school-term/school-terms.html','<div><h2>School Terms</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="school-term.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new School Term</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Term</span></th><th><span>Status</span></th><th><span>Type</span></th><th><span>Register</span></th><th><span>Registration Fee</span></th><th><span>Prom Date</span></th><th><span>Early Bird Date</span></th><tn></tn></tr></thead><tbody><tr ng-repeat="schoolTerm in vm.schoolTerms track by schoolTerm.id"><td><a ui-sref="school-term-detail({id:schoolTerm.id})">{{schoolTerm.id}}</a></td><td>{{schoolTerm.term}}</td><td>{{schoolTerm.status}}</td><td>{{schoolTerm.type}}</td><td>{{schoolTerm.register}}</td><td>{{schoolTerm.registrationFee | currency:"$"}}</td><td>{{schoolTerm.promDate | date:\'mediumDate\'}}</td><td>{{schoolTerm.earlyBirdDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><div ng-switch="schoolTerm.status"><div ng-switch-when="PENDING"><form name="startForm" role="form" novalidate ng-submit="vm.start(schoolTerm)"><button class="btn btn-primary btn-sm"><span class="glyphicon"></span> <span class="hidden-sm-down">Start</span></button></form></div><div ng-switch-when="ACTIVE"><form name="finishForm" role="form" novalidate ng-submit="vm.finish(schoolTerm)"><button class="btn btn-danger btn-sm"><span class="glyphicon"></span> <span class="hidden-sm-down">Finish</span></button></form></div></div><button type="submit" ui-sref="school-term.edit({id:schoolTerm.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="school-term.delete({id:schoolTerm.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/student/student-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.student.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Student?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/student/student-detail.html','<div><h2><span>Student</span> {{vm.student.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>First Name</span></dt><dd><span>{{vm.student.firstName}}</span></dd><dt><span>Last Name</span></dt><dd><span>{{vm.student.lastName}}</span></dd><dt><span>Gender</span></dt><dd><span>{{vm.student.gender}}</span></dd><dt><span>Birth Month</span></dt><dd><span>{{vm.student.birthMonth}}</span></dd><dt><span>Birth Year</span></dt><dd><span>{{vm.student.birthYear}}</span></dd><dt><span>Notes</span></dt><dd><span>{{vm.student.notes}}</span></dd><div has-authority="ROLE_ADMIN"><dt><span>Associated Users</span></dt><dd><!--<a ui-sref="user-management-detail({login:vm.student.associatedAccounts[0].login})">\n                    {{vm.student.associatedAccounts[0].login + \' \' + vm.student.associatedAccounts[0].lastName}} </a>--><div ng-switch="vm.student.associatedAccounts.length > 0"><div ng-switch-when="true"><table class="jh-table table table-striped"><thead><tr><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Login</span></th><th><span>Email</span></th><th><span>Phone</span></th><th><span>Primary Contact</span></th></tr></thead><tbody><tr ng-repeat="user in vm.student.associatedAccounts track by user.id"><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.login}}</td><td>{{user.email}}</td><td>{{user.phone}}</td><td><div ng-if="user.primaryContact"><span class="glyphicon glyphicon-check"></span></div></td></tr></tbody></table></div></div></dd></div><div has-authority="ROLE_ADMIN" ng-switch="vm.student.registrations.length > 0"><div ng-switch-when="true"><dt><span>Registrations</span></dt><dd><table class="jh-table table table-striped"><tbody><tr ng-repeat="registration in vm.student.registrations track by registration.id"><td><a ui-sref="registration-detail({id:registration.id})">{{registration.id}}</a></td><td>{{registration.mlcClassName}}</td><td>Teacher: {{registration.teacher}}</td><td><span ng-class="{\'color-red\': registration.status === \'Error\',\n                                \'color-green\': registration.status === \'CONFIRMED\',\n                                \'color-orange\': registration.status === \'PENDING\'}">{{registration.status}}</span></td><td>Tuition: {{registration.tuition | currency:"$"}}</td></tr></tbody></table></dd></div></div></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="student-detail.edit({id:vm.student.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/student/student-dialog-users.html','<div><h2>Students</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="student.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Student</span></button></div></div><div has-authority="ROLE_ADMIN"><form name="searchForm" role="form" novalidate ng-submit="vm.searchUser()"><div><span class="glyphicon glyphicon-search"></span> <input type="search" class="form-control" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"><label class="control-label" for="searchTerm">Search User</label></div></form></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName"><span>First Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Last Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gender"><span>Gender</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthMonth"><span>Birth Month</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthYear"><span>Birth Year</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="account.id"><span>Account</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="student in vm.students track by student.id"><td><a ui-sref="student-detail({id:student.id})">{{student.id}}</a></td><td>{{student.firstName}}</td><td>{{student.lastName}}</td><td>{{student.gender}}</td><td>{{student.birthMonth}}</td><td>{{student.birthYear}}</td><!--<td>\n                    <a ui-sref="mlc-account-detail({id:student.associatedAccounts[0].id})">{{student.associatedAccounts[0].id}}</a>\n                </td>--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="student-detail({id:student.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="student.edit({id:student.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="student.delete({id:student.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/student/student-dialog.html','<!--<form name="editForm" role="form" novalidate>--><div class="modal-header" xmlns="http://www.w3.org/1999/html"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStudentLabel">Create or edit a Student</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.student.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.student.id" readonly="readonly"></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.student.firstName"></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.student.lastName"></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="field_gender">Gender</label><select type="text" class="form-control" name="gender" id="field_gender" ng-model="vm.student.gender"><option value="M">Male</option><option value="F">Female</option><option value="U">Unspecified</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_birthMonth">Birth Month</label><select type="text" class="form-control" name="birthMonth" id="field_birthMonth" ng-model="vm.student.birthMonth"><option value="">Select a month</option><option value="1">January</option><option value="2">February</option><option value="3">March</option><option value="4">April</option><option value="5">May</option><option value="6">June</option><option value="7">July</option><option value="8">August</option><option value="9">September</option><option value="10">October</option><option value="11">November</option><option value="12">December</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_birthYear">Birth Year</label><!--<input type="text" class="form-control" name="birthYear" id="field_birthYear"\n                        ng-model="vm.student.birthYear"\n                        />--><select type="text" class="form-control" name="birthYear" id="field_birthYear" ng-model="vm.student.birthYear"><option value="">Select a year</option><option value="2024">2024</option><option value="2023">2023</option><option value="2022">2022</option><option value="2021">2021</option><option value="2020">2020</option><option value="2019">2019</option><option value="2018">2018</option><option value="2017">2017</option><option value="2016">2016</option><option value="2015">2015</option><option value="2014">2014</option><option value="2013">2013</option><option value="2012">2012</option><option value="2011">2011</option><option value="2010">2010</option><option value="2009">2009</option><option value="2008">2008</option><option value="2007">2007</option><option value="2006">2006</option><option value="2005">2005</option><option value="2004">2004</option><option value="2003">2003</option><option value="2002">2002</option><option value="2001">2001</option><option value="2000">2000</option><option value="1999">1999</option><option value="1998">1998</option><option value="1997">1997</option><option value="1996">1996</option><option value="1995">1995</option><option value="1994">1994</option><option value="1993">1993</option><option value="1992">1992</option><option value="1991">1991</option><option value="1990">1990</option><option value="1989">1989</option><option value="1988">1988</option><option value="1987">1987</option><option value="1986">1986</option><option value="1985">1985</option><option value="1984">1984</option><option value="1983">1983</option><option value="1982">1982</option><option value="1981">1981</option><option value="1980">1980</option><option value="1979">1979</option><option value="1978">1978</option><option value="1977">1977</option><option value="1976">1976</option><option value="1975">1975</option><option value="1974">1974</option><option value="1973">1973</option><option value="1972">1972</option><option value="1971">1971</option><option value="1970">1970</option><option value="1969">1969</option><option value="1968">1968</option><option value="1967">1967</option><option value="1966">1966</option><option value="1965">1965</option><option value="1964">1964</option><option value="1963">1963</option><option value="1962">1962</option><option value="1961">1961</option><option value="1960">1960</option><option value="1959">1959</option><option value="1958">1958</option><option value="1957">1957</option><option value="1956">1956</option><option value="1955">1955</option><option value="1954">1954</option><option value="1953">1953</option><option value="1952">1952</option><option value="1951">1951</option><option value="1950">1950</option><option value="1949">1949</option><option value="1948">1948</option><option value="1947">1947</option><option value="1946">1946</option><option value="1945">1945</option><option value="1944">1944</option><option value="1943">1943</option><option value="1942">1942</option><option value="1941">1941</option><option value="1940">1940</option><option value="1939">1939</option><option value="1938">1938</option><option value="1937">1937</option><option value="1936">1936</option><option value="1935">1935</option><option value="1934">1934</option><option value="1933">1933</option><option value="1932">1932</option><option value="1931">1931</option><option value="1930">1930</option></select></div></div><div class="col-md-12"><div class="form-group"><label class="control-label" for="field_notes">Notes</label><textarea placeholder="Fill in more information about student such as Mandarin ability, allergies, special medical conditions, second parent email." rows="3" class="form-control" name="notes" id="field_notes" ng-model="vm.student.notes"></textarea></div></div><!--\n        <div class="form-group">\n            <label for="field_account">Accounts</label>\n            <select class="form-control" id="field_account" name="accounts" ng-model="vm.student.associatedAccounts"\n                    ng-options="user.firstName+\' \'+ user.lastName for user in vm.availableUsers">\n            </select>\n        </div>--><br><br><div has-authority="ROLE_ADMIN"><div class="btn-group"><button type="button" ng-click="vm.showSearchField(vm.student.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm"></span><span>Add Associated Account</span></button></div><div ng-switch="vm.showSearch"><form name="searchForm" role="form" novalidate ng-submit="vm.searchUser()"><div ng-switch-when="true"><span class="glyphicon glyphicon-search"></span> <input type="search" class="form-control" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"><label class="control-label" for="searchTerm">Search User</label></div></form><div><table class="jh-table table table-striped"><thead><tr><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Login</span></th></tr></thead><tbody><tr ng-repeat="user in vm.availableUsers track by user.id"><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.login}}</td><td><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.addAccountToStudent(user)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm"></span><span>Add</span></button></div></td></tr></tbody></table></div></div></div><div ng-switch="vm.student.associatedAccounts.length > 0"><div ng-switch-when="true"><h4>Associated Accounts</h4><table class="jh-table table table-striped"><thead><tr><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Login</span></th><th><span>Primary Contact</span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.student.associatedAccounts track by user.id"><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.login}}</td><td><div ng-if="user.primaryContact"><span class="glyphicon glyphicon-check"></span></div></td><td><div ng-if="!user.primaryContact" class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.removeAssociatedAccount(user)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span><span>Remove Account</span></button></div></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div><!--</form>-->');
$templateCache.put('app/entities/student/students-in-class.html','<div><h2 has-authority="ROLE_TEACHER">Students In My Class</h2><jhi-alert></jhi-alert><div class="table-responsive"><div><div ng-repeat="mlcClass in vm.mlcClasses track by mlcClass.name"><div class="row"><div class="col-sm-10"><h3><span>{{mlcClass.name}}</span></h3></div><div class="col-sm-1"><h3><button type="submit" ng-click="vm.print(mlcClass.name)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-print"></span> <span class="hidden-sm-down">Print</span></button></h3></div><div class="col-sm-1"><h3><button type="submit" ng-click="vm.emailParents(mlcClass.name)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-sm-down">Email</span></button></h3></div></div><div id="print-section {{mlcClass.name}}"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Name</span></th><th><span>Gender</span></th><th><span>Birth Year/Month</span></th><th><span>Parent 1</span></th><th><span>Parent 2</span></th><th><span>Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="student in mlcClass.students track by student.id"><td><a ui-sref="student-detail({id:student.id})">{{student.lastName}}, {{student.firstName}}</a></td><td>{{student.gender}}</td><td>{{student.birthYear}}/{{student.birthMonth}}</td><td>{{student.parent1}}</td><td>{{student.parent2}}</td><td><span ng-class="{\'color-green\': student.status === \'CONFIRMED\', \'color-orange\': student.status === \'PENDING\'}">{{student.status}}</span></td></tr></tbody></table></div></div></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/student/students.html','<div><h2 has-authority="ROLE_ADMIN">Students</h2><jhi-alert></jhi-alert><div class="container no-padding"><div class="row"><div class="col-sm-6"><button class="btn btn-primary mb-2" ui-sref="student.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Student</span></button></div><div class="col-sm-4"><form name="searchForm" role="form" novalidate ng-submit="vm.searchStudent()" has-authority="ROLE_ADMIN"><div class="form-group mx-sm-3 has-feedback"><input type="search" class="form-control" placeholder="Search Student by Name" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"> <i class="glyphicon glyphicon-search form-control-feedback"></i></div></form></div></div></div><br><div class="table-responsive"><div ng-switch="vm.showRegistrations"><div ng-switch-when="true"><div ng-repeat="student in vm.students track by student.id"><div><a ui-sref="student-detail({id:student.id})"><h3><span>{{student.firstName}}</span> <span>{{student.lastName}}</span></h3></a><div class="row"><!--\n                            <div class="col-sm-2">\n                                <button type="button"\n                                        ui-sref="registration.new.student({studentId:student.id})"\n                                        class="btn btn-primary btn-sm">\n                                    <span class="glyphicon glyphicon-plus"></span>\n                                    <span class="hidden-sm-down">Register A Class</span>\n                                </button>\n                            </div> --><div class="col-sm-2" ng-if="student.registrations.length == 0"><button type="button" ui-sref="student.delete({id:student.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-trash"></span> <span class="hidden-sm-down">Delete Student</span></button></div></div></div><div ng-switch="student.registrations.length > 0"><div ng-switch-when="true"><h4>Registrations</h4><table class="jh-table table table-striped"><tbody><tr ng-repeat="registration in student.registrations track by registration.id"><td><a ui-sref="registration-detail({id:registration.id})">{{registration.id}}</a></td><td>{{registration.mlcClassName}}</td><td>Teacher: {{registration.teacher}}</td><td><span ng-class="{\'color-red\': registration.status === \'Error\', \'color-green\': registration.status === \'CONFIRMED\', \'color-orange\': registration.status === \'PENDING\'}">{{registration.status}}</span></td><td>Tuition: {{registration.tuition | currency:"$"}}</td><td ng-switch="registration.status"><button ng-switch-when="PENDING" type="button" ui-sref="registration.delete({id:registration.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down">Cancel</span></button></td></tr></tbody></table></div></div></div></div><div ng-switch-when="false"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="lastName"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gender"><span>Gender</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthYear"><span>Birth Month/Year</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Notes</span> <span class="glyphicon"></span></th><th></th></tr></thead><tbody><tr ng-repeat="student in vm.students track by student.id"><td><a ui-sref="student-detail({id:student.id})">{{student.lastName}}, {{student.firstName}}</a></td><td>{{student.gender}}</td><td>{{student.birthMonth}}/{{student.birthYear}}</td><td>{{student.notes}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="student-detail({id:student.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="student.edit({id:student.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="student.delete({id:student.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/teacher/my-teachers.html','<div><h2>My Teachers</h2><jhi-alert></jhi-alert><div><div ng-repeat="student in vm.students track by student.id"><div><h3><span>{{student.firstName}} {{student.firstName}}</span></h3></div><div><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="className"><span>Class Name</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>First Name</span></th><th><span>Last Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="mlcClass in student.mlcClass track by mlcClass.id"><td><a ui-sref="mlcClass-detail({id:mlcClass.id})">{{mlcClass.className}}</a></td><td><a ui-sref="teacher-detail({id:mlcClass.teacher.id})">{{mlcClass.teacher.firstName}}</a></td><td><a ui-sref="teacher-detail({id:mlcClass.teacher.id})">{{mlcClass.teacher.lastName}}</a></td></tr></tbody></table></div></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/teacher/teacher-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.teacher.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Teacher?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/teacher/teacher-detail.html','<div><h2><span>Teacher</span> {{vm.teacher.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>First Name</span></dt><dd><span>{{vm.teacher.firstName}}</span></dd><dt><span>Last Name</span></dt><dd><span>{{vm.teacher.lastName}}</span></dd><dt><span>Email</span></dt><dd>{{vm.teacher.account.email}}</dd></dl><br><div ng-switch="vm.teacher.mlcClasses.length > 0"><div ng-switch-when="true"><div class="row"><div class="col-sm-1"><h4>Classes</h4></div><div class="col-sm-2"><button type="button" ui-sref="teacher-detail.edit({id:vm.teacher.id})" class="btn btn-primary btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Add</span></button></div></div><table class="jh-table table table-striped"><tbody><tr ng-repeat="mlcClass in vm.teacher.mlcClasses track by mlcClass.id"><td><a ui-sref="mlc-class-detail({id:mlcClass.id})">{{mlcClass.className}}</a></td><td>Category: {{mlcClass.mlcClassCategory}}</td><td ng-class="{\'color-red\': mlcClass.status == \'CLOSED\'}">Status: {{mlcClass.status}}</td><td>Tuition: {{mlcClass.tuition}}</td><td>Time: {{mlcClass.classTime}}</td><td has-authority="ROLE_USER"><div ng-if="mlcClass.status == \'OPEN\'"><button type="submit" ui-sref="registration.new.class({classId:mlcClass.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Register</span></button></div></td><!--\n\n                    <td has-authority="ROLE_ADMIN">\n                        <button type="submit"\n                                ui-sref="vm.removeClass()"\n                                class="btn btn-danger btn-sm">\n                            <span class="glyphicon glyphicon-remove-circle"></span>\n                            <span class="hidden-sm-down">Remove</span>\n                        </button>\n                    </td>\n                    --></tr></tbody></table></div></div><button type="submit" ui-sref="teacher()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="teacher-detail.edit({id:vm.teacher.id})" class="btn btn-primary" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/teacher/teacher-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTeacherLabel">Create or edit a Teacher</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.teacher.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.teacher.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.teacher.firstName" required="true"></div><div class="form-group"><label class="control-label" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.teacher.lastName" required="true"></div><div class="form-group" has-authority="ROLE_ADMIN"><label class="control-label" for="field_hireDate">Hire Date</label><div class="input-group"><input id="field_hireDate" type="text" class="form-control" name="hireDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.teacher.hireDate" is-open="vm.datePickerOpenStatus.hireDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'hireDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group" has-authority="ROLE_ADMIN"><label class="control-label" for="field_payRate">Pay Rate</label><input type="number" class="form-control" name="payRate" id="field_payRate" ng-model="vm.teacher.payRate"></div><div class="form-group" has-authority="ROLE_ADMIN"><label class="control-label" for="field_status">Status</label><select type="text" class="form-control" name="status" id="field_status" ng-model="vm.teacher.status"><option value="Active">Active</option><option value="Inactive">Inactive</option></select></div><div class="form-group"><label for="field_account">User Account</label><select class="form-control" id="field_account" name="account" ng-model="vm.teacher.account" ng-options="mlcAccount as mlcAccount.firstName+ \' \'+mlcAccount.lastName + \' \'+ mlcAccount.login for mlcAccount in vm.accounts | orderBy:\'id\' track by mlcAccount.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form><form name="searchForm" role="form" novalidate ng-submit="vm.searchUser()" has-authority="ROLE_ADMIN"><div class="form-group has-feedback"><input type="search" class="form-control" placeholder="User Name" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"> <i class="glyphicon glyphicon-user form-control-feedback"></i></div></form>');
$templateCache.put('app/entities/teacher/teachers.html','<div><h2>Teachers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-6 no-padding-left" has-authority="ROLE_ADMIN"><button class="btn btn-primary" ui-sref="teacher.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Teacher</span></button></div><div class="col-sm-4"><form name="searchForm" role="form" novalidate ng-submit="vm.searchTeacher()"><div class="form-group has-feedback"><input type="search" class="form-control" placeholder="Search Teacher by Name" name="searchTerm" id="searchTerm" ng-model="vm.searchTerm"> <i class="glyphicon glyphicon-search form-control-feedback"></i></div></form></div><div class="col-sm-2" has-authority="ROLE_ADMIN"><button class="btn btn-primary" ui-sref="teacher.allemail"><span class="glyphicon glyphicon-envelope"></span> <span>Send Email</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="firstName"><span>First Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Last Name</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Class Categories</span></th><th><span>Classes</span></th><th></th></tr></thead><tbody><tr ng-repeat="teacher in vm.teachers track by teacher.id"><td><a ui-sref="teacher-detail({id:teacher.id})">{{teacher.firstName}}</a></td><td><a ui-sref="teacher-detail({id:teacher.id})">{{teacher.lastName}}</a></td><td>{{teacher.classCategories}}</td><td>{{teacher.classes}}</td><td class="text-right" has-authority="ROLE_ADMIN"><div class="btn-group flex-btn-group-container"><div ng-if="teacher.account"><button type="submit" ui-sref="teacher.email({id:teacher.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-sm-down"></span></button></div><button type="submit" ui-sref="teacher.edit({id:teacher.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="teacher.delete({id:teacher.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/user-agreement/user-agreement-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.userAgreement.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User Agreement?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/user-agreement/user-agreement-detail.html','<div><h2><span>User Agreement</span> {{vm.userAgreement.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.userAgreement.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="user-agreement-detail.edit({id:vm.userAgreement.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/user-agreement/user-agreement-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserAgreementLabel">Create or edit a User Agreement</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.userAgreement.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.userAgreement.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.userAgreement.name"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/user-agreement/user-agreements.html','<div><h2>User Agreements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="user-agreement.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new User Agreement</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="userAgreement in vm.userAgreements track by userAgreement.id"><td><a ui-sref="user-agreement-detail({id:userAgreement.id})">{{userAgreement.id}}</a></td><td>{{userAgreement.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-agreement-detail({id:userAgreement.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="user-agreement.edit({id:userAgreement.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="user-agreement.delete({id:userAgreement.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()" style="height: 0px;padding-bottom: 5px;padding-top: 5px"><ul class="nav navbar-nav navbar-left"><a class="navbar-brand logo" href="https://mlccc.herokuapp.com" ng-click="vm.collapseNavbar()"><span><img class="logo-img" src="content/images/Logo.jpg"></span></a></ul><ul class="nav navbar-nav navbar-right"><!--\n                <li ui-sref-active="active">\n                    <a ui-sref="home" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-home"></span>\n                        <span class="hidden-sm">Home</span>\n                    </a>\n                </li>--><li ng-switch-when="true" uib-dropdown class="dropdown pointer" ng-class="{active: vm.$state.includes(\'student\') || vm.$state.includes(\'student-in-class\')}"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="student-entity-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Students </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="student" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>My Students</span></a></li><li ui-sref-active="active" has-authority="ROLE_TEACHER"><a ui-sref="student-in-class" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>Students in My Class</span></a></li></ul></li><li ng-switch-when="true" ng-class="{active: vm.$state.includes(\'registration\')}"><a ui-sref="registration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span> <span class="hidden-sm">Registrations</span></a></li><li ng-switch-when="true" ng-class="{active: vm.$state.includes(\'teacher\')}"><a ui-sref="teacher" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Teachers</span></a></li><li ng-switch-when="true" uib-dropdown class="dropdown pointer" ng-class="{active: vm.$state.includes(\'mlc-class\') || vm.$state.includes(\'my-mlc-class\')}"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="class-entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm">Classes </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="mlc-class" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-list"></span>&nbsp; <span>All Classes</span></a></li><li ui-sref-active="active" has-authority="ROLE_TEACHER"><a ui-sref="my-mlc-class" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-list"></span>&nbsp; <span>My Classes</span></a></li></ul></li><li ng-switch-when="true" ui-sref-active="active" ng-class="{active: vm.$state.includes(\'invoice\')}"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-credit-card"></span>&nbsp; <span>Invoices</span></a></li><li ng-switch-when="true" ui-sref-active="active" ng-class="{active: vm.$state.includes(\'payment\')}"><a ui-sref="payment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-usd"></span>&nbsp; <span>Payments</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!--<li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer">--><li ng-switch-when="true" uib-dropdown class="dropdown pointer" ng-class="{active: vm.$state.includes(\'mlc-class-category\',\'class-time\',\'class-status\',\'class-room\')}"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-authority="ROLE_ADMIN"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm">Management </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="mlc-class-category" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th"></span>&nbsp; <span>Class Category</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="class-time" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-time"></span>&nbsp; <span>Class Time</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="class-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-adjust"></span>&nbsp; <span>Class Status</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="class-room" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-map-marker"></span>&nbsp; <span>Class Room</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="school-term" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-calendar"></span>&nbsp; <span>School Term</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="school-district" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-map-marker"></span>&nbsp; <span>School District</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="registration-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-adjust"></span>&nbsp; <span>Registration Status</span></a></li><!--\n                        <li ui-sref-active="active">\n                                <a ui-sref="payment" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-credit-card"></span>&nbsp;\n                                    <span>Payment Information</span>\n                                </a>\n                        </li>\n                        --><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="discount-code" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-usd"></span>&nbsp; <span>Discount Code</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="discount" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-usd"></span>&nbsp; <span>Discount</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="news-letter" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>News Letter</span></a></li><hr has-authority="ROLE_SUPER_ADMIN"><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>User management</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPER_ADMIN"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span>Metrics</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPER_ADMIN"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span>Health</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPER_ADMIN"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Configuration</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPER_ADMIN"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span>Audits</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPER_ADMIN"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span>Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active" has-authority="ROLE_SUPER_ADMIN"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>API</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!--\n                <li ng-class="{active: vm.$state.includes(\'admin\')}"  ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-tower"></span>\n                            <span class="hidden-sm">Administration</span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active">\n                            <a ui-sref="user-management" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-user"></span>&nbsp;\n                                <span>User management</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-dashboard"></span>&nbsp;\n                                <span>Metrics</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-health" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-heart"></span>&nbsp;\n                                <span>Health</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-list-alt"></span>&nbsp;\n                                <span>Configuration</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="audits" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-bell"></span>&nbsp;\n                                <span>Audits</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="logs" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-tasks"></span>&nbsp;\n                                <span>Logs</span>\n                            </a>\n                        </li>\n                        <li ng-show="vm.swaggerEnabled" ui-sref-active="active">\n                            <a ui-sref="docs" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-book"></span>&nbsp;\n                                <span>API</span>\n                            </a>\n                        </li>\n\n                    </ul>\n                </li> --><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span>Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span>Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span>Register</span></a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p>Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');}]);})();